
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dAbO5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $g5gZt = parcelRequire("g5gZt");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");




const $8d1094a96cdc1d7a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    addItemText: {
        id: "company-hub.company-hub-common.config-panel.add-card-cta",
        defaultMessage: "Add card"
    }
});


const $85951a917e87bf4a$var$addButtonContentWrapperStyles = (0, $ecnYn.xcss)({
    height: '20px'
});
const $85951a917e87bf4a$export$6cb731ac7be1981a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { actionSubjectIdSuffix: actionSubjectIdSuffix, analyticsSource: analyticsSource, addItem: addItem, onAddItemKeyPress: onAddItemKeyPress, label: label } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== actionSubjectIdSuffix || $[1] !== addItem || $[2] !== analyticsSource || $[3] !== createAnalyticsEvent) {
        t1 = ()=>{
            addItem();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: `add${actionSubjectIdSuffix}`,
                    source: analyticsSource
                }
            }).fire();
        };
        $[0] = actionSubjectIdSuffix;
        $[1] = addItem;
        $[2] = analyticsSource;
        $[3] = createAnalyticsEvent;
        $[4] = t1;
    } else t1 = $[4];
    const onAddItemButtonClick = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            color: "currentColor",
            label: ""
        });
        $[5] = t2;
    } else t2 = $[5];
    const t3 = label || (0, $8d1094a96cdc1d7a$export$defe85febe8b728c).addItemText;
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.050",
            xcss: $85951a917e87bf4a$var$addButtonContentWrapperStyles
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), t3));
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== onAddItemButtonClick || $[9] !== onAddItemKeyPress || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: onAddItemButtonClick,
            onKeyPress: onAddItemKeyPress
        }, t4);
        $[8] = onAddItemButtonClick;
        $[9] = onAddItemKeyPress;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ actionSubjectIdSuffix: actionSubjectIdSuffix, analyticsSource: analyticsSource, addItem: addItem, onAddItemKeyPress: onAddItemKeyPress, label: label })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onAddItemButtonClick = ()=>{
        addItem();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `add${actionSubjectIdSuffix}`,
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onAddItemButtonClick,
        onKeyPress: onAddItemKeyPress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.050",
        xcss: $85951a917e87bf4a$var$addButtonContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        color: "currentColor",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label || (0, $8d1094a96cdc1d7a$export$defe85febe8b728c).addItemText)));
};
module.exports["AddItemButton"] = $85951a917e87bf4a$export$6cb731ac7be1981a;

});

parcelRegister("hECbK", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $kZ5GD = parcelRequire("kZ5GD");








var $gMc0m = parcelRequire("gMc0m");





var $4JDbp = parcelRequire("4JDbp");


var $4cOi8 = parcelRequire("4cOi8");

const $2ec1d6fee0534a73$var$CONTENT_WIDTH = 800;
const $2ec1d6fee0534a73$var$styles = {
    default: "_1bsb1c3h _4t3iv7uf",
    compact: "_4t3i16xz",
    containerStyles: "_1reo15vq _18m915vq _2rko1mok _1bsb1osq _kqswh2mm"
};
const $2ec1d6fee0534a73$export$73bba9cb9f06b02a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { layout: t1, previewSizeVariant: t2, PreviewComponent: PreviewComponent } = t0;
    const layout = t1 === undefined ? (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT : t1;
    const previewSizeVariant = t2 === undefined ? "default" : t2;
    const [containerWidth, setContainerWidth] = (0, $42omo.useState)(0);
    const calculatedScale = containerWidth ? containerWidth / $2ec1d6fee0534a73$var$CONTENT_WIDTH : 0;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            $2ec1d6fee0534a73$var$styles.containerStyles
        ]);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.default), {
            setWidth: setContainerWidth
        });
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    const t5 = `scale(${calculatedScale})`;
    let t6;
    if ($[2] !== t5) {
        t6 = {
            transform: t5,
            transformOrigin: "top left"
        };
        $[2] = t5;
        $[3] = t6;
    } else t6 = $[3];
    const t7 = $2ec1d6fee0534a73$var$styles[previewSizeVariant];
    let t8;
    if ($[4] !== t7) {
        t8 = (0, $gMc0m.default)([
            $2ec1d6fee0534a73$var$styles.default,
            t7
        ]);
        $[4] = t7;
        $[5] = t8;
    } else t8 = $[5];
    let t9;
    if ($[6] !== PreviewComponent || $[7] !== layout) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PreviewComponent, {
            height: (0, $4cOi8.Height).MEDIUM,
            layout: layout
        });
        $[6] = PreviewComponent;
        $[7] = layout;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== t8 || $[10] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t8
        }, t9);
        $[9] = t8;
        $[10] = t9;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== t10 || $[13] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t3
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: t6
        }, t10));
        $[12] = t10;
        $[13] = t6;
        $[14] = t11;
    } else t11 = $[14];
    return t11;
} : ({ layout: layout = (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT, previewSizeVariant: previewSizeVariant = 'default', PreviewComponent: PreviewComponent })=>{
    const [containerWidth, setContainerWidth] = (0, $42omo.useState)(0);
    const calculatedScale = containerWidth ? containerWidth / $2ec1d6fee0534a73$var$CONTENT_WIDTH : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $2ec1d6fee0534a73$var$styles.containerStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.default), {
        setWidth: setContainerWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            transform: `scale(${calculatedScale})`,
            transformOrigin: 'top left'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $2ec1d6fee0534a73$var$styles.default,
            $2ec1d6fee0534a73$var$styles[previewSizeVariant]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PreviewComponent, {
        height: (0, $4cOi8.Height).MEDIUM,
        layout: layout
    }))));
};


const $e1e57cfddd500cee$var$headingSizeMap = {
    default: 'xsmall',
    compact: 'xxsmall'
};
/**
 * Mapping layout variants to classnames
 */ const $e1e57cfddd500cee$var$variantMap = {
    default: 'defaultLayoutOption',
    compact: 'compactLayoutOption'
};
const $e1e57cfddd500cee$var$layoutOptionStyles = {
    defaultLayoutOption: "_2rko12b0 _1h6d1l7x _189ee4h9 _1dqonqa1 _bfhksm61 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _d0altlke",
    compactLayoutOption: "_ca0qutpp _n3tdutpp _19bv12x7 _u5f312x7",
    layoutOptionSelected: "_1h6dq98m",
    radioButtonWrapper: "_18u0r5cr _4cvr1h6o",
    layoutLabelHeadingWrapper: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _18u01i6y _19pkv77o"
};
const $e1e57cfddd500cee$export$f4ca495c8982b022 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { updateLayout: updateLayout, source: source, layoutOptions: layoutOptions, variant: t1, PreviewComponent: PreviewComponent, previewImage: previewImage, currentLayoutSelection: currentLayoutSelection } = t0;
    const variant = t1 === undefined ? "default" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t2 = (value)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "selected",
                    actionSubject: "layout",
                    actionSubjectId: "configPanelLayoutOptions",
                    source: source,
                    attributes: {
                        value: value
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t2;
    } else t2 = $[2];
    const handleClickAnalytics = t2;
    let t3;
    if ($[3] !== handleClickAnalytics || $[4] !== layoutOptions || $[5] !== updateLayout) {
        t3 = (event)=>{
            const selectedOption = layoutOptions.find((option)=>option.value === event.currentTarget.value);
            if (selectedOption) {
                handleClickAnalytics(selectedOption.value);
                updateLayout(selectedOption.value);
            }
        };
        $[3] = handleClickAnalytics;
        $[4] = layoutOptions;
        $[5] = updateLayout;
        $[6] = t3;
    } else t3 = $[6];
    const handleOnChange = t3;
    let t4;
    if ($[7] !== handleClickAnalytics || $[8] !== layoutOptions || $[9] !== updateLayout) {
        t4 = (newLayoutValue)=>{
            const selectedValue = layoutOptions.find((t5)=>{
                const { value: value_0 } = t5;
                return value_0 === newLayoutValue;
            })?.value;
            handleClickAnalytics(selectedValue);
            updateLayout(newLayoutValue);
        };
        $[7] = handleClickAnalytics;
        $[8] = layoutOptions;
        $[9] = updateLayout;
        $[10] = t4;
    } else t4 = $[10];
    const handleOptionClick = t4;
    let t5;
    if ($[11] !== PreviewComponent || $[12] !== currentLayoutSelection || $[13] !== formatMessage || $[14] !== handleOnChange || $[15] !== handleOptionClick || $[16] !== layoutOptions || $[17] !== previewImage || $[18] !== variant) {
        let t6;
        if ($[20] !== PreviewComponent || $[21] !== currentLayoutSelection || $[22] !== formatMessage || $[23] !== handleOnChange || $[24] !== handleOptionClick || $[25] !== previewImage || $[26] !== variant) {
            t6 = (t7)=>{
                const { value: layout, label: i18nLabel, description: i18nDescription } = t7;
                const label = formatMessage(i18nLabel);
                const description = i18nDescription && formatMessage(i18nDescription);
                const { imageSrc: imageSrc, imageSrcDark: imageSrcDark } = previewImage?.(layout) || {};
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                    xcss: (0, $1Whri.cx)($e1e57cfddd500cee$var$layoutOptionStyles.defaultLayoutOption, currentLayoutSelection === layout && $e1e57cfddd500cee$var$layoutOptionStyles.layoutOptionSelected, $e1e57cfddd500cee$var$layoutOptionStyles[$e1e57cfddd500cee$var$variantMap[variant]]),
                    onClick: ()=>handleOptionClick(layout),
                    key: `${layout}${label}`,
                    testId: "layout-option"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                    direction: "column",
                    gap: "space.100"
                }, PreviewComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ec1d6fee0534a73$export$73bba9cb9f06b02a), {
                    layout: layout,
                    previewSizeVariant: variant,
                    PreviewComponent: PreviewComponent
                }), !PreviewComponent && previewImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                    src: imageSrc,
                    srcDark: imageSrcDark,
                    alt: "",
                    testId: `${layout}--image`
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                    direction: "column",
                    gap: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($e1e57cfddd500cee$var$layoutOptionStyles.radioButtonWrapper)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
                    value: layout,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                        alignItems: "center",
                        xcss: (0, $1Whri.cx)($e1e57cfddd500cee$var$layoutOptionStyles.layoutLabelHeadingWrapper)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                        size: $e1e57cfddd500cee$var$headingSizeMap[variant]
                    }, label)),
                    name: label,
                    isChecked: layout === currentLayoutSelection,
                    onChange: handleOnChange
                })), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    align: "start",
                    color: "color.text.subtlest",
                    size: "small"
                }, description))));
            };
            $[20] = PreviewComponent;
            $[21] = currentLayoutSelection;
            $[22] = formatMessage;
            $[23] = handleOnChange;
            $[24] = handleOptionClick;
            $[25] = previewImage;
            $[26] = variant;
            $[27] = t6;
        } else t6 = $[27];
        t5 = layoutOptions.map(t6);
        $[11] = PreviewComponent;
        $[12] = currentLayoutSelection;
        $[13] = formatMessage;
        $[14] = handleOnChange;
        $[15] = handleOptionClick;
        $[16] = layoutOptions;
        $[17] = previewImage;
        $[18] = variant;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[28] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5);
        $[28] = t5;
        $[29] = t6;
    } else t6 = $[29];
    return t6;
} : ({ updateLayout: updateLayout, source: source, layoutOptions: layoutOptions, variant: variant = 'default', PreviewComponent: PreviewComponent, previewImage: previewImage, currentLayoutSelection: currentLayoutSelection })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleClickAnalytics = (0, $42omo.useCallback)((value)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'selected',
                actionSubject: 'layout',
                actionSubjectId: 'configPanelLayoutOptions',
                source: source,
                attributes: {
                    value: value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const handleOnChange = (event)=>{
        const selectedOption = layoutOptions.find((option)=>option.value === event.currentTarget.value);
        if (selectedOption) {
            handleClickAnalytics(selectedOption.value);
            updateLayout(selectedOption.value);
        }
    };
    const handleOptionClick = (newLayoutValue)=>{
        const selectedValue = layoutOptions.find(({ value: value_0 })=>value_0 === newLayoutValue)?.value;
        handleClickAnalytics(selectedValue);
        updateLayout(newLayoutValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, layoutOptions.map(({ value: layout, label: i18nLabel, description: i18nDescription })=>{
        const label = formatMessage(i18nLabel);
        const description = i18nDescription && formatMessage(i18nDescription);
        const { imageSrc: imageSrc, imageSrcDark: imageSrcDark } = previewImage?.(layout) || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: (0, $1Whri.cx)($e1e57cfddd500cee$var$layoutOptionStyles.defaultLayoutOption, currentLayoutSelection === layout && $e1e57cfddd500cee$var$layoutOptionStyles.layoutOptionSelected, $e1e57cfddd500cee$var$layoutOptionStyles[$e1e57cfddd500cee$var$variantMap[variant]]),
            onClick: ()=>handleOptionClick(layout),
            key: `${layout}${label}`,
            testId: "layout-option"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.100"
        }, PreviewComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ec1d6fee0534a73$export$73bba9cb9f06b02a), {
            layout: layout,
            previewSizeVariant: variant,
            PreviewComponent: PreviewComponent
        }), !PreviewComponent && previewImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: imageSrc,
            srcDark: imageSrcDark,
            alt: "",
            testId: `${layout}--image`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($e1e57cfddd500cee$var$layoutOptionStyles.radioButtonWrapper)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
            value: layout,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                alignItems: "center",
                xcss: (0, $1Whri.cx)($e1e57cfddd500cee$var$layoutOptionStyles.layoutLabelHeadingWrapper)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                size: $e1e57cfddd500cee$var$headingSizeMap[variant]
            }, label)),
            name: label,
            isChecked: layout === currentLayoutSelection,
            onChange: handleOnChange
        })), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            align: "start",
            color: "color.text.subtlest",
            size: "small"
        }, description))));
    }));
};
module.exports["LayoutOptions"] = $e1e57cfddd500cee$export$f4ca495c8982b022;

});

parcelRegister("2oKNO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");


var $g3LxX = parcelRequire("g3LxX");


var $fOKpq = parcelRequire("fOKpq");


var $1VNax = parcelRequire("1VNax");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");





var $inPa6 = parcelRequire("inPa6");


var $51lK8 = parcelRequire("51lK8");


var $2WHHL = parcelRequire("2WHHL");


var $iTTcV = parcelRequire("iTTcV");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $be2Qa = parcelRequire("be2Qa");

const $af284bdcd0c65e3f$var$wrapperStyles = (0, $ecnYn.xcss)({
    gap: 'space.200'
});
const $af284bdcd0c65e3f$var$isEqual = (base)=>(value)=>base === value;
const $af284bdcd0c65e3f$var$isScroll = $af284bdcd0c65e3f$var$isEqual('scroll');
const $af284bdcd0c65e3f$var$isAuto = $af284bdcd0c65e3f$var$isEqual('auto');
const $af284bdcd0c65e3f$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $af284bdcd0c65e3f$var$isElementScrollable = (element)=>{
    const style = window.getComputedStyle(element);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $af284bdcd0c65e3f$var$isEither(overflow, $af284bdcd0c65e3f$var$isScroll) || $af284bdcd0c65e3f$var$isEither(overflow, $af284bdcd0c65e3f$var$isAuto);
};
const $af284bdcd0c65e3f$var$getClosestScrollableElement = (element)=>{
    if (!element) return null;
    if (element === document.body || element === document.documentElement) return null;
    if (!$af284bdcd0c65e3f$var$isElementScrollable(element)) return $af284bdcd0c65e3f$var$getClosestScrollableElement(element.parentElement);
    return element;
};
const $af284bdcd0c65e3f$export$ca49a56e05207e2d = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { analyticsSource: analyticsSource, children: children, defaultItems: defaultItems, setDraggedItem: setDraggedItem, updateItems: updateItems, shouldUseCardV2UI: t1 } = t0;
    const shouldUseCardV2UI = t1 === undefined ? false : t1;
    const items = (0, $42omo.useRef)(defaultItems);
    const draggableZoneRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    let t3;
    if ($[0] !== analyticsSource || $[1] !== createAnalyticsEvent || $[2] !== defaultItems || $[3] !== setDraggedItem || $[4] !== updateItems) {
        t2 = ()=>{
            let cleanupAutoScroll = null;
            return (0, $bSjaC.combine)((0, $4T4vf.monitorForElements)({
                canMonitor: $af284bdcd0c65e3f$var$_temp,
                onDragStart: ()=>{
                    if (cleanupAutoScroll) return;
                    const closestScrollable = $af284bdcd0c65e3f$var$getClosestScrollableElement(draggableZoneRef.current);
                    if (!closestScrollable) return;
                    cleanupAutoScroll = (0, $51lK8.autoScrollForElements)({
                        element: closestScrollable
                    });
                },
                onDrop: (t4)=>{
                    const { location: location, source: source_0 } = t4;
                    const target = location.current.dropTargets[0];
                    if (!target) return;
                    const sourceData = source_0.data;
                    const targetData = target.data;
                    if (!(0, $be2Qa.isItemData)(sourceData) || !(0, $be2Qa.isItemData)(targetData)) return;
                    const indexOfSource = defaultItems.findIndex((item)=>item.cardId === sourceData.item.cardId);
                    const indexOfTarget = defaultItems.findIndex((item_0)=>item_0.cardId === targetData.item.cardId);
                    if (indexOfTarget < 0) return;
                    const closestEdgeOfTarget = (0, $2WHHL.extractClosestEdge)(targetData);
                    items.current = (0, $iTTcV.reorderWithEdge)({
                        list: defaultItems,
                        startIndex: indexOfSource,
                        indexOfTarget: indexOfTarget,
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        axis: "vertical"
                    });
                    setDraggedItem?.();
                    updateItems(items.current);
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "reordered",
                            actionSubject: "items",
                            actionSubjectId: "draggableItemsZone",
                            source: analyticsSource
                        }
                    }).fire();
                }
            }), ()=>cleanupAutoScroll?.());
        };
        t3 = [
            analyticsSource,
            items,
            createAnalyticsEvent,
            defaultItems,
            updateItems,
            setDraggedItem
        ];
        $[0] = analyticsSource;
        $[1] = createAnalyticsEvent;
        $[2] = defaultItems;
        $[3] = setDraggedItem;
        $[4] = updateItems;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[7] !== shouldUseCardV2UI) {
        t4 = !shouldUseCardV2UI && {
            xcss: $af284bdcd0c65e3f$var$wrapperStyles
        };
        $[7] = shouldUseCardV2UI;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== children || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            ref: draggableZoneRef,
            ...t4,
            testId: "draggable-item-zone"
        }, children);
        $[9] = children;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ analyticsSource: analyticsSource, children: children, defaultItems: defaultItems, setDraggedItem: setDraggedItem, updateItems: updateItems, shouldUseCardV2UI: shouldUseCardV2UI = false })=>{
    const items = (0, $42omo.useRef)(defaultItems);
    const draggableZoneRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        let cleanupAutoScroll = null;
        return (0, $bSjaC.combine)((0, $4T4vf.monitorForElements)({
            canMonitor: ({ source: source })=>{
                return (0, $be2Qa.isItemData)(source.data);
            },
            onDragStart: ()=>{
                if (cleanupAutoScroll) return;
                const closestScrollable = $af284bdcd0c65e3f$var$getClosestScrollableElement(draggableZoneRef.current);
                if (!closestScrollable) return;
                cleanupAutoScroll = (0, $51lK8.autoScrollForElements)({
                    element: closestScrollable
                });
            },
            onDrop: ({ location: location, source: source_0 })=>{
                const target = location.current.dropTargets[0];
                if (!target) return;
                const sourceData = source_0.data;
                const targetData = target.data;
                if (!(0, $be2Qa.isItemData)(sourceData) || !(0, $be2Qa.isItemData)(targetData)) return;
                const indexOfSource = defaultItems.findIndex((item)=>item.cardId === sourceData.item.cardId);
                const indexOfTarget = defaultItems.findIndex((item_0)=>item_0.cardId === targetData.item.cardId);
                if (indexOfTarget < 0) return;
                const closestEdgeOfTarget = (0, $2WHHL.extractClosestEdge)(targetData);
                items.current = (0, $iTTcV.reorderWithEdge)({
                    list: defaultItems,
                    startIndex: indexOfSource,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    axis: 'vertical'
                });
                setDraggedItem?.();
                updateItems(items.current);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'reordered',
                        actionSubject: 'items',
                        actionSubjectId: 'draggableItemsZone',
                        source: analyticsSource
                    }
                }).fire();
            }
        }), ()=>cleanupAutoScroll?.());
    }, [
        analyticsSource,
        items,
        createAnalyticsEvent,
        defaultItems,
        updateItems,
        setDraggedItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        ref: draggableZoneRef,
        ...!shouldUseCardV2UI && {
            xcss: $af284bdcd0c65e3f$var$wrapperStyles
        },
        testId: "draggable-item-zone"
    }, children);
};
function $af284bdcd0c65e3f$var$_temp(t0) {
    const { source: source } = t0;
    return (0, $be2Qa.isItemData)(source.data);
}



var $dCemt = parcelRequire("dCemt");

const $5f316676683a88de$var$upAccelerator = 'mod+option+shift+[';
const $5f316676683a88de$var$downAccelerator = 'mod+option+shift+]';
const $5f316676683a88de$export$ae634aeaeccf14ea = ({ items: items, removeItem: removeItem, analyticsSource: analyticsSource, actionSubjectIdPostFix: actionSubjectIdPostFix, itemsListRef: itemsListRef, shouldUseCardV2UI: shouldUseCardV2UI, updateItems: updateItems, itemLabel: itemLabel, canDeleteItem: canDeleteItem = true, renderItemContent: renderItemContent })=>{
    const { shortcutListener: shortcutListener } = (0, $fOKpq.useProductDependencies)();
    const isDeleteDisabled = items?.length === 1;
    const [{ selectedToEditCardId: selectedToEditCardId }, { setIsInViewMode: setIsInViewMode, setSelectedToEditCardId: setSelectedToEditCardId, setIsInAutoFocusMode: setIsInAutoFocusMode }] = (0, $g3LxX.useExtensionsState)();
    const firstItemId = items?.[0]?.cardId || null;
    (0, $42omo.useEffect)(()=>{
        // the order is important here
        // view mode should goes first to allow the active item to be set
        setIsInViewMode(false);
        if (selectedToEditCardId !== 'dragged-item') setSelectedToEditCardId(firstItemId);
        return ()=>{
            // Only reset card-level state on unmount. Do NOT reset isInViewMode here
            // because this component does not own the view mode lifecycle — the editor does.
            // Resetting isInViewMode to true on unmount would leave the editor in an
            // inconsistent state where subsequent openConfigPanel calls silently fail
            // (setSelectedExtensionLocalId is guarded by isInViewMode).
            setSelectedToEditCardId(null);
            setIsInAutoFocusMode(true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        firstItemId,
        setIsInViewMode,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const setDraggedItem = ()=>setSelectedToEditCardId('dragged-item');
    const swapItems = (source, target)=>{
        const newItems = [
            ...items
        ];
        const temp = newItems[target];
        newItems[target] = newItems[source];
        newItems[source] = temp;
        updateItems(newItems);
    };
    const [focusedItem, setFocusedItem] = (0, $42omo.useState)(undefined);
    const onMoveUp = ()=>{
        if (focusedItem !== undefined) {
            setDraggedItem();
            swapItems(focusedItem, focusedItem - 1);
            setFocusedItem(focusedItem - 1);
        }
    };
    const onMoveDown = ()=>{
        if (focusedItem !== undefined) {
            setDraggedItem();
            swapItems(focusedItem, focusedItem + 1);
            setFocusedItem(focusedItem + 1);
        }
    };
    const isFirstItemFocused = focusedItem === 0;
    const isLastItemFocused = focusedItem === items?.length - 1;
    const ShortcutListener = shortcutListener || (0, $42omo.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "column",
        testId: "items-list-builder",
        gap: shouldUseCardV2UI ? undefined : 'space.200',
        ref: itemsListRef
    }, (0, $1VNax.checkItems)(items) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $af284bdcd0c65e3f$export$ca49a56e05207e2d), {
        analyticsSource: analyticsSource,
        defaultItems: items,
        setDraggedItem: setDraggedItem,
        updateItems: updateItems,
        shouldUseCardV2UI: shouldUseCardV2UI
    }, !isFirstItemFocused && shortcutListener && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ShortcutListener, {
        accelerator: $5f316676683a88de$var$upAccelerator,
        listener: onMoveUp
    }), !isLastItemFocused && shortcutListener && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ShortcutListener, {
        accelerator: $5f316676683a88de$var$downAccelerator,
        listener: onMoveDown
    }), items.map((itemParameters, order)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dCemt.Item), {
            actionSubjectIdPostFix: actionSubjectIdPostFix,
            analyticsSource: analyticsSource,
            itemParameters: itemParameters,
            isDeleteDisabled: isDeleteDisabled,
            isExpanded: selectedToEditCardId === itemParameters.cardId,
            isFirstItem: order === 0,
            isLastItem: order === items.length - 1,
            key: itemParameters.cardId,
            onFocus: ()=>setFocusedItem(order),
            onBlur: ()=>setFocusedItem(undefined),
            order: order + 1,
            removeItem: removeItem,
            renderItemContent: renderItemContent,
            setDraggedItem: setDraggedItem,
            setExpandedItem: setSelectedToEditCardId,
            swapItems: swapItems,
            shouldUseCardV2UI: shouldUseCardV2UI,
            itemLabel: itemLabel,
            canDeleteItem: canDeleteItem
        });
    })));
};
module.exports["ItemsListBuilder"] = $5f316676683a88de$export$ae634aeaeccf14ea;

});

parcelRegister("dCemt", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $2AytZ = parcelRequire("2AytZ");


var $gKvd9 = parcelRequire("gKvd9");


var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3v7tz = parcelRequire("3v7tz");


var $g3LxX = parcelRequire("g3LxX");











var $jTxSS = parcelRequire("jTxSS");


var $dRnqM = parcelRequire("dRnqM");


var $2WHHL = parcelRequire("2WHHL");


var $2n8po = parcelRequire("2n8po");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");


var $882hS = parcelRequire("882hS");


var $afUmf = parcelRequire("afUmf");


var $6f0Oj = parcelRequire("6f0Oj");




















var $4rwCt = parcelRequire("4rwCt");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $hgeg8 = parcelRequire("hgeg8");


var $22Iw9 = parcelRequire("22Iw9");


var $euUgw = parcelRequire("euUgw");


var $l998X = parcelRequire("l998X");











var $8aNCk = parcelRequire("8aNCk");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $dOMrE = parcelRequire("dOMrE");

function $428e284101874428$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Cannot use `@atlaskit/button` here because it cancels `mousedown` events
 * which prevents dragging.
 */ const $428e284101874428$var$buttonStyles = {
    name: "txaqq0",
    styles: "color:var(--ds-text, #292A2E);border-radius:var(--ds-radius-small, 4px);padding:var(--ds-space-0, 0px);width:max-content;border:none;cursor:grab;display:flex"
};
const $428e284101874428$var$buttonAppearanceStyles = {
    default: {
        name: "1m0qggu",
        styles: "background-color:var(--ds-background-neutral, #0515240F);&:hover{background-color:var(--ds-background-neutral-hovered, #0B120E24);}&:active{background-color:var(--ds-background-neutral-pressed, #080F214A);}"
    },
    subtle: {
        name: "u8pb1t",
        styles: "background-color:var(--ds-background-neutral-subtle, #00000000);&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #0B120E24);}"
    },
    selected: {
        name: "1km59x1",
        styles: "background-color:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB)"
    }
};
const $428e284101874428$export$c099c65cfbd84d0a = /*#__PURE__*/ (0, $42omo.forwardRef)(function DragHandleButton({ children: children, isSelected: isSelected = false, testId: testId, appearance: appearanceProp = 'default', type: /**
   * Defaulting to `button` instead of `submit` (native default in some cases).
   *
   * A type of `submit` only makes sense in a form context, and isn't very
   * relevant to a drag handle.
   *
   * `@atlaskit/button` also defaults to a type of `button` as well, as it
   * is more semantically appropriate in a wider range of cases.
   */ type = 'button', ...buttonProps }, ref) {
    const appearance = isSelected ? 'selected' : appearanceProp;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dOMrE.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        ref: ref,
        css: [
            $428e284101874428$var$buttonStyles,
            $428e284101874428$var$buttonAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        type: type,
        ...buttonProps
    }, children));
});


const $99266c3e40a077c6$export$4c99a519d851f90c = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function DragHandleButton(t0, ref) {
    const $ = (0, $frIzR.c)(9);
    let buttonProps;
    let label;
    if ($[0] !== t0) {
        ({ label: label, ...buttonProps } = t0);
        $[0] = t0;
        $[1] = buttonProps;
        $[2] = label;
    } else {
        buttonProps = $[1];
        label = $[2];
    }
    let t1;
    if ($[3] !== label) {
        t1 = /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
            spacing: "spacious",
            label: label,
            size: "small"
        });
        $[3] = label;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== buttonProps || $[6] !== ref || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, $l998X.jsx)((0, $428e284101874428$export$c099c65cfbd84d0a), {
            ref: ref,
            ...buttonProps,
            children: t1
        });
        $[5] = buttonProps;
        $[6] = ref;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function DragHandleButton({ label: label, ...buttonProps }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $428e284101874428$export$c099c65cfbd84d0a), {
        ref: ref,
        ...buttonProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
            spacing: "spacious",
            label: label,
            size: "small"
        })
    });
});










const $7b98210e734672cc$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    moveUp: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.move.up.label",
        defaultMessage: "Move up"
    },
    moveDown: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.move.down.label",
        defaultMessage: "Move down"
    },
    arrowUp: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.arrow.up",
        defaultMessage: "up"
    },
    arrowDown: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.arrow.down",
        defaultMessage: "down"
    },
    reorder: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.reorder",
        defaultMessage: "reorder"
    }
});


const $fec75a069994527c$var$moveRowUp = (0, $hgeg8.makeKeyMapWithCommon)('Move Up', 'Ctrl-Alt-Shift-[');
const $fec75a069994527c$var$moveRowDown = (0, $hgeg8.makeKeyMapWithCommon)('Move Down', 'Ctrl-Alt-Shift-]');
const $fec75a069994527c$var$upKeyMap = (0, $hgeg8.tooltip)($fec75a069994527c$var$moveRowUp);
const $fec75a069994527c$var$downKeyMap = (0, $hgeg8.tooltip)($fec75a069994527c$var$moveRowDown);
const $fec75a069994527c$var$dragHandleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'utility.elevation.surface.current',
    marginInline: 'space.050'
});
const $fec75a069994527c$var$draggingStyles = (0, $ecnYn.xcss)({
    opacity: '0.5'
});
const $fec75a069994527c$var$shortcut = (0, $ecnYn.xcss)({
    background: "var(--ds-background-neutral, #0515240F)",
    color: 'color.text.subtle',
    borderRadius: 'radius.small',
    padding: 'space.050',
    alignSelf: 'flex-end'
});
const $fec75a069994527c$var$getStyles = (isDragHandleHovered, isDragHandleFocused)=>({
        justifyContent: 'center',
        width: '16px',
        backgroundColor: "var(--ds-elevation-surface-current, #FFFFFF)",
        ...isDragHandleHovered && {
            backgroundColor: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
        },
        ...isDragHandleFocused && {
            backgroundColor: "var(--ds-elevation-surface-current, #FFFFFF)"
        }
    });
const $fec75a069994527c$export$d87bd93dda5de125 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(37);
    const { isDragHandleFocused: isDragHandleFocused, isDragging: isDragging, isFirst: isFirst, isLast: isLast, onMoveUp: onMoveUp, onMoveDown: onMoveDown, setIsDragHandleFocused: setIsDragHandleFocused, onFocus: onFocus, onBlur: onBlur } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const dragHandleRef = (0, $42omo.useRef)(null);
    const [isDragHandleHovered, setIsDragHandleHovered] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== formatMessage || $[1] !== isDragHandleFocused || $[2] !== isDragHandleHovered || $[3] !== isDragging || $[4] !== onBlur || $[5] !== onFocus) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $fec75a069994527c$var$dragHandleStyles,
                    isDragging && $fec75a069994527c$var$draggingStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99266c3e40a077c6$export$4c99a519d851f90c), {
                style: $fec75a069994527c$var$getStyles(isDragHandleHovered, isDragHandleFocused),
                ref: (0, $4rwCt.mergeRefs)([
                    dragHandleRef,
                    triggerRef
                ]),
                ...triggerProps,
                testId: "drag-handle",
                label: formatMessage((0, $7b98210e734672cc$export$defe85febe8b728c).reorder),
                onMouseLeave: ()=>{
                    if (!triggerProps.isSelected) setIsDragHandleHovered(false);
                },
                onMouseEnter: ()=>{
                    if (!triggerProps.isSelected) setIsDragHandleHovered(true);
                },
                onFocus: onFocus,
                onBlur: onBlur
            }));
        };
        $[0] = formatMessage;
        $[1] = isDragHandleFocused;
        $[2] = isDragHandleHovered;
        $[3] = isDragging;
        $[4] = onBlur;
        $[5] = onFocus;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== setIsDragHandleFocused) {
        t2 = (args)=>{
            const { isOpen: isOpen } = args;
            setIsDragHandleFocused(isOpen);
            if (!isOpen) setIsDragHandleHovered(false);
        };
        $[7] = setIsDragHandleFocused;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== formatMessage) {
        t3 = formatMessage((0, $7b98210e734672cc$export$defe85febe8b728c).arrowUp);
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: t3
        });
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $fec75a069994527c$var$shortcut
        }, $fec75a069994527c$var$upKeyMap);
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7b98210e734672cc$export$defe85febe8b728c).moveUp);
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== isFirst || $[16] !== onMoveUp || $[17] !== t4) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            elemBefore: t4,
            elemAfter: t5,
            isDisabled: isFirst,
            onClick: onMoveUp
        }, t6);
        $[15] = isFirst;
        $[16] = onMoveUp;
        $[17] = t4;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== formatMessage) {
        t8 = formatMessage((0, $7b98210e734672cc$export$defe85febe8b728c).arrowDown);
        $[19] = formatMessage;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
            label: t8
        });
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $fec75a069994527c$var$shortcut
        }, $fec75a069994527c$var$downKeyMap);
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7b98210e734672cc$export$defe85febe8b728c).moveDown);
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== isLast || $[26] !== onMoveDown || $[27] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            elemBefore: t9,
            elemAfter: t10,
            isDisabled: isLast,
            onClick: onMoveDown
        }, t11);
        $[25] = isLast;
        $[26] = onMoveDown;
        $[27] = t9;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== t12 || $[30] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, t7, t12);
        $[29] = t12;
        $[30] = t7;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== isDragHandleFocused || $[33] !== t1 || $[34] !== t13 || $[35] !== t2) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            trigger: t1,
            onOpenChange: t2,
            isOpen: isDragHandleFocused
        }, t13);
        $[32] = isDragHandleFocused;
        $[33] = t1;
        $[34] = t13;
        $[35] = t2;
        $[36] = t14;
    } else t14 = $[36];
    return t14;
} : ({ isDragHandleFocused: isDragHandleFocused, isDragging: isDragging, isFirst: isFirst, isLast: isLast, onMoveUp: onMoveUp, onMoveDown: onMoveDown, setIsDragHandleFocused: setIsDragHandleFocused, onFocus: onFocus, onBlur: onBlur })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const dragHandleRef = (0, $42omo.useRef)(null);
    const [isDragHandleHovered, setIsDragHandleHovered] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $fec75a069994527c$var$dragHandleStyles,
                    isDragging && $fec75a069994527c$var$draggingStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99266c3e40a077c6$export$4c99a519d851f90c), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: $fec75a069994527c$var$getStyles(isDragHandleHovered, isDragHandleFocused),
                ref: (0, $4rwCt.mergeRefs)([
                    dragHandleRef,
                    triggerRef
                ]),
                ...triggerProps,
                testId: "drag-handle",
                label: formatMessage((0, $7b98210e734672cc$export$defe85febe8b728c).reorder),
                onMouseLeave: ()=>{
                    if (!triggerProps.isSelected) setIsDragHandleHovered(false);
                },
                onMouseEnter: ()=>{
                    if (!triggerProps.isSelected) setIsDragHandleHovered(true);
                },
                onFocus: onFocus,
                onBlur: onBlur
            })),
        onOpenChange: (args)=>{
            const { isOpen: isOpen } = args;
            setIsDragHandleFocused(isOpen);
            if (!isOpen) setIsDragHandleHovered(false);
        },
        isOpen: isDragHandleFocused
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: formatMessage((0, $7b98210e734672cc$export$defe85febe8b728c).arrowUp)
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $fec75a069994527c$var$shortcut
        }, $fec75a069994527c$var$upKeyMap),
        isDisabled: isFirst,
        onClick: onMoveUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7b98210e734672cc$export$defe85febe8b728c).moveUp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
            label: formatMessage((0, $7b98210e734672cc$export$defe85febe8b728c).arrowDown)
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $fec75a069994527c$var$shortcut
        }, $fec75a069994527c$var$downKeyMap),
        isDisabled: isLast,
        onClick: onMoveDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7b98210e734672cc$export$defe85febe8b728c).moveDown))));
};



var $be2Qa = parcelRequire("be2Qa");

const $55b77b963efcc3f6$var$idle = {
    type: 'idle'
};
const $55b77b963efcc3f6$var$dragging = {
    type: 'is-dragging'
};
const $55b77b963efcc3f6$var$itemContainer = (0, $ecnYn.xcss)({
    alignItems: 'flex-start',
    position: 'relative'
});
const $55b77b963efcc3f6$var$itemContainerV2 = (0, $ecnYn.xcss)({
    alignItems: 'flex-start',
    position: 'relative',
    paddingTop: 'space.200',
    paddingBottom: 'space.200'
});
const $55b77b963efcc3f6$var$itemDisabled = (0, $ecnYn.xcss)({
    opacity: 0.4
});
const $55b77b963efcc3f6$var$itemPreview = (0, $ecnYn.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    maxWidth: '360px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $55b77b963efcc3f6$var$draggableContent = (0, $ecnYn.xcss)({
    width: '100%'
});
const $55b77b963efcc3f6$export$f115a0a419405ac5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(49);
    const { item: item, children: children, headerTitle: headerTitle, index: index, isDragHandleFocused: isDragHandleFocused, isFirstItem: isFirstItem, isLastItem: isLastItem, setDraggedItem: setDraggedItem, setIsDragHandleFocused: setIsDragHandleFocused, swapItems: swapItems, shouldUseCardV2UI: shouldUseCardV2UI, onBlur: onBlur, onFocus: onFocus } = t0;
    const ref = (0, $42omo.useRef)(null);
    const [draggableState, setDraggableState] = (0, $42omo.useState)($55b77b963efcc3f6$var$idle);
    let t1;
    let t2;
    if ($[0] !== index || $[1] !== item || $[2] !== setDraggedItem || $[3] !== setIsDragHandleFocused) {
        t1 = ()=>{
            const element = ref.current;
            (0, $dRnqM.default)(element);
            const data = (0, $be2Qa.getItemData)({
                item: item,
                index: index
            });
            return (0, $bSjaC.combine)((0, $4T4vf.draggable)({
                element: element,
                getInitialData: ()=>data,
                onGenerateDragPreview: (t3)=>{
                    const { nativeSetDragImage: nativeSetDragImage } = t3;
                    (0, $afUmf.setCustomNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage,
                        getOffset: (0, $882hS.pointerOutsideOfPreview)({
                            x: "var(--ds-space-200, 16px)",
                            y: "var(--ds-space-100, 8px)"
                        }),
                        render: (t4)=>{
                            const { container: container } = t4;
                            setDraggableState({
                                type: "preview",
                                container: container
                            });
                        }
                    });
                },
                onDragStart: ()=>{
                    setDraggableState($55b77b963efcc3f6$var$dragging);
                    setIsDragHandleFocused(false);
                },
                onDrop: ()=>{
                    setDraggableState($55b77b963efcc3f6$var$idle);
                    setDraggedItem();
                }
            }), (0, $4T4vf.dropTargetForElements)({
                element: element,
                canDrop: (t5)=>{
                    const { source: source } = t5;
                    if (source.element === element) return false;
                    return (0, $be2Qa.isItemData)(source.data);
                },
                getData: (t6)=>{
                    const { input: input } = t6;
                    return (0, $2WHHL.attachClosestEdge)(data, {
                        element: element,
                        input: input,
                        allowedEdges: [
                            "top",
                            "bottom"
                        ]
                    });
                },
                getIsSticky: $55b77b963efcc3f6$var$_temp,
                onDragEnter: (t7)=>{
                    const { self: self } = t7;
                    const closestEdge = (0, $2WHHL.extractClosestEdge)(self.data);
                    setDraggableState({
                        type: "is-dragging-over",
                        closestEdge: closestEdge
                    });
                    setIsDragHandleFocused(false);
                },
                onDrag: (t8)=>{
                    const { self: self_0 } = t8;
                    const closestEdge_0 = (0, $2WHHL.extractClosestEdge)(self_0.data);
                    setDraggableState((current)=>{
                        if (current.type === "is-dragging-over" && current.closestEdge === closestEdge_0) return current;
                        return {
                            type: "is-dragging-over",
                            closestEdge: closestEdge_0
                        };
                    });
                },
                onDragLeave: ()=>{
                    setDraggableState($55b77b963efcc3f6$var$idle);
                },
                onDrop: ()=>{
                    setDraggableState($55b77b963efcc3f6$var$idle);
                    setDraggedItem();
                }
            }));
        };
        t2 = [
            item,
            index,
            setDraggedItem,
            setIsDragHandleFocused
        ];
        $[0] = index;
        $[1] = item;
        $[2] = setDraggedItem;
        $[3] = setIsDragHandleFocused;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    const isDragging = draggableState.type === "is-dragging";
    let t3;
    if ($[6] !== setDraggedItem || $[7] !== setIsDragHandleFocused || $[8] !== swapItems) {
        t3 = (sourceIndex, targetIndex)=>{
            setDraggedItem();
            setIsDragHandleFocused(false);
            swapItems(sourceIndex, targetIndex);
        };
        $[6] = setDraggedItem;
        $[7] = setIsDragHandleFocused;
        $[8] = swapItems;
        $[9] = t3;
    } else t3 = $[9];
    const handleMove = t3;
    const t4 = shouldUseCardV2UI ? $55b77b963efcc3f6$var$itemContainerV2 : $55b77b963efcc3f6$var$itemContainer;
    let t5;
    if ($[10] !== t4) {
        t5 = [
            t4
        ];
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    let t7;
    if ($[12] !== handleMove || $[13] !== index) {
        t6 = ()=>{
            handleMove(index, index + 1);
        };
        t7 = ()=>{
            handleMove(index, index - 1);
        };
        $[12] = handleMove;
        $[13] = index;
        $[14] = t6;
        $[15] = t7;
    } else {
        t6 = $[14];
        t7 = $[15];
    }
    let t8;
    if ($[16] !== isDragHandleFocused || $[17] !== isDragging || $[18] !== isFirstItem || $[19] !== isLastItem || $[20] !== onBlur || $[21] !== onFocus || $[22] !== setIsDragHandleFocused || $[23] !== t6 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fec75a069994527c$export$d87bd93dda5de125), {
            isDragging: isDragging,
            isDragHandleFocused: isDragHandleFocused,
            isFirst: isFirstItem,
            isLast: isLastItem,
            onMoveDown: t6,
            onMoveUp: t7,
            setIsDragHandleFocused: setIsDragHandleFocused,
            onBlur: onBlur,
            onFocus: onFocus
        });
        $[16] = isDragHandleFocused;
        $[17] = isDragging;
        $[18] = isFirstItem;
        $[19] = isLastItem;
        $[20] = onBlur;
        $[21] = onFocus;
        $[22] = setIsDragHandleFocused;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    const t9 = isDragging && $55b77b963efcc3f6$var$itemDisabled;
    let t10;
    if ($[26] !== t9) {
        t10 = [
            t9,
            $55b77b963efcc3f6$var$draggableContent
        ];
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== children || $[29] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t10
        }, children);
        $[28] = children;
        $[29] = t10;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== draggableState.closestEdge || $[32] !== draggableState.type || $[33] !== shouldUseCardV2UI) {
        t12 = draggableState.type === "is-dragging-over" && draggableState.closestEdge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2n8po.DropIndicator), {
            edge: draggableState.closestEdge,
            ...!shouldUseCardV2UI && {
                gap: "var(--ds-space-200, 16px)"
            }
        }) : null;
        $[31] = draggableState.closestEdge;
        $[32] = draggableState.type;
        $[33] = shouldUseCardV2UI;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== t11 || $[36] !== t12 || $[37] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            ref: ref,
            alignInline: "start",
            alignBlock: "center",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            alignInline: "stretch",
            xcss: $55b77b963efcc3f6$var$draggableContent
        }, t8, t11, t12));
        $[35] = t11;
        $[36] = t12;
        $[37] = t8;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== t13 || $[40] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            grow: "fill",
            alignBlock: "stretch",
            xcss: t5
        }, t13);
        $[39] = t13;
        $[40] = t5;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== draggableState.container || $[43] !== draggableState.type || $[44] !== headerTitle) {
        t15 = draggableState.type === "preview" && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $55b77b963efcc3f6$var$itemPreview
        }, headerTitle), draggableState.container);
        $[42] = draggableState.container;
        $[43] = draggableState.type;
        $[44] = headerTitle;
        $[45] = t15;
    } else t15 = $[45];
    let t16;
    if ($[46] !== t14 || $[47] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t14, t15);
        $[46] = t14;
        $[47] = t15;
        $[48] = t16;
    } else t16 = $[48];
    return t16;
} : ({ item: item, children: children, headerTitle: headerTitle, index: index, isDragHandleFocused: isDragHandleFocused, isFirstItem: isFirstItem, isLastItem: isLastItem, setDraggedItem: setDraggedItem, setIsDragHandleFocused: setIsDragHandleFocused, swapItems: swapItems, shouldUseCardV2UI: shouldUseCardV2UI, onBlur: onBlur, onFocus: onFocus })=>{
    const ref = (0, $42omo.useRef)(null);
    const [draggableState, setDraggableState] = (0, $42omo.useState)($55b77b963efcc3f6$var$idle);
    (0, $42omo.useEffect)(()=>{
        const element = ref.current;
        (0, $dRnqM.default)(element);
        const data = (0, $be2Qa.getItemData)({
            item: item,
            index: index
        });
        return (0, $bSjaC.combine)((0, $4T4vf.draggable)({
            element: element,
            getInitialData: ()=>data,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $afUmf.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $882hS.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render: ({ container: container })=>{
                        setDraggableState({
                            type: 'preview',
                            container: container
                        });
                    }
                });
            },
            onDragStart: ()=>{
                setDraggableState($55b77b963efcc3f6$var$dragging);
                setIsDragHandleFocused(false);
            },
            onDrop: ()=>{
                setDraggableState($55b77b963efcc3f6$var$idle);
                setDraggedItem();
            }
        }), (0, $4T4vf.dropTargetForElements)({
            element: element,
            canDrop: ({ source: source })=>{
                if (source.element === element) return false;
                return (0, $be2Qa.isItemData)(source.data);
            },
            getData: ({ input: input })=>{
                return (0, $2WHHL.attachClosestEdge)(data, {
                    element: element,
                    input: input,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            getIsSticky: ()=>{
                return true;
            },
            onDragEnter: ({ self: self })=>{
                const closestEdge = (0, $2WHHL.extractClosestEdge)(self.data);
                setDraggableState({
                    type: 'is-dragging-over',
                    closestEdge: closestEdge
                });
                setIsDragHandleFocused(false);
            },
            onDrag: ({ self: self_0 })=>{
                const closestEdge_0 = (0, $2WHHL.extractClosestEdge)(self_0.data);
                setDraggableState((current)=>{
                    if (current.type === 'is-dragging-over' && current.closestEdge === closestEdge_0) return current;
                    return {
                        type: 'is-dragging-over',
                        closestEdge: closestEdge_0
                    };
                });
            },
            onDragLeave: ()=>{
                setDraggableState($55b77b963efcc3f6$var$idle);
            },
            onDrop: ()=>{
                setDraggableState($55b77b963efcc3f6$var$idle);
                setDraggedItem();
            }
        }));
    }, [
        item,
        index,
        setDraggedItem,
        setIsDragHandleFocused
    ]);
    const isDragging = draggableState.type === 'is-dragging';
    const handleMove = (sourceIndex, targetIndex)=>{
        setDraggedItem();
        setIsDragHandleFocused(false);
        swapItems(sourceIndex, targetIndex);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        grow: "fill",
        alignBlock: "stretch",
        xcss: [
            shouldUseCardV2UI ? $55b77b963efcc3f6$var$itemContainerV2 : $55b77b963efcc3f6$var$itemContainer
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        ref: ref,
        alignInline: "start",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        alignInline: "stretch",
        xcss: $55b77b963efcc3f6$var$draggableContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fec75a069994527c$export$d87bd93dda5de125), {
        isDragging: isDragging,
        isDragHandleFocused: isDragHandleFocused,
        isFirst: isFirstItem,
        isLast: isLastItem,
        onMoveDown: ()=>{
            handleMove(index, index + 1);
        },
        onMoveUp: ()=>{
            handleMove(index, index - 1);
        },
        setIsDragHandleFocused: setIsDragHandleFocused,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            isDragging && $55b77b963efcc3f6$var$itemDisabled,
            $55b77b963efcc3f6$var$draggableContent
        ]
    }, children), draggableState.type === 'is-dragging-over' && draggableState.closestEdge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2n8po.DropIndicator), {
        edge: draggableState.closestEdge,
        ...!shouldUseCardV2UI && {
            gap: "var(--ds-space-200, 16px)"
        }
    }) : null))), draggableState.type === 'preview' && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $55b77b963efcc3f6$var$itemPreview
    }, headerTitle), draggableState.container));
};
function $55b77b963efcc3f6$var$_temp() {
    return true;
}





const $0f333c30497d4bf4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    collapseCardLabel: {
        id: "company-hub.company-hub-common.link-cards.card.collapse.label",
        defaultMessage: "Collapse card"
    },
    expandCardLabel: {
        id: "company-hub.company-hub-common.link-cards.card.expand.label",
        defaultMessage: "Expand card"
    },
    removeCardLabel: {
        id: "company-hub.company-hub-common.link-cards.card.remove.card.label",
        defaultMessage: "Remove card"
    },
    cardTitle: {
        id: "company-hub.company-hub-common.link-cards.card.title",
        defaultMessage: "Card {order}"
    },
    // Items can be referred to as "cards" (link cards extension) or "frames" (carousel v2)
    collapseItemLabel: {
        id: "company-hub.company-hub-common.shared-components.item.collapse.label",
        defaultMessage: "{itemLabel, select, card {Collapse card} frame {Collapse frame} other {Collapse card}}"
    },
    expandItemLabel: {
        id: "company-hub.company-hub-common.shared-components.item.expand.label",
        defaultMessage: "{itemLabel, select, card {Expand card} frame {Expand frame} other {Expand card}}"
    },
    removeItemLabel: {
        id: "company-hub.company-hub-common.shared-components.item.remove.label",
        defaultMessage: "{itemLabel, select, card {Remove card} frame {Remove frame} other {Remove card}}"
    },
    itemTitle: {
        id: "company-hub.company-hub-common.shared-components.item.title",
        defaultMessage: "{itemLabel, select, card {Card {order}} frame {Frame {order}} other {Card {order}}}"
    }
});


var $4dd3a2a96c820c98$export$2bc99c3a07d4b9fd = /*#__PURE__*/ function(ITEM_LABEL) {
    ITEM_LABEL["CARD"] = "card";
    ITEM_LABEL["FRAME"] = "frame";
    return ITEM_LABEL;
}({});
const $4dd3a2a96c820c98$var$iconColors = {
    hoverActive: "var(--ds-icon-danger, #C9372C)",
    default: "var(--ds-icon-subtle, #505258)",
    disabled: "var(--ds-text-disabled, #080F214A)"
};
const $4dd3a2a96c820c98$var$removeActiveStyles = (0, $ecnYn.xcss)({
    ':hover': {
        background: "var(--ds-background-danger, #FFECEB)",
        color: 'color.text.danger'
    },
    ':focus': {
        background: "var(--ds-background-danger, #FFECEB)",
        color: 'color.text.danger'
    }
});
const $4dd3a2a96c820c98$var$removeButtonStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    borderRadius: 'radius.small',
    display: 'flex',
    height: '32px',
    justifyContent: 'center'
});
const $4dd3a2a96c820c98$var$dragHandleFocusedWrapperStyles = (0, $ecnYn.xcss)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
});
const $4dd3a2a96c820c98$var$removeHoveredWrapperStyles = (0, $ecnYn.xcss)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-danger, #E2483D)"}`
});
const $4dd3a2a96c820c98$var$collapsibleStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    outline: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $4dd3a2a96c820c98$var$collapsibleStylesV2 = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $4dd3a2a96c820c98$var$collapsibleTriggerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.0',
    paddingRight: 'space.200',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    ':focus': {
        borderRadius: 'radius.small'
    },
    width: '100%'
});
const $4dd3a2a96c820c98$var$collapsibleTriggerStylesV2 = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    width: '100%'
});
const $4dd3a2a96c820c98$var$collapsibleContentStyles = (0, $ecnYn.xcss)({
    width: '100%',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    paddingTop: 'space.050',
    paddingBottom: 'space.150'
});
const $4dd3a2a96c820c98$var$collapsibleContentStylesV2 = (0, $ecnYn.xcss)({
    width: '100%',
    paddingLeft: 'space.050',
    paddingRight: 'space.0',
    paddingTop: 'space.050',
    paddingBottom: 'space.150'
});
const $4dd3a2a96c820c98$export$6d08773d2e66f8f2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(89);
    const { actionSubjectIdPostFix: actionSubjectIdPostFix, analyticsSource: analyticsSource, itemParameters: itemParameters, canDeleteItem: t1, isDeleteDisabled: isDeleteDisabled, isExpanded: isExpanded, isFirstItem: isFirstItem, isLastItem: isLastItem, onBlur: onBlur, onFocus: onFocus, order: order, removeItem: removeItem, setDraggedItem: setDraggedItem, setExpandedItem: setExpandedItem, swapItems: swapItems, shouldUseCardV2UI: t2, itemLabel: t3, renderItemContent: renderItemContent } = t0;
    const canDeleteItem = t1 === undefined ? true : t1;
    const shouldUseCardV2UI = t2 === undefined ? false : t2;
    const itemLabel = t3 === undefined ? "card" : t3;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const itemRef = (0, $42omo.useRef)(null);
    const [t4, t5] = (0, $g3LxX.useExtensionsState)();
    const { isInAutoFocusMode: isInAutoFocusMode, selectedToRemoveCardId: selectedToRemoveCardId } = t4;
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToRemoveCardId: setSelectedToRemoveCardId } = t5;
    const CollapsedCardIcon = shouldUseCardV2UI ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const { cardId: cardId, title: title } = itemParameters;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isItemDisabled = (0, $3v7tz.useIsDisabledContext)();
    let t6;
    if ($[0] !== actionSubjectIdPostFix || $[1] !== analyticsSource || $[2] !== cardId || $[3] !== createAnalyticsEvent || $[4] !== removeItem) {
        t6 = ()=>{
            removeItem(cardId);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: `delete${actionSubjectIdPostFix}`,
                    source: analyticsSource
                }
            }).fire();
        };
        $[0] = actionSubjectIdPostFix;
        $[1] = analyticsSource;
        $[2] = cardId;
        $[3] = createAnalyticsEvent;
        $[4] = removeItem;
        $[5] = t6;
    } else t6 = $[5];
    const onRemove = t6;
    const isSelectedToRemove = selectedToRemoveCardId === cardId;
    let removeButtonColor;
    if (isDeleteDisabled || isItemDisabled) removeButtonColor = $4dd3a2a96c820c98$var$iconColors.disabled;
    else if (isSelectedToRemove) removeButtonColor = $4dd3a2a96c820c98$var$iconColors.hoverActive;
    else removeButtonColor = $4dd3a2a96c820c98$var$iconColors.default;
    const [isDragHandleFocused, setIsDragHandleFocused] = (0, $42omo.useState)(false);
    const isRemoveDisabled = isDeleteDisabled || isItemDisabled;
    let t7;
    if ($[6] !== cardId || $[7] !== isRemoveDisabled || $[8] !== setSelectedToRemoveCardId) {
        t7 = ()=>{
            !isRemoveDisabled && setSelectedToRemoveCardId(cardId);
        };
        $[6] = cardId;
        $[7] = isRemoveDisabled;
        $[8] = setSelectedToRemoveCardId;
        $[9] = t7;
    } else t7 = $[9];
    const selectItemToRemove = t7;
    let t8;
    if ($[10] !== setSelectedToRemoveCardId) {
        t8 = ()=>{
            setSelectedToRemoveCardId(null);
        };
        $[10] = setSelectedToRemoveCardId;
        $[11] = t8;
    } else t8 = $[11];
    const unselectItemToRemove = t8;
    let t9;
    if ($[12] !== isRemoveDisabled || $[13] !== onRemove || $[14] !== selectItemToRemove || $[15] !== unselectItemToRemove) {
        t9 = {
            isDisabled: isRemoveDisabled,
            onClick: onRemove,
            onMouseOver: selectItemToRemove,
            onFocus: selectItemToRemove,
            onMouseOut: unselectItemToRemove,
            onBlur: unselectItemToRemove
        };
        $[12] = isRemoveDisabled;
        $[13] = onRemove;
        $[14] = selectItemToRemove;
        $[15] = unselectItemToRemove;
        $[16] = t9;
    } else t9 = $[16];
    const removeItemProps = t9;
    let t10;
    if ($[17] !== analyticsSource || $[18] !== cardId || $[19] !== createAnalyticsEvent || $[20] !== isExpanded || $[21] !== setExpandedItem || $[22] !== setIsInAutoFocusMode) {
        t10 = ()=>{
            setIsInAutoFocusMode(true);
            setExpandedItem(isExpanded ? "" : cardId);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: isExpanded ? "collapsed" : "expanded",
                    actionSubject: "card",
                    actionSubjectId: "cardCollapsible",
                    source: analyticsSource
                }
            }).fire();
        };
        $[17] = analyticsSource;
        $[18] = cardId;
        $[19] = createAnalyticsEvent;
        $[20] = isExpanded;
        $[21] = setExpandedItem;
        $[22] = setIsInAutoFocusMode;
        $[23] = t10;
    } else t10 = $[23];
    const onCollapsibleTriggerClick = t10;
    let t11;
    let t12;
    if ($[24] !== isExpanded || $[25] !== isInAutoFocusMode) {
        t11 = ()=>{
            if (isExpanded && itemRef.current && isInAutoFocusMode) itemRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        };
        t12 = [
            isExpanded,
            itemRef,
            isInAutoFocusMode
        ];
        $[24] = isExpanded;
        $[25] = isInAutoFocusMode;
        $[26] = t11;
        $[27] = t12;
    } else {
        t11 = $[26];
        t12 = $[27];
    }
    (0, $42omo.useEffect)(t11, t12);
    let collapseLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).collapseCardLabel;
    let expandLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).expandCardLabel;
    let removeLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).removeCardLabel;
    let t13;
    if ($[28] !== formatMessage || $[29] !== order) {
        t13 = formatMessage((0, $0f333c30497d4bf4$export$defe85febe8b728c).cardTitle, {
            order: order
        });
        $[28] = formatMessage;
        $[29] = order;
        $[30] = t13;
    } else t13 = $[30];
    let headerTitle = t13;
    if (itemLabel === "frame") {
        collapseLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).collapseItemLabel;
        expandLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).expandItemLabel;
        removeLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).removeItemLabel;
        let t14;
        if ($[31] !== formatMessage || $[32] !== itemLabel || $[33] !== order) {
            t14 = formatMessage((0, $0f333c30497d4bf4$export$defe85febe8b728c).itemTitle, {
                itemLabel: itemLabel,
                order: order
            });
            $[31] = formatMessage;
            $[32] = itemLabel;
            $[33] = order;
            $[34] = t14;
        } else t14 = $[34];
        headerTitle = t14;
    }
    headerTitle = title || headerTitle;
    const t14 = shouldUseCardV2UI ? $4dd3a2a96c820c98$var$collapsibleStylesV2 : $4dd3a2a96c820c98$var$collapsibleStyles;
    const t15 = isSelectedToRemove && !isRemoveDisabled && !shouldUseCardV2UI ? $4dd3a2a96c820c98$var$removeHoveredWrapperStyles : isDragHandleFocused && $4dd3a2a96c820c98$var$dragHandleFocusedWrapperStyles;
    let t16;
    if ($[35] !== t14 || $[36] !== t15) {
        t16 = [
            t14,
            t15
        ];
        $[35] = t14;
        $[36] = t15;
        $[37] = t16;
    } else t16 = $[37];
    const t17 = order - 1;
    const t18 = shouldUseCardV2UI ? $4dd3a2a96c820c98$var$collapsibleTriggerStylesV2 : $4dd3a2a96c820c98$var$collapsibleTriggerStyles;
    let t19;
    if ($[38] !== t18) {
        t19 = [
            t18
        ];
        $[38] = t18;
        $[39] = t19;
    } else t19 = $[39];
    const t20 = shouldUseCardV2UI ? "medium" : undefined;
    const t21 = shouldUseCardV2UI ? "semibold" : undefined;
    let t22;
    if ($[40] !== headerTitle || $[41] !== t20 || $[42] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text",
            size: t20,
            weight: t21,
            maxLines: 1
        }, headerTitle);
        $[40] = headerTitle;
        $[41] = t20;
        $[42] = t21;
        $[43] = t22;
    } else t22 = $[43];
    let t23;
    if ($[44] !== CollapsedCardIcon || $[45] !== collapseLabel || $[46] !== expandLabel || $[47] !== formatMessage || $[48] !== isExpanded) {
        t23 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            color: "var(--ds-text-subtle, #505258)",
            label: formatMessage(collapseLabel),
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CollapsedCardIcon, {
            color: "var(--ds-text-subtle, #505258)",
            label: formatMessage(expandLabel),
            size: "small"
        });
        $[44] = CollapsedCardIcon;
        $[45] = collapseLabel;
        $[46] = expandLabel;
        $[47] = formatMessage;
        $[48] = isExpanded;
        $[49] = t23;
    } else t23 = $[49];
    let t24;
    if ($[50] !== t22 || $[51] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            spread: "space-between",
            space: "space.050"
        }, t22, t23);
        $[50] = t22;
        $[51] = t23;
        $[52] = t24;
    } else t24 = $[52];
    let t25;
    if ($[53] !== onBlur || $[54] !== onCollapsibleTriggerClick || $[55] !== onFocus || $[56] !== t19 || $[57] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            onClick: onCollapsibleTriggerClick,
            onBlur: onBlur,
            onFocus: onFocus,
            backgroundColor: "color.background.neutral.subtle",
            xcss: t19
        }, t24);
        $[53] = onBlur;
        $[54] = onCollapsibleTriggerClick;
        $[55] = onFocus;
        $[56] = t19;
        $[57] = t24;
        $[58] = t25;
    } else t25 = $[58];
    let t26;
    if ($[59] !== headerTitle || $[60] !== isDragHandleFocused || $[61] !== isFirstItem || $[62] !== isLastItem || $[63] !== itemParameters || $[64] !== onBlur || $[65] !== onFocus || $[66] !== setDraggedItem || $[67] !== shouldUseCardV2UI || $[68] !== swapItems || $[69] !== t17 || $[70] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $55b77b963efcc3f6$export$f115a0a419405ac5), {
            index: t17,
            item: itemParameters,
            headerTitle: headerTitle,
            isDragHandleFocused: isDragHandleFocused,
            isFirstItem: isFirstItem,
            isLastItem: isLastItem,
            setDraggedItem: setDraggedItem,
            setIsDragHandleFocused: setIsDragHandleFocused,
            swapItems: swapItems,
            shouldUseCardV2UI: shouldUseCardV2UI,
            onFocus: onFocus,
            onBlur: onBlur
        }, t25);
        $[59] = headerTitle;
        $[60] = isDragHandleFocused;
        $[61] = isFirstItem;
        $[62] = isLastItem;
        $[63] = itemParameters;
        $[64] = onBlur;
        $[65] = onFocus;
        $[66] = setDraggedItem;
        $[67] = shouldUseCardV2UI;
        $[68] = swapItems;
        $[69] = t17;
        $[70] = t25;
        $[71] = t26;
    } else t26 = $[71];
    let t27;
    if ($[72] !== canDeleteItem || $[73] !== formatMessage || $[74] !== isExpanded || $[75] !== isItemDisabled || $[76] !== isRemoveDisabled || $[77] !== itemLabel || $[78] !== itemParameters || $[79] !== removeButtonColor || $[80] !== removeItemProps || $[81] !== removeLabel || $[82] !== renderItemContent || $[83] !== shouldUseCardV2UI) {
        t27 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            direction: "column",
            xcss: [
                shouldUseCardV2UI ? $4dd3a2a96c820c98$var$collapsibleContentStylesV2 : $4dd3a2a96c820c98$var$collapsibleContentStyles
            ],
            testId: "item-content"
        }, renderItemContent(itemParameters, isItemDisabled), canDeleteItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            ...removeItemProps,
            xcss: [
                $4dd3a2a96c820c98$var$removeButtonStyles,
                !isRemoveDisabled && $4dd3a2a96c820c98$var$removeActiveStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            columnGap: "space.050",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
            color: removeButtonColor,
            label: formatMessage(removeLabel, {
                itemLabel: itemLabel
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...removeLabel,
            values: {
                itemLabel: itemLabel
            }
        }))));
        $[72] = canDeleteItem;
        $[73] = formatMessage;
        $[74] = isExpanded;
        $[75] = isItemDisabled;
        $[76] = isRemoveDisabled;
        $[77] = itemLabel;
        $[78] = itemParameters;
        $[79] = removeButtonColor;
        $[80] = removeItemProps;
        $[81] = removeLabel;
        $[82] = renderItemContent;
        $[83] = shouldUseCardV2UI;
        $[84] = t27;
    } else t27 = $[84];
    let t28;
    if ($[85] !== t16 || $[86] !== t26 || $[87] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            xcss: t16,
            testId: "item-wrapper",
            ref: itemRef,
            grow: "fill",
            alignBlock: "center",
            alignInline: "start"
        }, t26, t27);
        $[85] = t16;
        $[86] = t26;
        $[87] = t27;
        $[88] = t28;
    } else t28 = $[88];
    return t28;
} : ({ actionSubjectIdPostFix: actionSubjectIdPostFix, analyticsSource: analyticsSource, itemParameters: itemParameters, canDeleteItem: canDeleteItem = true, isDeleteDisabled: isDeleteDisabled, isExpanded: isExpanded, isFirstItem: isFirstItem, isLastItem: isLastItem, onBlur: onBlur, onFocus: onFocus, order: order, removeItem: removeItem, setDraggedItem: setDraggedItem, setExpandedItem: setExpandedItem, swapItems: swapItems, shouldUseCardV2UI: shouldUseCardV2UI = false, itemLabel: itemLabel = "card", renderItemContent: renderItemContent })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const itemRef = (0, $42omo.useRef)(null);
    const [{ isInAutoFocusMode: isInAutoFocusMode, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToRemoveCardId: setSelectedToRemoveCardId }] = (0, $g3LxX.useExtensionsState)();
    const CollapsedCardIcon = shouldUseCardV2UI ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const { cardId: cardId, title: title } = itemParameters;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isItemDisabled = (0, $3v7tz.useIsDisabledContext)();
    const onRemove = (0, $42omo.useCallback)(()=>{
        removeItem(cardId);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `delete${actionSubjectIdPostFix}`,
                source: analyticsSource
            }
        }).fire();
    }, [
        cardId,
        removeItem,
        createAnalyticsEvent,
        analyticsSource,
        actionSubjectIdPostFix
    ]);
    const isSelectedToRemove = selectedToRemoveCardId === cardId;
    let removeButtonColor;
    if (isDeleteDisabled || isItemDisabled) removeButtonColor = $4dd3a2a96c820c98$var$iconColors.disabled;
    else if (isSelectedToRemove) removeButtonColor = $4dd3a2a96c820c98$var$iconColors.hoverActive;
    else removeButtonColor = $4dd3a2a96c820c98$var$iconColors.default;
    const [isDragHandleFocused, setIsDragHandleFocused] = (0, $42omo.useState)(false);
    const isRemoveDisabled = isDeleteDisabled || isItemDisabled;
    const selectItemToRemove = (0, $42omo.useCallback)(()=>{
        !isRemoveDisabled && setSelectedToRemoveCardId(cardId);
    }, [
        isRemoveDisabled,
        cardId,
        setSelectedToRemoveCardId
    ]);
    const unselectItemToRemove = (0, $42omo.useCallback)(()=>{
        setSelectedToRemoveCardId(null);
    }, [
        setSelectedToRemoveCardId
    ]);
    const removeItemProps = {
        isDisabled: isRemoveDisabled,
        onClick: onRemove,
        onMouseOver: selectItemToRemove,
        onFocus: selectItemToRemove,
        onMouseOut: unselectItemToRemove,
        onBlur: unselectItemToRemove
    };
    const onCollapsibleTriggerClick = ()=>{
        setIsInAutoFocusMode(true);
        setExpandedItem(isExpanded ? '' : cardId);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: isExpanded ? 'collapsed' : 'expanded',
                actionSubject: 'card',
                actionSubjectId: 'cardCollapsible',
                source: analyticsSource
            }
        }).fire();
    };
    (0, $42omo.useEffect)(()=>{
        if (isExpanded && itemRef.current && isInAutoFocusMode) itemRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, [
        isExpanded,
        itemRef,
        isInAutoFocusMode
    ]);
    let collapseLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).collapseCardLabel, expandLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).expandCardLabel, removeLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).removeCardLabel, headerTitle = formatMessage((0, $0f333c30497d4bf4$export$defe85febe8b728c).cardTitle, {
        order: order
    });
    if (itemLabel === "frame") {
        // @TODO, switch over to these messages unconditionally once
        // translations are available. The itemLabel context
        // is provided for correct string selection.
        collapseLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).collapseItemLabel;
        expandLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).expandItemLabel;
        removeLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).removeItemLabel;
        headerTitle = formatMessage((0, $0f333c30497d4bf4$export$defe85febe8b728c).itemTitle, {
            itemLabel: itemLabel,
            order: order
        });
    }
    headerTitle = title || headerTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: [
            shouldUseCardV2UI ? $4dd3a2a96c820c98$var$collapsibleStylesV2 : $4dd3a2a96c820c98$var$collapsibleStyles,
            isSelectedToRemove && !isRemoveDisabled && !shouldUseCardV2UI ? $4dd3a2a96c820c98$var$removeHoveredWrapperStyles : isDragHandleFocused && $4dd3a2a96c820c98$var$dragHandleFocusedWrapperStyles
        ],
        testId: "item-wrapper",
        ref: itemRef,
        grow: "fill",
        alignBlock: "center",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $55b77b963efcc3f6$export$f115a0a419405ac5), {
        index: order - 1,
        item: itemParameters,
        headerTitle: headerTitle,
        isDragHandleFocused: isDragHandleFocused,
        isFirstItem: isFirstItem,
        isLastItem: isLastItem,
        setDraggedItem: setDraggedItem,
        setIsDragHandleFocused: setIsDragHandleFocused,
        swapItems: swapItems,
        shouldUseCardV2UI: shouldUseCardV2UI,
        onFocus: onFocus,
        onBlur: onBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: onCollapsibleTriggerClick,
        onBlur: onBlur,
        onFocus: onFocus,
        backgroundColor: "color.background.neutral.subtle",
        xcss: [
            shouldUseCardV2UI ? $4dd3a2a96c820c98$var$collapsibleTriggerStylesV2 : $4dd3a2a96c820c98$var$collapsibleTriggerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text",
        size: shouldUseCardV2UI ? 'medium' : undefined,
        weight: shouldUseCardV2UI ? 'semibold' : undefined,
        maxLines: 1
    }, headerTitle), isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
        color: "var(--ds-text-subtle, #505258)",
        label: formatMessage(collapseLabel),
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CollapsedCardIcon, {
        color: "var(--ds-text-subtle, #505258)",
        label: formatMessage(expandLabel),
        size: "small"
    })))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column",
        xcss: [
            shouldUseCardV2UI ? $4dd3a2a96c820c98$var$collapsibleContentStylesV2 : $4dd3a2a96c820c98$var$collapsibleContentStyles
        ],
        testId: "item-content"
    }, renderItemContent(itemParameters, isItemDisabled), canDeleteItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        ...removeItemProps,
        xcss: [
            $4dd3a2a96c820c98$var$removeButtonStyles,
            !isRemoveDisabled && $4dd3a2a96c820c98$var$removeActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        columnGap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
        color: removeButtonColor,
        label: formatMessage(removeLabel, {
            itemLabel: itemLabel
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...removeLabel,
        values: {
            itemLabel: itemLabel
        }
    })))));
};
module.exports["ITEM_LABEL"] = $4dd3a2a96c820c98$export$2bc99c3a07d4b9fd;
module.exports["Item"] = $4dd3a2a96c820c98$export$6d08773d2e66f8f2;

});

parcelRegister("izxBd", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");


var $2Maq7 = parcelRequire("2Maq7");


var $eNm9g = parcelRequire("eNm9g");

const $b55fc346907dc922$export$549037637b109d47 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (items)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [initialUnsplashResults, setInitialUnsplashResults] = (0, $42omo.useState)(t0);
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    let t1;
    if ($[1] !== initialUnsplashResults?.length || $[2] !== submitError) {
        t1 = ()=>{
            if (initialUnsplashResults?.length === 0) (0, $eNm9g.getUnsplashPhotos)((0, $2Maq7.DEFAULT_UNSPLASH_QUERY_WORD), 1, submitError).then((result)=>{
                setInitialUnsplashResults(result);
            }).catch((_error)=>{
                setInitialUnsplashResults(undefined);
            });
        };
        $[1] = initialUnsplashResults?.length;
        $[2] = submitError;
        $[3] = t1;
    } else t1 = $[3];
    const loadInitialUnsplashResults = t1;
    let t2;
    if ($[4] !== items?.length || $[5] !== loadInitialUnsplashResults) {
        t2 = ()=>{
            if (items?.length > 0) loadInitialUnsplashResults();
        };
        $[4] = items?.length;
        $[5] = loadInitialUnsplashResults;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== items || $[8] !== loadInitialUnsplashResults) {
        t3 = [
            loadInitialUnsplashResults,
            items
        ];
        $[7] = items;
        $[8] = loadInitialUnsplashResults;
        $[9] = t3;
    } else t3 = $[9];
    (0, $42omo.useEffect)(t2, t3);
    return initialUnsplashResults;
} : (items)=>{
    const [initialUnsplashResults, setInitialUnsplashResults] = (0, $42omo.useState)([]);
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const loadInitialUnsplashResults = (0, $42omo.useCallback)(()=>{
        if (initialUnsplashResults?.length === 0) (0, $eNm9g.getUnsplashPhotos)((0, $2Maq7.DEFAULT_UNSPLASH_QUERY_WORD), 1, submitError).then((result)=>{
            setInitialUnsplashResults(result);
        }).catch((_error)=>{
            setInitialUnsplashResults(undefined);
        });
    }, [
        initialUnsplashResults,
        setInitialUnsplashResults,
        submitError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (items?.length > 0) loadInitialUnsplashResults();
    }, [
        loadInitialUnsplashResults,
        items
    ]);
    return initialUnsplashResults;
};
module.exports["useInitialUnsplashResults"] = $b55fc346907dc922$export$549037637b109d47;

});

parcelRegister("7XNwX", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1Whri = parcelRequire("1Whri");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $1oCLl = parcelRequire("1oCLl");


var $e1Ppq = parcelRequire("e1Ppq");


var $4cOi8 = parcelRequire("4cOi8");


var $lEBwV = parcelRequire("lEBwV");




const $554da5c3d4e48b76$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    imageLabel: {
        id: "company-hub.company-hub-common.link-cards.card.image.section.label",
        defaultMessage: "Image"
    },
    aiGenerationErrorFlagTitle: {
        id: "company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.title",
        defaultMessage: "We couldn't generate your image"
    },
    aiGenerationErrorFlagDescription: {
        id: "company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.description",
        defaultMessage: "Try again or choose a different image."
    },
    aiGenerationErrorFlagDescriptionWithReason: {
        id: "company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.description-with-reason",
        defaultMessage: "{errorReason}. Try again or choose a different image."
    }
});


const $f24cb80f13977578$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $f24cb80f13977578$var$styles = {
    fieldWrapper: "_19pkpxbi"
};
const $f24cb80f13977578$export$d8d17c714ce39824 = ({ analyticsSource: analyticsSource, itemId: itemId, contentId: contentId, imageSrc: imageSrc, imageAltText: imageAltText, updateItemFormField: updateItemFormField, shouldAllowLinkFromUrl: shouldAllowLinkFromUrl = false })=>{
    // Gate the Premium Extensions image generation experiment behind the
    // `confluence-ai` feature so that AI-related UI is suppressed for IC
    // (Isolated Cloud) tenants where Confluence AI is not available.
    const isAiImgGenEnabled = (0, $1oCLl.expValEquals)($f24cb80f13977578$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true) && (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    const { generateImage: generateImage, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, error: aiHeaderImageError } = (0, $e1Ppq.useAIGeneratedCoverImage)({
        contentId: contentId
    });
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isAiHeaderImageLoading = (aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW') && !aiHeaderImageFileId; // Fire an analytics event when an AI-generated header image has been
    // produced successfully. We fire once per generation by tracking when
    // `aiHeaderImageFileId` transitions from falsy to truthy. Mirrors the
    // `headerImageAdded` analytics fired by Confluence's
    // EditorPageCoverPicture.handleAIGeneratedUpload, but adapted for the
    // company hub config panel.
    const prevAIHeaderImageFileIdRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!isAiImgGenEnabled) {
            prevAIHeaderImageFileIdRef.current = aiHeaderImageFileId;
            return;
        }
        const prevFileId = prevAIHeaderImageFileIdRef.current;
        const isNewFileId = !prevFileId && !!aiHeaderImageFileId;
        prevAIHeaderImageFileIdRef.current = aiHeaderImageFileId;
        if (!isNewFileId) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'added',
                actionSubject: 'image',
                actionSubjectId: 'companyHubImageAdded',
                source: analyticsSource,
                attributes: {
                    imageSource: 'aiGenerated',
                    imageId: aiHeaderImageFileId,
                    inputMethod: 'configPanel',
                    aiHeaderImageStatus: aiHeaderImageStatus,
                    isAIImgGenEnabled: isAiImgGenEnabled
                }
            }
        }).fire();
    }, [
        aiHeaderImageFileId,
        aiHeaderImageStatus,
        isAiImgGenEnabled,
        createAnalyticsEvent,
        analyticsSource
    ]);
    // Surface a flag to the user when AI image generation fails. We only fire
    // when the status transitions INTO `ERROR` (mirroring the Confluence header
    // image behaviour in EditorPageCoverPicture) so re-renders while already in
    // the error state don't produce duplicate flags.
    //
    // Each fire uses a unique flag `id` so that consecutive failures STACK in
    // the flag tray (matching the Confluence header image behaviour) rather
    // than replacing the previous flag — ADS `useFlags` dedupes by `id`.
    const prevAIHeaderImageStatusRef = (0, $42omo.useRef)(null);
    const aiGenerationErrorFlagCounterRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        if (!isAiImgGenEnabled) {
            prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
            return;
        }
        const prevStatus = prevAIHeaderImageStatusRef.current;
        const isTransitioningToError = prevStatus !== 'ERROR' && aiHeaderImageStatus === 'ERROR';
        prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
        if (!isTransitioningToError) return;
        const description = aiHeaderImageError ? formatMessage((0, $554da5c3d4e48b76$export$defe85febe8b728c).aiGenerationErrorFlagDescriptionWithReason, {
            errorReason: aiHeaderImageError
        }) : formatMessage((0, $554da5c3d4e48b76$export$defe85febe8b728c).aiGenerationErrorFlagDescription);
        aiGenerationErrorFlagCounterRef.current += 1;
        showFlag({
            id: `company-hub-image-field-ai-generation-error-flag-${aiGenerationErrorFlagCounterRef.current}`,
            title: formatMessage((0, $554da5c3d4e48b76$export$defe85febe8b728c).aiGenerationErrorFlagTitle),
            description: description,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        });
    }, [
        aiHeaderImageStatus,
        aiHeaderImageError,
        isAiImgGenEnabled,
        showFlag,
        formatMessage
    ]);
    const generateImageRef = (0, $42omo.useRef)(generateImage);
    generateImageRef.current = generateImage;
    const generateAndApplyImage = (0, $42omo.useCallback)(async (props)=>{
        const mediaFileId = await generateImageRef.current(props);
        if (mediaFileId) updateItemFormField(itemId, {
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: mediaFileId,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: ''
        });
        return mediaFileId;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        itemId,
        updateItemFormField
    ]);
    const handleChangeImage = (0, $42omo.useCallback)((props)=>{
        const newImageSrc = 'fullSizeImageUrl' in props ? props.fullSizeImageUrl : props.uploadedImageId;
        const newAltText = props.altDescription;
        updateItemFormField(itemId, {
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: newImageSrc,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: newAltText
        });
    }, [
        itemId,
        updateItemFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: (0, $1Whri.cx)($f24cb80f13977578$var$styles.fieldWrapper),
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "center",
        testId: "image-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $554da5c3d4e48b76$export$defe85febe8b728c).imageLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEBwV.MediaPickerSection), {
        shouldAllowLinkFromUrl: shouldAllowLinkFromUrl,
        contentId: contentId,
        image: imageSrc ? {
            imageSrc: imageSrc,
            altText: imageAltText
        } : undefined,
        onChangeImage: handleChangeImage,
        analyticsSource: analyticsSource,
        shouldShowDeleteButton: true,
        generateAIHeaderImage: isAiImgGenEnabled ? generateAndApplyImage : undefined,
        isAiHeaderImageLoading: isAiImgGenEnabled ? isAiHeaderImageLoading : false
    })));
};
module.exports["ImageField"] = $f24cb80f13977578$export$d8d17c714ce39824;

});

parcelRegister("lEBwV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $ghftu = parcelRequire("ghftu");


var $fZtQj = parcelRequire("fZtQj");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");











var $inPa6 = parcelRequire("inPa6");




var $1qfLF = parcelRequire("1qfLF");


var $bfgIy = parcelRequire("bfgIy");


var $gKvd9 = parcelRequire("gKvd9");


var $hw7wB = parcelRequire("hw7wB");


var $gj7hi = parcelRequire("gj7hi");


var $10CSJ = parcelRequire("10CSJ");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");





var $gmg8x = parcelRequire("gmg8x");

var $9e5cdbdc7fbe3d43$exports = {};
$9e5cdbdc7fbe3d43$exports = new URL("DefaultUploadImageBackground.144fddae.jpg", import.meta.url).toString();



var $jD7cj = parcelRequire("jD7cj");


var $jCIc5 = parcelRequire("jCIc5");


var $kHNfU = parcelRequire("kHNfU");











var $jSnXV = parcelRequire("jSnXV");








var $7p4As = parcelRequire("7p4As");


var $fVjjG = parcelRequire("fVjjG");


var $69PnT = parcelRequire("69PnT");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");




var $1s5hv = parcelRequire("1s5hv");


var $4noo5 = parcelRequire("4noo5");


var $azUhE = parcelRequire("azUhE");


var $jqjsu = parcelRequire("jqjsu");




const $d5322b00bbb55dcf$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    buttonText: {
        id: "company-hub.common.media-components.unsplash.unsplash-browser.button.text",
        defaultMessage: "Browse unsplash"
    },
    errorText: {
        id: "company-hub.common.media-components.unsplash.unsplash-browser.error.text",
        defaultMessage: "We had trouble accessing this link. Try again."
    },
    inspirationText: {
        id: "company-hub.common.media-components.media-picker.ui.content.inspiration.text",
        defaultMessage: "Need inspiration?"
    },
    placeholderText: {
        id: "company-hub.common.media-components.media-picker.ui.content.placeholder.text",
        defaultMessage: "Add link from URL"
    }
});


const $89fc6885476c9938$var$styles = {
    elemBeforeInput: "_19bvu2gc",
    elemAfterInput: "_u5f3u2gc"
};
const $89fc6885476c9938$export$31a366db97ea3a6a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { currentUrl: currentUrl, analyticsSource: analyticsSource, handleImageSelection: handleImageSelection, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isFileId = Boolean(currentUrl?.match(/([0-9a-fA-F-]{36})/));
    const showCustomUploadedImage = !!currentUrl && isFileId;
    const [url, setUrl] = (0, $42omo.useState)(showCustomUploadedImage ? "" : currentUrl);
    const [isValidImage, setIsValidImage] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(false);
    let t2;
    if ($[0] !== analyticsSource || $[1] !== createAnalyticsEvent || $[2] !== handleImageSelection) {
        const validateUrl = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(async (urlToValidate)=>{
            const trimmedUrl = urlToValidate.trim();
            if (!trimmedUrl) {
                setError(false);
                setIsValidImage(false);
                return;
            }
            if (!(0, $jqjsu.isValidUrl)(trimmedUrl)) {
                setError(true);
                setIsValidImage(false);
                return;
            }
            const normalizedUrl = (0, $jqjsu.normalizeUrl)(trimmedUrl);
            const isImage = await (0, $jqjsu.isImageURL)(normalizedUrl);
            if (!isImage) {
                setError(true);
                setIsValidImage(false);
                return;
            }
            handleImageSelection({
                fullSizeImageUrl: normalizedUrl,
                altDescription: ""
            });
            setError(false);
            setIsValidImage(true);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "entered",
                    actionSubject: "url",
                    source: analyticsSource,
                    attributes: {
                        imageSource: "BrowseButtonAndLinkInput"
                    }
                }
            }).fire();
        }, 300);
        t2 = (e)=>{
            const newUrl = e.currentTarget.value;
            setUrl(newUrl);
            validateUrl(newUrl);
        };
        $[0] = analyticsSource;
        $[1] = createAnalyticsEvent;
        $[2] = handleImageSelection;
        $[3] = t2;
    } else t2 = $[3];
    const handleUrlInput = t2;
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage((0, $d5322b00bbb55dcf$export$defe85febe8b728c).placeholderText);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $89fc6885476c9938$var$styles.elemBeforeInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isValidImage) {
        t5 = isValidImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $89fc6885476c9938$var$styles.elemAfterInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            spacing: "spacious",
            label: "valid",
            color: "var(--ds-icon-success, #6A9A23)"
        })) : undefined;
        $[7] = isValidImage;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== handleUrlInput || $[10] !== isDisabled || $[11] !== t3 || $[12] !== t5 || $[13] !== url) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            isDisabled: isDisabled,
            onChange: handleUrlInput,
            placeholder: t3,
            elemBeforeInput: t4,
            elemAfterInput: t5,
            value: url
        });
        $[9] = handleUrlInput;
        $[10] = isDisabled;
        $[11] = t3;
        $[12] = t5;
        $[13] = url;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== error) {
        t7 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d5322b00bbb55dcf$export$defe85febe8b728c).errorText));
        $[15] = error;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d5322b00bbb55dcf$export$defe85febe8b728c).inspirationText);
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== isDisabled) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $azUhE.MediaContentHelperMessage), {
            isDisabled: isDisabled,
            helperMessage: t8
        });
        $[18] = isDisabled;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            gap: "space.100",
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d5322b00bbb55dcf$export$defe85febe8b728c).buttonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($69PnT))), {
            label: "",
            size: "small"
        }));
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== isDisabled) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "default",
            href: "https://unsplash.com",
            isDisabled: isDisabled,
            rel: "noopener noreferrer",
            shouldFitContainer: true,
            target: "_blank"
        }, t10);
        $[21] = isDisabled;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t11 || $[24] !== t6 || $[25] !== t7 || $[26] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t6, t7, t9, t11);
        $[23] = t11;
        $[24] = t6;
        $[25] = t7;
        $[26] = t9;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ currentUrl: currentUrl, analyticsSource: analyticsSource, handleImageSelection: handleImageSelection, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isFileId = Boolean(currentUrl?.match(/([0-9a-fA-F-]{36})/));
    const showCustomUploadedImage = !!currentUrl && isFileId;
    const [url, setUrl] = (0, $42omo.useState)(showCustomUploadedImage ? '' : currentUrl);
    const [isValidImage, setIsValidImage] = (0, $42omo.useState)(false); // TODO: submit to error monitoring service once we find CSM use for this
    const [error, setError] = (0, $42omo.useState)(false);
    const validateUrl = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(async (urlToValidate)=>{
        const trimmedUrl = urlToValidate.trim();
        if (!trimmedUrl) {
            setError(false);
            setIsValidImage(false);
            return;
        }
        if (!(0, $jqjsu.isValidUrl)(trimmedUrl)) {
            setError(true);
            setIsValidImage(false);
            return;
        }
        const normalizedUrl = (0, $jqjsu.normalizeUrl)(trimmedUrl);
        const isImage = await (0, $jqjsu.isImageURL)(normalizedUrl);
        if (!isImage) {
            setError(true);
            setIsValidImage(false);
            return;
        }
        handleImageSelection({
            fullSizeImageUrl: normalizedUrl,
            altDescription: ''
        });
        setError(false);
        setIsValidImage(true);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'entered',
                actionSubject: 'url',
                source: analyticsSource,
                attributes: {
                    imageSource: 'BrowseButtonAndLinkInput'
                }
            }
        }).fire();
    }, 300);
    const handleUrlInput = (e)=>{
        const newUrl = e.currentTarget.value;
        setUrl(newUrl);
        validateUrl(newUrl);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        isDisabled: isDisabled,
        onChange: handleUrlInput,
        placeholder: formatMessage((0, $d5322b00bbb55dcf$export$defe85febe8b728c).placeholderText),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $89fc6885476c9938$var$styles.elemBeforeInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            color: "var(--ds-icon, #292A2E)",
            label: ""
        })),
        elemAfterInput: isValidImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $89fc6885476c9938$var$styles.elemAfterInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            spacing: "spacious",
            label: "valid",
            color: "var(--ds-icon-success, #6A9A23)"
        })) : undefined,
        value: url
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d5322b00bbb55dcf$export$defe85febe8b728c).errorText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $azUhE.MediaContentHelperMessage), {
        isDisabled: isDisabled,
        helperMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d5322b00bbb55dcf$export$defe85febe8b728c).inspirationText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "default",
        href: "https://unsplash.com",
        isDisabled: isDisabled,
        rel: "noopener noreferrer",
        shouldFitContainer: true,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        gap: "space.100",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d5322b00bbb55dcf$export$defe85febe8b728c).buttonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($69PnT))), {
        label: "",
        size: "small"
    }))));
};



var $6YdGV = parcelRequire("6YdGV");


var $h3Ebw = parcelRequire("h3Ebw");


var $iqWjJ = parcelRequire("iqWjJ");

var $eVW6V = parcelRequire("eVW6V");


var $h92Kw = parcelRequire("h92Kw");










const $21feb76b65fdb5bb$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    fileUploadButtonText: {
        id: "company-hub.company-hub-common.unsplash.upload.text",
        defaultMessage: "Upload"
    },
    deleteImageButtonText: {
        id: "company-hub.company-hub-common.unsplash.delete.image.text",
        defaultMessage: "Remove image"
    },
    defaultBackgroundImageAltText: {
        id: "company-hub.company-hub-common.unsplash.background-img.default.label",
        defaultMessage: "Default background image for upload previewer"
    }
});


const $101400821b25fad6$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $101400821b25fad6$var$bottomSpacing = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $101400821b25fad6$var$removeBottomSpacing = (0, $ecnYn.xcss)({
    marginBottom: 'space.0'
});
const $101400821b25fad6$var$uploadFileContainer = (0, $ecnYn.xcss)({
    position: 'relative',
    borderRadius: 'radius.large',
    height: '124px',
    width: '100%',
    marginBottom: 'space.100',
    overflow: 'hidden'
});
const $101400821b25fad6$var$uploadFileButton = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: '30%',
    right: '30%',
    bottom: '30%',
    top: '30%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $101400821b25fad6$export$d96ef1145be738e0 = ({ itemId: itemId, elementIdPrefix: elementIdPrefix, sectionLabel: sectionLabel, imageAltText: imageAltText, selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, handleImageSelection: handleImageSelection, contentId: contentId, confluencePageId: confluencePageId, analyticsSource: analyticsSource, isPageTitleComponent: isPageTitleComponent = false, isNoImageAllowed: isNoImageAllowed = false, enableBottomSpacing: enableBottomSpacing = true, placement: placement, dropdownPopupComponentRef: dropdownPopupComponentRef, isDisabled: isDisabled = false, isAiHeaderImageLoading: isAiHeaderImageLoading, helperMessage: helperMessage, shouldShowDeleteButton: shouldShowDeleteButton = false, customMediaConfig: customMediaConfig, shouldAllowLinkFromUrl: shouldAllowLinkFromUrl = false, generateAIHeaderImage: generateAIHeaderImage })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { selectedDefaultImageUrl: selectedDefaultImageUrl, setDefaultUnsplashResults: setDefaultUnsplashResults, defaultUnsplashResults: defaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError, errorMessage: errorMessage } = (0, $eVW6V.useUnsplash)(isPageTitleComponent, selectedImageUrl, initialUnsplashResults);
    const [newUploadedImage, setNewUploadedImage] = (0, $42omo.useState)();
    const handleUploadedImage = (0, $42omo.useCallback)((props)=>{
        setNewUploadedImage(()=>props);
        handleImageSelection(props);
    }, [
        handleImageSelection
    ]);
    const handleAIGenerate = (0, $42omo.useCallback)(async (props_0)=>{
        if (!generateAIHeaderImage) return undefined;
        const mediaFileId = await generateAIHeaderImage(props_0);
        if (mediaFileId) // Mirror the manual upload path so the picker's local state
        // (newUploadedImage) reflects each new AI-generated image,
        // preventing stale renders on re-generation.
        handleUploadedImage({
            uploadedImageId: mediaFileId,
            altDescription: ''
        });
        return mediaFileId;
    }, [
        generateAIHeaderImage,
        handleUploadedImage
    ]);
    const handleDelete = ()=>{
        setNewUploadedImage(undefined);
        handleImageSelection({
            fullSizeImageUrl: '',
            altDescription: ''
        });
    };
    const { showCustomUploadedImage: showCustomUploadedImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: newUploadedImage ? newUploadedImage?.uploadedImageId : selectedDefaultImageUrl || undefined
    });
    const selectedDefaultUploadedImage = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (!selectedDefaultUploadedImage.current && !newUploadedImage && showCustomUploadedImage) selectedDefaultUploadedImage.current = selectedDefaultImageUrl;
    }, [
        newUploadedImage,
        showCustomUploadedImage,
        selectedDefaultImageUrl
    ]);
    const customMediaAuthProvider = (0, $42omo.useMemo)(()=>{
        if (!customMediaConfig) return undefined;
        return ()=>Promise.resolve({
                token: customMediaConfig.mediaToken,
                baseUrl: customMediaConfig.mediaUrl,
                asapIssuer: customMediaConfig.asapIssuer
            });
    }, [
        customMediaConfig
    ]);
    const { mediaConfig: mediaConfig, handleUploadEnd: handleUploadEnd, handleUploadStart: handleUploadStart, handleOnError: handleOnError, isMediaBrowserOpen: isMediaBrowserOpen, openMediaBrowser: openMediaBrowser, closeMediaBrowser: closeMediaBrowser, isUploadingImage: isUploadingImage } = (0, $h92Kw.useUploadMediaConfig)({
        contentId: contentId,
        handleUploadedImageSelection: handleUploadedImage,
        analyticsSource: analyticsSource
    });
    const resolvedCollectionName = (0, $42omo.useMemo)(()=>{
        if (customMediaConfig) return customMediaConfig.mediaCollectionName;
        return mediaConfig?.collection;
    }, [
        customMediaConfig,
        mediaConfig
    ]);
    const resolvedAuthProvider = (0, $42omo.useMemo)(()=>{
        return customMediaConfig ? customMediaAuthProvider : mediaConfig?.authProvider;
    }, [
        customMediaConfig,
        customMediaAuthProvider,
        mediaConfig
    ]);
    const canOpenBrowser = Boolean(resolvedCollectionName && resolvedAuthProvider && openMediaBrowser);
    const handleUploadButtonClick = (0, $42omo.useCallback)(()=>{
        if (!canOpenBrowser) return;
        openMediaBrowser();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'customerImageUploadButton',
                source: analyticsSource
            }
        }).fire();
    }, [
        canOpenBrowser,
        openMediaBrowser,
        createAnalyticsEvent,
        analyticsSource
    ]);
    const unsplashSearchFieldId = itemId ? `${elementIdPrefix}-search-unsplash-${itemId}` : `${elementIdPrefix}-search-unsplash`;
    const initialUnsplashFive = (0, $42omo.useMemo)(()=>defaultUnsplashResults?.slice(0, 5), [
        defaultUnsplashResults
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
        htmlFor: unsplashSearchFieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jCIc5.PanelSubheader), null, sectionLabel)), shouldShowDeleteButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $21feb76b65fdb5bb$export$defe85febe8b728c).deleteImageButtonText),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        onClick: handleDelete,
        isDisabled: isDisabled,
        testId: "remove-image-button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $azUhE.MediaContentHelperMessage), {
        isDisabled: isDisabled,
        helperMessage: helperMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $101400821b25fad6$var$uploadFileContainer
    }, showCustomUploadedImage && !(0, $iqWjJ.isUnsplashImage)(selectedImageUrl) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "custom-image-upload"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kHNfU.CustomImageUploadRenderer), {
        contentId: contentId,
        imageAltText: imageAltText,
        imageSrc: newUploadedImage?.uploadedImageId || selectedDefaultUploadedImage.current,
        mediaConfigOverride: {
            authProvider: customMediaAuthProvider,
            collection: customMediaConfig?.mediaCollectionName
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        height: "124px",
        width: "100%",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9e5cdbdc7fbe3d43$exports))),
        alt: formatMessage((0, $21feb76b65fdb5bb$export$defe85febe8b728c).defaultBackgroundImageAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $101400821b25fad6$var$uploadFileButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleUploadButtonClick,
        isDisabled: isUploadingImage || isDisabled || !canOpenBrowser,
        testId: "open-media-browser",
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($hw7wB)))
    }, formatMessage((0, $21feb76b65fdb5bb$export$defe85febe8b728c).fileUploadButtonText)))), resolvedCollectionName && resolvedAuthProvider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10CSJ.BrowserLoader), {
        mediaClientConfig: {
            authProvider: resolvedAuthProvider,
            useSha256ForUploads: true
        },
        config: {
            multiple: false,
            fileExtensions: [
                '.jpg',
                '.jpeg',
                '.png',
                '.gif'
            ],
            uploadParams: {
                collection: resolvedCollectionName,
                onUploadRejection: mediaConfig?.onUploadRejection
            }
        },
        isOpen: isMediaBrowserOpen,
        onClose: closeMediaBrowser,
        onUploadsStart: handleUploadStart,
        onError: handleOnError,
        onEnd: handleUploadEnd
    }), shouldAllowLinkFromUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $89fc6885476c9938$export$31a366db97ea3a6a), {
        analyticsSource: analyticsSource,
        currentUrl: selectedDefaultImageUrl,
        handleImageSelection: handleImageSelection,
        isDisabled: isDisabled
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3Ebw.UnsplashSearchBar), {
        elementIdPrefix: elementIdPrefix,
        unsplashSearchFieldId: unsplashSearchFieldId,
        handleImageSelection: handleImageSelection,
        analyticsSource: analyticsSource,
        setDefaultUnsplashResults: setDefaultUnsplashResults,
        defaultUnsplashResults: defaultUnsplashResults,
        unSplashSearchResults: unSplashSearchResults,
        setUnsplashSearchResults: setUnsplashSearchResults,
        setError: setError,
        handleError: handleError,
        placement: placement,
        dropdownPopupComponentRef: dropdownPopupComponentRef,
        isUploadingImage: isUploadingImage || isDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: enableBottomSpacing ? $101400821b25fad6$var$bottomSpacing : $101400821b25fad6$var$removeBottomSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6YdGV.DefaultImagePicker), {
        contentId: contentId,
        confluencePageId: confluencePageId,
        initialUnsplashResults: initialUnsplashFive,
        handleImageSelection: handleImageSelection,
        imageAltText: imageAltText,
        previewUploadedImageId: newUploadedImage?.uploadedImageId,
        initialUploadedImageId: selectedDefaultUploadedImage.current,
        selectedImageUrl: selectedDefaultImageUrl,
        analyticsSource: analyticsSource,
        isUploadingImage: isUploadingImage || isDisabled,
        isNoImageAllowed: isNoImageAllowed && !isPageTitleComponent,
        mediaConfigOverride: {
            authProvider: customMediaAuthProvider,
            collection: customMediaConfig?.mediaCollectionName
        }
    }), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jD7cj.FormFieldErrorMessage), null, errorMessage))), (0, $1oCLl.expValEquals)($101400821b25fad6$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true) && (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gmg8x.RovoHeaderImageGenerator), {
        generateAIHeaderImage: generateAIHeaderImage ? handleAIGenerate : undefined,
        isAiHeaderImageLoading: isAiHeaderImageLoading,
        onSubmit: ({ selectedTheme: selectedTheme })=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'companyHubImageGenerationSubmitted',
                    source: analyticsSource,
                    attributes: {
                        selectedTheme: selectedTheme
                    }
                }
            }).fire();
        }
    }));
};





const $08f113053161f1c5$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    mediaPickerContentTitle: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.media-picker-content-title",
        defaultMessage: "Media"
    },
    mediaPickerButtonLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.media-picker-button-label",
        defaultMessage: "Choose media"
    },
    mediaPickerContentHelperMessage: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.mdia-picker-helper-message",
        defaultMessage: "Choose high resolution images 1200px or wider for best results."
    }
});


const $0b87ab78f69513db$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $0b87ab78f69513db$var$styles = {
    mediaPickerPopupContainer: "_1bsbncxg _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
const $0b87ab78f69513db$export$b119da8ecc7e9645 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { onChangeImage: onChangeImage, image: image, contentId: contentId, analyticsSource: analyticsSource, shouldShowDeleteButton: t1, onOpenUpdate: onOpenUpdate, isDisabled: t2, isAiHeaderImageLoading: isAiHeaderImageLoading, customMediaConfig: customMediaConfig, shouldAllowLinkFromUrl: t3, generateAIHeaderImage: generateAIHeaderImage } = t0;
    const shouldShowDeleteButton = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const shouldAllowLinkFromUrl = t3 === undefined ? false : t3;
    const [openPopup, setOpenPopup] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t4;
    if ($[0] !== onOpenUpdate) {
        t4 = (open)=>{
            setOpenPopup(open);
            onOpenUpdate?.(open);
        };
        $[0] = onOpenUpdate;
        $[1] = t4;
    } else t4 = $[1];
    const handleSetOpenPopup = t4;
    const isPremiumImgGenerationEnabled = (0, $1oCLl.expValEquals)($0b87ab78f69513db$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, "isEnabled", true) && (0, $5spQU.isFeatureEnabled)("confluence", "confluence-ai");
    const popupPlacement = isPremiumImgGenerationEnabled ? "top-end" : "bottom-end";
    let t5;
    if ($[2] !== handleSetOpenPopup) {
        t5 = ()=>handleSetOpenPopup(false);
        $[2] = handleSetOpenPopup;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== analyticsSource || $[5] !== contentId || $[6] !== customMediaConfig || $[7] !== generateAIHeaderImage || $[8] !== image?.altText || $[9] !== image?.imageSrc || $[10] !== isAiHeaderImageLoading || $[11] !== isDisabled || $[12] !== onChangeImage || $[13] !== shouldAllowLinkFromUrl || $[14] !== shouldShowDeleteButton) {
        t6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $0b87ab78f69513db$var$styles.mediaPickerPopupContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $101400821b25fad6$export$d96ef1145be738e0), {
                elementIdPrefix: `${analyticsSource}-media-picker`,
                sectionLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $08f113053161f1c5$export$defe85febe8b728c).mediaPickerContentTitle),
                imageAltText: image?.altText,
                selectedImageUrl: image?.imageSrc,
                initialUnsplashResults: undefined,
                handleImageSelection: onChangeImage,
                contentId: contentId,
                analyticsSource: analyticsSource,
                helperMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $08f113053161f1c5$export$defe85febe8b728c).mediaPickerContentHelperMessage),
                shouldShowDeleteButton: shouldShowDeleteButton,
                isDisabled: isDisabled,
                customMediaConfig: customMediaConfig,
                shouldAllowLinkFromUrl: shouldAllowLinkFromUrl,
                generateAIHeaderImage: generateAIHeaderImage,
                isAiHeaderImageLoading: isAiHeaderImageLoading
            }));
        $[4] = analyticsSource;
        $[5] = contentId;
        $[6] = customMediaConfig;
        $[7] = generateAIHeaderImage;
        $[8] = image?.altText;
        $[9] = image?.imageSrc;
        $[10] = isAiHeaderImageLoading;
        $[11] = isDisabled;
        $[12] = onChangeImage;
        $[13] = shouldAllowLinkFromUrl;
        $[14] = shouldShowDeleteButton;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== analyticsSource || $[17] !== formatMessage || $[18] !== handleSetOpenPopup || $[19] !== openPopup) {
        t7 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                analyticsContext: {
                    source: `${analyticsSource}MediaPickerButton`
                },
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))),
                iconAfter: $0b87ab78f69513db$var$_temp,
                onClick: ()=>handleSetOpenPopup(!openPopup),
                "aria-label": formatMessage((0, $08f113053161f1c5$export$defe85febe8b728c).mediaPickerButtonLabel),
                isSelected: openPopup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null));
        $[16] = analyticsSource;
        $[17] = formatMessage;
        $[18] = handleSetOpenPopup;
        $[19] = openPopup;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== openPopup || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
            isOpen: openPopup,
            onClose: t5,
            content: t6,
            placement: popupPlacement,
            trigger: t7
        });
        $[21] = openPopup;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : ({ onChangeImage: onChangeImage, image: image, contentId: contentId, analyticsSource: analyticsSource, shouldShowDeleteButton: shouldShowDeleteButton = false, onOpenUpdate: onOpenUpdate, isDisabled: isDisabled = false, isAiHeaderImageLoading: isAiHeaderImageLoading, customMediaConfig: customMediaConfig, shouldAllowLinkFromUrl: shouldAllowLinkFromUrl = false, generateAIHeaderImage: generateAIHeaderImage })=>{
    const [openPopup, setOpenPopup] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleSetOpenPopup = (open)=>{
        setOpenPopup(open);
        onOpenUpdate?.(open);
    }; // When the Premium Extensions image generation experiment is enabled, the
    // media picker popup should always render above the trigger button. This
    // prevents the panel from being clipped by, or obscuring, content rendered
    // below the trigger in the Company Hub configuration UI.
    // Also gated behind the `confluence-ai` feature so that AI-related UI is
    // suppressed for IC (Isolated Cloud) tenants where Confluence AI is not
    // available.
    const isPremiumImgGenerationEnabled = (0, $1oCLl.expValEquals)($0b87ab78f69513db$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true) && (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    const popupPlacement = isPremiumImgGenerationEnabled ? 'top-end' : 'bottom-end';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        isOpen: openPopup,
        onClose: ()=>handleSetOpenPopup(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $0b87ab78f69513db$var$styles.mediaPickerPopupContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $101400821b25fad6$export$d96ef1145be738e0), {
                elementIdPrefix: `${analyticsSource}-media-picker`,
                sectionLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $08f113053161f1c5$export$defe85febe8b728c).mediaPickerContentTitle),
                imageAltText: image?.altText,
                selectedImageUrl: image?.imageSrc,
                initialUnsplashResults: undefined,
                handleImageSelection: onChangeImage,
                contentId: contentId,
                analyticsSource: analyticsSource,
                helperMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $08f113053161f1c5$export$defe85febe8b728c).mediaPickerContentHelperMessage),
                shouldShowDeleteButton: shouldShowDeleteButton,
                isDisabled: isDisabled,
                customMediaConfig: customMediaConfig,
                shouldAllowLinkFromUrl: shouldAllowLinkFromUrl,
                generateAIHeaderImage: generateAIHeaderImage,
                isAiHeaderImageLoading: isAiHeaderImageLoading
            })),
        placement: popupPlacement,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                analyticsContext: {
                    source: `${analyticsSource}MediaPickerButton`
                },
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))),
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: ()=>handleSetOpenPopup(!openPopup),
                "aria-label": formatMessage((0, $08f113053161f1c5$export$defe85febe8b728c).mediaPickerButtonLabel),
                isSelected: openPopup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null))
    });
};
function $0b87ab78f69513db$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["MediaPickerSection"] = $0b87ab78f69513db$export$b119da8ecc7e9645;

});

parcelRegister("7lwhH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $10CSJ = parcelRequire("10CSJ");


var $1s5hv = parcelRequire("1s5hv");


var $4cOi8 = parcelRequire("4cOi8");


var $hY5v2 = parcelRequire("hY5v2");

var $h92Kw = parcelRequire("h92Kw");




const $5d69590c133cbf20$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    sectionLabel: {
        id: "company-hub.company-hub-common.link-cards.card.image.section.label",
        defaultMessage: "Image"
    }
});


const $8bc4a4109967f242$var$styles = {
    fieldWrapper: "_19pkpxbi"
};
const $8bc4a4109967f242$export$47c17c5f362608ab = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(37);
    const { analyticsSource: analyticsSource, idPrefix: idPrefix, itemId: itemId, confluencePageId: confluencePageId, contentId: contentId, imageSrc: imageSrc, imageAltText: imageAltText, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, updateItemFormField: updateItemFormField } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== itemId || $[1] !== updateItemFormField) {
        t1 = (t2)=>{
            const { fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription } = t2;
            updateItemFormField(itemId, {
                [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: fullSizeImageUrl,
                [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription
            });
        };
        $[0] = itemId;
        $[1] = updateItemFormField;
        $[2] = t1;
    } else t1 = $[2];
    const handleUnsplashImageSelection = t1;
    let t2;
    if ($[3] !== itemId || $[4] !== updateItemFormField) {
        t2 = (t3)=>{
            const { uploadedImageId: uploadedImageId, altDescription: altDescription_0 } = t3;
            updateItemFormField(itemId, {
                [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: uploadedImageId,
                [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription_0
            });
        };
        $[3] = itemId;
        $[4] = updateItemFormField;
        $[5] = t2;
    } else t2 = $[5];
    const handleUploadedImageSelection = t2;
    let t3;
    if ($[6] !== analyticsSource || $[7] !== contentId || $[8] !== handleUploadedImageSelection) {
        t3 = {
            contentId: contentId,
            handleUploadedImageSelection: handleUploadedImageSelection,
            analyticsSource: analyticsSource
        };
        $[6] = analyticsSource;
        $[7] = contentId;
        $[8] = handleUploadedImageSelection;
        $[9] = t3;
    } else t3 = $[9];
    const { mediaConfig: mediaConfig, handleUploadEnd: handleUploadEnd, handleUploadStart: handleUploadStart, handleOnError: handleOnError, isMediaBrowserOpen: isMediaBrowserOpen, openMediaBrowser: openMediaBrowser, closeMediaBrowser: closeMediaBrowser, isUploadingImage: isUploadingImage } = (0, $h92Kw.useUploadMediaConfig)(t3);
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $1Whri.cx)($8bc4a4109967f242$var$styles.fieldWrapper);
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== intl) {
        t5 = intl.formatMessage((0, $5d69590c133cbf20$export$defe85febe8b728c).sectionLabel);
        $[11] = intl;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== analyticsSource || $[14] !== confluencePageId || $[15] !== contentId || $[16] !== handleUnsplashImageSelection || $[17] !== idPrefix || $[18] !== imageAltText || $[19] !== imageSrc || $[20] !== initialUnsplashResults || $[21] !== isNoImageAllowed || $[22] !== isUploadingImage || $[23] !== itemId || $[24] !== openMediaBrowser || $[25] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hY5v2.UnsplashSearch), {
            id: itemId,
            selectedImageUrl: imageSrc,
            imageAltText: imageAltText,
            sectionLabel: t5,
            initialUnsplashResults: initialUnsplashResults,
            idPrefix: idPrefix,
            handleImageSelection: handleUnsplashImageSelection,
            analyticsSource: analyticsSource,
            analyticsActionSubject: "button",
            analyticsActionSubjectId: "customerImageUpload",
            openMediaBrowser: openMediaBrowser,
            contentId: contentId,
            confluencePageId: confluencePageId,
            isUploadingImage: isUploadingImage,
            isNoImageAllowed: isNoImageAllowed
        });
        $[13] = analyticsSource;
        $[14] = confluencePageId;
        $[15] = contentId;
        $[16] = handleUnsplashImageSelection;
        $[17] = idPrefix;
        $[18] = imageAltText;
        $[19] = imageSrc;
        $[20] = initialUnsplashResults;
        $[21] = isNoImageAllowed;
        $[22] = isUploadingImage;
        $[23] = itemId;
        $[24] = openMediaBrowser;
        $[25] = t5;
        $[26] = t6;
    } else t6 = $[26];
    let t7;
    if ($[27] !== closeMediaBrowser || $[28] !== handleOnError || $[29] !== handleUploadEnd || $[30] !== handleUploadStart || $[31] !== isMediaBrowserOpen || $[32] !== mediaConfig) {
        t7 = mediaConfig?.collection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10CSJ.BrowserLoader), {
            mediaClientConfig: {
                authProvider: mediaConfig?.authProvider,
                useSha256ForUploads: true
            },
            config: {
                multiple: false,
                fileExtensions: [
                    ".jpg",
                    ".jpeg",
                    ".png",
                    ".gif"
                ],
                uploadParams: {
                    collection: mediaConfig.collection,
                    onUploadRejection: mediaConfig?.onUploadRejection
                }
            },
            isOpen: isMediaBrowserOpen,
            onClose: closeMediaBrowser,
            onUploadsStart: handleUploadStart,
            onError: handleOnError,
            onEnd: handleUploadEnd
        }) : null;
        $[27] = closeMediaBrowser;
        $[28] = handleOnError;
        $[29] = handleUploadEnd;
        $[30] = handleUploadStart;
        $[31] = isMediaBrowserOpen;
        $[32] = mediaConfig;
        $[33] = t7;
    } else t7 = $[33];
    let t8;
    if ($[34] !== t6 || $[35] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: t4,
            direction: "column"
        }, t6, t7));
        $[34] = t6;
        $[35] = t7;
        $[36] = t8;
    } else t8 = $[36];
    return t8;
} : ({ analyticsSource: analyticsSource, idPrefix: idPrefix, itemId: itemId, confluencePageId: confluencePageId, contentId: contentId, imageSrc: imageSrc, imageAltText: imageAltText, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, updateItemFormField: updateItemFormField })=>{
    const intl = (0, $aXWIB.useIntl)();
    const handleUnsplashImageSelection = (0, $42omo.useCallback)(({ fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription })=>{
        updateItemFormField(itemId, {
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: fullSizeImageUrl,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription
        });
    }, [
        itemId,
        updateItemFormField
    ]);
    const handleUploadedImageSelection = (0, $42omo.useCallback)(({ uploadedImageId: uploadedImageId, altDescription: altDescription_0 })=>{
        updateItemFormField(itemId, {
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: uploadedImageId,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription_0
        });
    }, [
        itemId,
        updateItemFormField
    ]);
    const { mediaConfig: mediaConfig, handleUploadEnd: handleUploadEnd, handleUploadStart: handleUploadStart, handleOnError: handleOnError, isMediaBrowserOpen: isMediaBrowserOpen, openMediaBrowser: openMediaBrowser, closeMediaBrowser: closeMediaBrowser, isUploadingImage: isUploadingImage } = (0, $h92Kw.useUploadMediaConfig)({
        contentId: contentId,
        handleUploadedImageSelection: handleUploadedImageSelection,
        analyticsSource: analyticsSource
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: (0, $1Whri.cx)($8bc4a4109967f242$var$styles.fieldWrapper),
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hY5v2.UnsplashSearch), {
        id: itemId,
        selectedImageUrl: imageSrc,
        imageAltText: imageAltText,
        sectionLabel: intl.formatMessage((0, $5d69590c133cbf20$export$defe85febe8b728c).sectionLabel),
        initialUnsplashResults: initialUnsplashResults,
        idPrefix: idPrefix,
        handleImageSelection: handleUnsplashImageSelection,
        analyticsSource: analyticsSource,
        analyticsActionSubject: "button",
        analyticsActionSubjectId: "customerImageUpload",
        openMediaBrowser: openMediaBrowser,
        contentId: contentId,
        confluencePageId: confluencePageId,
        isUploadingImage: isUploadingImage,
        isNoImageAllowed: isNoImageAllowed
    }), mediaConfig?.collection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10CSJ.BrowserLoader), {
        mediaClientConfig: {
            authProvider: mediaConfig?.authProvider,
            useSha256ForUploads: true
        },
        config: {
            multiple: false,
            fileExtensions: [
                '.jpg',
                '.jpeg',
                '.png',
                '.gif'
            ],
            uploadParams: {
                collection: mediaConfig.collection,
                onUploadRejection: mediaConfig?.onUploadRejection
            }
        },
        isOpen: isMediaBrowserOpen,
        onClose: closeMediaBrowser,
        onUploadsStart: handleUploadStart,
        onError: handleOnError,
        onEnd: handleUploadEnd
    }) : null));
};
module.exports["UnsplashSearchField"] = $8bc4a4109967f242$export$47c17c5f362608ab;

});

parcelRegister("8jjEv", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $1bY7o = parcelRequire("1bY7o");


var $7bZ3i = parcelRequire("7bZ3i");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $hn4RR = parcelRequire("hn4RR");


var $9CM6e = parcelRequire("9CM6e");











var $4iPjq = parcelRequire("4iPjq");


var $5qrxS = parcelRequire("5qrxS");


var $fOKpq = parcelRequire("fOKpq");

const $a01e638968d35f1e$var$supportedPluginKeys = [
    'confluence',
    'jira',
    'atlas',
    'loom'
];
const $a01e638968d35f1e$export$8f5a036ec4993fc5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { cloudId: cloudId, link: link, setIsOpen: setIsOpen, onLinkSelect: onLinkSelect } = t0;
    const { linkPickerConfig: linkPickerConfig } = (0, $fOKpq.useProductDependencies)();
    let t1;
    if ($[0] !== onLinkSelect || $[1] !== setIsOpen) {
        t1 = (payload)=>{
            onLinkSelect(payload);
            setIsOpen(false);
        };
        $[0] = onLinkSelect;
        $[1] = setIsOpen;
        $[2] = t1;
    } else t1 = $[2];
    const handleSubmit = t1;
    let t2;
    if ($[3] !== setIsOpen) {
        t2 = ()=>{
            setIsOpen(false);
        };
        $[3] = setIsOpen;
        $[4] = t2;
    } else t2 = $[4];
    const handleCancel = t2;
    let t3;
    if ($[5] !== cloudId) {
        t3 = {
            cloudId: cloudId,
            product: "confluence"
        };
        $[5] = cloudId;
        $[6] = t3;
    } else t3 = $[6];
    const { isLoading: isLoading, plugins: plugins } = (0, $5qrxS.useLinkPickerPlugins)(t3);
    let t4;
    if ($[7] !== plugins) {
        t4 = plugins.filter($a01e638968d35f1e$var$_temp);
        $[7] = plugins;
        $[8] = t4;
    } else t4 = $[8];
    const filteredPlugins = t4;
    const pluginsToUse = linkPickerConfig?.linkPickerPlugins || filteredPlugins;
    const isLoadingPlugins = linkPickerConfig?.linkPickerPlugins ? false : isLoading;
    let t5;
    if ($[9] !== handleCancel || $[10] !== handleSubmit || $[11] !== isLoadingPlugins || $[12] !== link.url || $[13] !== pluginsToUse) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iPjq.default), {
            plugins: pluginsToUse,
            isLoadingPlugins: isLoadingPlugins,
            url: link.url,
            onSubmit: handleSubmit,
            onCancel: handleCancel,
            hideDisplayText: true
        });
        $[9] = handleCancel;
        $[10] = handleSubmit;
        $[11] = isLoadingPlugins;
        $[12] = link.url;
        $[13] = pluginsToUse;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ cloudId: cloudId, link: link, setIsOpen: setIsOpen, onLinkSelect: onLinkSelect })=>{
    const { linkPickerConfig: linkPickerConfig } = (0, $fOKpq.useProductDependencies)();
    const handleSubmit = (payload)=>{
        onLinkSelect(payload);
        setIsOpen(false);
    };
    const handleCancel = ()=>{
        setIsOpen(false);
    };
    const { isLoading: isLoading, plugins: plugins } = (0, $5qrxS.useLinkPickerPlugins)({
        cloudId: cloudId,
        product: 'confluence'
    });
    const filteredPlugins = (0, $42omo.useMemo)(()=>{
        return plugins.filter((plugin)=>{
            return plugin.tabKey && $a01e638968d35f1e$var$supportedPluginKeys.includes(plugin.tabKey);
        });
    }, [
        plugins
    ]);
    // Use custom plugins if provided, otherwise use default filtered plugins
    const pluginsToUse = linkPickerConfig?.linkPickerPlugins || filteredPlugins;
    const isLoadingPlugins = linkPickerConfig?.linkPickerPlugins ? false : isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iPjq.default), {
        plugins: pluginsToUse,
        isLoadingPlugins: isLoadingPlugins,
        url: link.url,
        onSubmit: handleSubmit,
        onCancel: handleCancel,
        hideDisplayText: true
    });
};
function $a01e638968d35f1e$var$_temp(plugin) {
    return plugin.tabKey && $a01e638968d35f1e$var$supportedPluginKeys.includes(plugin.tabKey);
}





const $647f79795a021064$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    clearIconLabel: {
        id: "company-hub.company-hub-common.link-picker.clear-icon-label",
        defaultMessage: "Clear link selection"
    },
    popupPlaceholderText: {
        id: "company-hub.company-hub-common.link-picker.popup-placeholder-text",
        defaultMessage: "Add any link"
    }
});


const $9a2b125c92105a3b$var$styles = {
    disabled: "_syaz1gmx",
    link: "_p12fmgvx",
    placeholder: "_zulp12x7 _16jlkb7n _1o9zidpf _i0dlf1ug _4cvr1h6o _syazazsu",
    selection: "_18zr1b66 _4cvr1h6o _1bah1yb4 _ca0qze3t _n3tdze3t",
    trigger: "_2rko12b0 _18zrpxbi _bfhksm61 _4t3i1ylp _ca0qze3t _n3tdze3t",
    triggerPressed: "_bfhkfcek",
    unresolvedLink: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
};
const $9a2b125c92105a3b$var$getDefaultPayload = (link, title)=>({
        url: link || '',
        displayText: null,
        title: title || null,
        meta: {
            inputMethod: 'manual'
        }
    });
const $9a2b125c92105a3b$var$Placeholder = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $9a2b125c92105a3b$var$styles.placeholder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $647f79795a021064$export$defe85febe8b728c).popupPlaceholderText));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $9a2b125c92105a3b$var$styles.placeholder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $647f79795a021064$export$defe85febe8b728c).popupPlaceholderText));
const $9a2b125c92105a3b$export$901b688e8da62820 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { id: id, cloudId: cloudId, link: link, title: title, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, isDisabled: isDisabled } = t0;
    let t1;
    if ($[0] !== link || $[1] !== title) {
        t1 = $9a2b125c92105a3b$var$getDefaultPayload(link, title);
        $[0] = link;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    const selectedLinkPayload = t1;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [isLinkFallbackError, setIsLinkFallbackError] = (0, $42omo.useState)(false);
    let t2;
    if ($[3] !== selectedLinkPayload.url) {
        t2 = ()=>window.open(selectedLinkPayload.url, "_blank");
        $[3] = selectedLinkPayload.url;
        $[4] = t2;
    } else t2 = $[4];
    const onLinkClick = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsLinkFallbackError(false);
        $[5] = t3;
    } else t3 = $[5];
    const onResolve = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (t5)=>{
            const { status: status } = t5;
            return setIsLinkFallbackError(status !== "forbidden" && status !== "unauthorized");
        };
        $[6] = t4;
    } else t4 = $[6];
    const onError = t4;
    let t5;
    if ($[7] !== isDisabled || $[8] !== isLinkFallbackError || $[9] !== onLinkClick || $[10] !== selectedLinkPayload.url) {
        t5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $9a2b125c92105a3b$var$styles.link
            }, !isLinkFallbackError && !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CM6e.CardSSR), {
                appearance: "inline",
                onClick: onLinkClick,
                onError: onError,
                onResolve: onResolve,
                truncateInline: true,
                url: selectedLinkPayload.url
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hn4RR.default), {
                ...!isDisabled && {
                    href: selectedLinkPayload.url
                },
                onClick: $9a2b125c92105a3b$var$_temp,
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($9a2b125c92105a3b$var$styles.unresolvedLink, isDisabled && $9a2b125c92105a3b$var$styles.disabled)
            }, selectedLinkPayload.url)));
        $[7] = isDisabled;
        $[8] = isLinkFallbackError;
        $[9] = onLinkClick;
        $[10] = selectedLinkPayload.url;
        $[11] = t5;
    } else t5 = $[11];
    const ResolvedLink = t5;
    let t6;
    if ($[12] !== handleClearLink) {
        t6 = (e_0)=>{
            e_0.stopPropagation();
            setIsLinkFallbackError(false);
            handleClearLink();
        };
        $[12] = handleClearLink;
        $[13] = t6;
    } else t6 = $[13];
    const onLinkClear = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== cloudId || $[16] !== handleSelectLink || $[17] !== selectedLinkPayload) {
        t8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a01e638968d35f1e$export$8f5a036ec4993fc5), {
                cloudId: cloudId,
                link: selectedLinkPayload,
                onLinkSelect: handleSelectLink,
                setIsOpen: setIsOpen
            });
        $[15] = cloudId;
        $[16] = handleSelectLink;
        $[17] = selectedLinkPayload;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== ResolvedLink || $[20] !== isDisabled || $[21] !== isOpen || $[22] !== onLinkClear || $[23] !== selectedLinkPayload.url) {
        t9 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                ...triggerProps,
                isDisabled: isDisabled,
                onClick: ()=>setIsOpen(!isOpen),
                testId: "link-picker-popup-button",
                style: {
                    border: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)"
                },
                xcss: (0, $1Whri.cx)($9a2b125c92105a3b$var$styles.trigger, isOpen && $9a2b125c92105a3b$var$styles.triggerPressed)
            }, !!selectedLinkPayload.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                xcss: $9a2b125c92105a3b$var$styles.selection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLink, null), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                onClick: onLinkClear,
                appearance: "subtle",
                spacing: "compact",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $647f79795a021064$export$defe85febe8b728c).clearIconLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev)))
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9a2b125c92105a3b$var$Placeholder, null));
        $[19] = ResolvedLink;
        $[20] = isDisabled;
        $[21] = isOpen;
        $[22] = onLinkClear;
        $[23] = selectedLinkPayload.url;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== id || $[26] !== isOpen || $[27] !== t8 || $[28] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            id: id,
            isOpen: isOpen,
            onClose: t7,
            placement: "left",
            content: t8,
            trigger: t9,
            shouldRenderToParent: true
        }));
        $[25] = id;
        $[26] = isOpen;
        $[27] = t8;
        $[28] = t9;
        $[29] = t10;
    } else t10 = $[29];
    return t10;
} : ({ id: id, cloudId: cloudId, link: link, title: title, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, isDisabled: isDisabled })=>{
    const selectedLinkPayload = $9a2b125c92105a3b$var$getDefaultPayload(link, title);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [isLinkFallbackError, setIsLinkFallbackError] = (0, $42omo.useState)(false);
    const onLinkClick = ()=>window.open(selectedLinkPayload.url, '_blank');
    const onResolve = ()=>setIsLinkFallbackError(false);
    const onError = ({ status: status })=>setIsLinkFallbackError(status !== 'forbidden' && status !== 'unauthorized');
    const ResolvedLink = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $9a2b125c92105a3b$var$styles.link
        }, !isLinkFallbackError && !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CM6e.CardSSR), {
            appearance: "inline",
            onClick: onLinkClick,
            onError: onError,
            onResolve: onResolve,
            truncateInline: true,
            url: selectedLinkPayload.url
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hn4RR.default), {
            ...!isDisabled && {
                href: selectedLinkPayload.url
            },
            onClick: (e)=>e.stopPropagation(),
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($9a2b125c92105a3b$var$styles.unresolvedLink, isDisabled && $9a2b125c92105a3b$var$styles.disabled)
        }, selectedLinkPayload.url)));
    };
    const onLinkClear = (e_0)=>{
        e_0.stopPropagation();
        setIsLinkFallbackError(false);
        handleClearLink();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        id: id,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a01e638968d35f1e$export$8f5a036ec4993fc5), {
                cloudId: cloudId,
                link: selectedLinkPayload,
                onLinkSelect: handleSelectLink,
                setIsOpen: setIsOpen
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                ...triggerProps,
                isDisabled: isDisabled,
                onClick: ()=>setIsOpen(!isOpen),
                testId: "link-picker-popup-button",
                style: {
                    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
                },
                xcss: (0, $1Whri.cx)($9a2b125c92105a3b$var$styles.trigger, isOpen && $9a2b125c92105a3b$var$styles.triggerPressed)
            }, !!selectedLinkPayload.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                xcss: $9a2b125c92105a3b$var$styles.selection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLink, null), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                onClick: onLinkClear,
                appearance: "subtle",
                spacing: "compact",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $647f79795a021064$export$defe85febe8b728c).clearIconLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev)))
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9a2b125c92105a3b$var$Placeholder, null)),
        shouldRenderToParent: true
    }));
};
function $9a2b125c92105a3b$var$_temp(e) {
    return e.stopPropagation();
}
module.exports["LinkPicker"] = $9a2b125c92105a3b$export$901b688e8da62820;

});

parcelRegister("d0hoS", function(module, exports) {
/**
 * @generated SignedSource<<0907a28d57b9d1524d8d13cf4e618c83>>
 * @relayHash b02d8f8b31305d13be27cef9e8b950ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0edbf1f8d53711cef0a2bc558686119f8ba6622bfe9a75dc0d54f98aa2d1c1f8
const $8c19f56c2352a4c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-published",
                                        "cover-picture-id-draft"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-published\",\"cover-picture-id-draft\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchPageCoverImageQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchPageCoverImageQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "0edbf1f8d53711cef0a2bc558686119f8ba6622bfe9a75dc0d54f98aa2d1c1f8",
            "metadata": {},
            "name": "useFetchPageCoverImageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8c19f56c2352a4c4$var$node.hash = "0855dab8d0960c23520163cfbddf5236";
var $8c19f56c2352a4c4$export$2e2bcd8739ae039 = $8c19f56c2352a4c4$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $irOoi = parcelRequire("irOoi");


var $inPa6 = parcelRequire("inPa6");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $kDHbX = parcelRequire("kDHbX");


var $gWF6I = parcelRequire("gWF6I");


var $7w8ah = parcelRequire("7w8ah");




const $1308770a57e72d89$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    fetchErrorTitle: {
        id: "company-hub.company-hub-common.link-cards.fetch-cover-image.fetch.error.title",
        defaultMessage: "We can\u2019t upload your image"
    },
    fetchErrorDescription: {
        id: "company-hub.company-hub-common.link-cards.fetch-cover-image.fetch.error.description",
        defaultMessage: "Refresh the page and try again"
    }
});


const $0e64e10de69315d4$var$extractId = (data)=>{
    const isLivePage = data?.content?.nodes?.[0]?.subType === 'live';
    let imageProperty;
    if (isLivePage) imageProperty = data?.content?.nodes?.[0]?.properties?.nodes?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).DRAFT);
    else {
        imageProperty = data?.content?.nodes?.[0]?.properties?.nodes?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).PUBLISHED);
        if (!imageProperty) imageProperty = data?.content?.nodes?.[0]?.properties?.nodes?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).DRAFT);
    }
    return (0, $7w8ah.propertyToId)(imageProperty)?.value.id;
};
function $0e64e10de69315d4$export$d09c7708bbcc7c1a(analyticsSource) {
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const environment = (0, $gWF6I.useRelayEnvironmentProvider)().getEnvironment({});
    return (0, $42omo.useCallback)(async (confluencePageId, image)=>{
        if (!confluencePageId) return image?.url;
        let coverImageUrl;
        try {
            const data = await (0, $irOoi.fetchQuery)(environment, (0, $8c19f56c2352a4c4$export$2e2bcd8739ae039), {
                id: confluencePageId ?? ''
            }).toPromise();
            coverImageUrl = $0e64e10de69315d4$var$extractId(data);
            if (coverImageUrl) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'image',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'imageFoundOnPage'
                    }
                }
            }).fire();
        } catch (error) {
            showFlag({
                id: 'fetch-cover-image-error',
                title: formatMessage((0, $1308770a57e72d89$export$defe85febe8b728c).fetchErrorTitle),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    label: "",
                    size: "medium",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                description: formatMessage((0, $1308770a57e72d89$export$defe85febe8b728c).fetchErrorDescription)
            });
            (0, $kDHbX.fireErrorAnalytics)({
                error: error instanceof Error ? error : new Error('Failed to fetch page cover image'),
                meta: {
                    id: 'useFetchPageCoverImage',
                    packageName: '@atlassian/company-hub-common'
                }
            });
        }
        return coverImageUrl || image?.url;
    }, [
        analyticsSource,
        createAnalyticsEvent,
        showFlag,
        formatMessage,
        environment
    ]);
}
module.exports["useFetchCoverImage"] = $0e64e10de69315d4$export$d09c7708bbcc7c1a;

});

parcelRegister("k1IsV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $82gXq = parcelRequire("82gXq");


var $3v7tz = parcelRequire("3v7tz");

const $8ba72fdae90322d2$var$toggleFieldContainerDisabledStyles = (0, $ecnYn.xcss)({
    color: 'color.text.disabled'
});
const $8ba72fdae90322d2$var$labelWrapperStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    flexGrow: 1,
    gap: 'space.100'
});
const $8ba72fdae90322d2$export$f91e8bfeb5571984 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    let Icon;
    let id;
    let isDisabled;
    let label;
    let toggleProps;
    if ($[0] !== t0) {
        ({ Icon: Icon, id: id, label: label, isDisabled: isDisabled, ...toggleProps } = t0);
        $[0] = t0;
        $[1] = Icon;
        $[2] = id;
        $[3] = isDisabled;
        $[4] = label;
        $[5] = toggleProps;
    } else {
        Icon = $[1];
        id = $[2];
        isDisabled = $[3];
        label = $[4];
        toggleProps = $[5];
    }
    const isDisabledContext = (0, $3v7tz.useIsDisabledContext)();
    const isToggleDisabled = isDisabled ?? isDisabledContext;
    if (!id) {
        let t1;
        if ($[6] !== label) {
            t1 = label.replace(/\s+/g, "-").toLowerCase();
            $[6] = label;
            $[7] = t1;
        } else t1 = $[7];
        id = `toggle-${t1}-property`;
    }
    const t1 = isToggleDisabled && $8ba72fdae90322d2$var$toggleFieldContainerDisabledStyles;
    let t2;
    if ($[8] !== id || $[9] !== label) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("label", {
            htmlFor: id
        }, label);
        $[8] = id;
        $[9] = label;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== Icon || $[12] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $8ba72fdae90322d2$var$labelWrapperStyles
        }, t2, Icon);
        $[11] = Icon;
        $[12] = t2;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== id || $[15] !== isToggleDisabled || $[16] !== toggleProps) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
            ...toggleProps,
            isDisabled: isToggleDisabled,
            id: id
        });
        $[14] = id;
        $[15] = isToggleDisabled;
        $[16] = toggleProps;
        $[17] = t4;
    } else t4 = $[17];
    let t5;
    if ($[18] !== t1 || $[19] !== t3 || $[20] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            xcss: t1
        }, t3, t4);
        $[18] = t1;
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
} : ({ Icon: Icon, id: id, label: label, isDisabled: isDisabled, ...toggleProps })=>{
    const isDisabledContext = (0, $3v7tz.useIsDisabledContext)();
    const isToggleDisabled = isDisabled ?? isDisabledContext;
    if (!id) id = `toggle-${label.replace(/\s+/g, '-').toLowerCase()}-property`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        xcss: isToggleDisabled && $8ba72fdae90322d2$var$toggleFieldContainerDisabledStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $8ba72fdae90322d2$var$labelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("label", {
        htmlFor: id
    }, label), Icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
        ...toggleProps,
        isDisabled: isToggleDisabled,
        id: id
    }));
};
module.exports["ToggleField"] = $8ba72fdae90322d2$export$f91e8bfeb5571984;

});

parcelRegister("jQ0mm", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $cO1el = parcelRequire("cO1el");


var $ghftu = parcelRequire("ghftu");


var $gKvd9 = parcelRequire("gKvd9");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $kZ5GD = parcelRequire("kZ5GD");


var $4noo5 = parcelRequire("4noo5");


var $4cOi8 = parcelRequire("4cOi8");


var $8jjEv = parcelRequire("8jjEv");




const $252cf81a0f143938$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    buttonHeading: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.button-heading",
        defaultMessage: "Button"
    },
    textPlaceholder: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.button-text-placeholder",
        defaultMessage: "View"
    },
    deleteIconLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.delete-icon-label",
        defaultMessage: "Delete"
    },
    defaultButtonStyleLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.light-button-style-label",
        defaultMessage: "Default"
    },
    alternativeButtonStyleLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.dark-button-style-label",
        defaultMessage: "Alternative"
    }
});


const $4d261656ae8fd0a9$var$popupWrapper = (0, $ecnYn.xcss)({
    width: '262px'
});
const $4d261656ae8fd0a9$var$defaultRadioOptionStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.250',
    paddingBlock: 'space.050',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    color: 'color.text'
});
const $4d261656ae8fd0a9$var$alternativeRadioOptionStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    color: 'color.text.inverse'
});
const $4d261656ae8fd0a9$export$322c06619d3c1a57 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(9);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>setIsOpen(false);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d261656ae8fd0a9$var$PopupContent, props);
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== isOpen) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                iconAfter: $4d261656ae8fd0a9$var$_temp
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $252cf81a0f143938$export$defe85febe8b728c).buttonHeading)));
        $[3] = isOpen;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isOpen || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            shouldRenderToParent: true,
            isOpen: isOpen,
            onClose: t0,
            placement: "bottom-start",
            content: t1,
            trigger: t2
        });
        $[5] = isOpen;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d261656ae8fd0a9$var$PopupContent, props),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $252cf81a0f143938$export$defe85febe8b728c).buttonHeading)))
    });
};
const $4d261656ae8fd0a9$var$PopupContent = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(53);
    const { text: text, link: link, style: style, source: source, buttonStyles: buttonStyles, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, handleClearButton: handleClearButton, updateButtonText: updateButtonText, updateButtonStyle: updateButtonStyle, cloudId: cloudId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== buttonStyles || $[1] !== intl) {
        t1 = buttonStyles || [
            {
                label: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).defaultButtonStyleLabel),
                value: (0, $4cOi8.ButtonStyle).DEFAULT,
                styles: $4d261656ae8fd0a9$var$defaultRadioOptionStyles
            },
            {
                label: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).alternativeButtonStyleLabel),
                value: (0, $4cOi8.ButtonStyle).ALTERNATIVE_1,
                styles: [
                    $4d261656ae8fd0a9$var$defaultRadioOptionStyles,
                    $4d261656ae8fd0a9$var$alternativeRadioOptionStyles
                ]
            }
        ];
        $[0] = buttonStyles;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    const buttonStyleOptions = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== source) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "focused",
                    actionSubject: "textField",
                    actionSubjectId: "configPanelButtonField",
                    source: `${source}ButtonLabel`
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = source;
        $[5] = t2;
    } else t2 = $[5];
    const fireTextFieldAnalytics = t2;
    let t3;
    if ($[6] !== createAnalyticsEvent || $[7] !== source) {
        t3 = (isAddingLink)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: isAddingLink ? "added" : "removed",
                    actionSubject: "buttonLink",
                    actionSubjectId: "configPanelButtonLink",
                    source: `${source}ButtonLink`
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = source;
        $[8] = t3;
    } else t3 = $[8];
    const fireButtonLinkAnalytics = t3;
    let t4;
    if ($[9] !== fireButtonLinkAnalytics || $[10] !== handleSelectLink) {
        t4 = (selectedLink)=>{
            handleSelectLink(selectedLink);
            fireButtonLinkAnalytics(true);
        };
        $[9] = fireButtonLinkAnalytics;
        $[10] = handleSelectLink;
        $[11] = t4;
    } else t4 = $[11];
    const selectLink = t4;
    let t5;
    if ($[12] !== fireButtonLinkAnalytics || $[13] !== handleClearButton) {
        t5 = ()=>{
            fireButtonLinkAnalytics(false);
            handleClearButton();
        };
        $[12] = fireButtonLinkAnalytics;
        $[13] = handleClearButton;
        $[14] = t5;
    } else t5 = $[14];
    const handleDeleteButton = t5;
    let t6;
    if ($[15] !== buttonStyleOptions || $[16] !== updateButtonStyle) {
        t6 = (event)=>{
            const selectedOption = buttonStyleOptions.find((option)=>option.value === event.currentTarget.value);
            if (selectedOption) updateButtonStyle(selectedOption.value);
        };
        $[15] = buttonStyleOptions;
        $[16] = updateButtonStyle;
        $[17] = t6;
    } else t6 = $[17];
    const handleChange = t6;
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlock: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $252cf81a0f143938$export$defe85febe8b728c).buttonHeading)));
        $[18] = t7;
    } else t7 = $[18];
    const t8 = !(text || link);
    let t9;
    if ($[19] !== intl) {
        t9 = intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).deleteIconLabel);
        $[19] = intl;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== handleDeleteButton || $[22] !== t8 || $[23] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            justifyContent: "space-between",
            alignItems: "center"
        }, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            isDisabled: t8,
            spacing: "compact",
            appearance: "subtle",
            onClick: handleDeleteButton,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
            label: t9,
            testId: "delete-button"
        }));
        $[21] = handleDeleteButton;
        $[22] = t8;
        $[23] = t9;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== cloudId || $[26] !== handleClearLink || $[27] !== link || $[28] !== selectLink) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            testId: "link-picker-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jjEv.LinkPicker), {
            cloudId: cloudId,
            link: link,
            id: "button-link",
            handleSelectLink: selectLink,
            handleClearLink: handleClearLink
        }));
        $[25] = cloudId;
        $[26] = handleClearLink;
        $[27] = link;
        $[28] = selectLink;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== updateButtonText) {
        t12 = (event_0)=>{
            updateButtonText(event_0.currentTarget.value);
        };
        $[30] = updateButtonText;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== intl) {
        t13 = intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).textPlaceholder);
        $[32] = intl;
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== fireTextFieldAnalytics || $[35] !== t12 || $[36] !== t13 || $[37] !== text) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            maxLength: 40,
            value: text,
            onChange: t12,
            onFocus: fireTextFieldAnalytics,
            placeholder: t13,
            testId: "button-name"
        }));
        $[34] = fireTextFieldAnalytics;
        $[35] = t12;
        $[36] = t13;
        $[37] = text;
        $[38] = t14;
    } else t14 = $[38];
    let t15;
    if ($[39] !== buttonStyleOptions || $[40] !== handleChange || $[41] !== style) {
        let t16;
        if ($[43] !== handleChange || $[44] !== style) {
            t16 = (option_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
                    key: index,
                    value: option_0.value,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                        alignItems: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                        xcss: option_0.styles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $252cf81a0f143938$export$defe85febe8b728c).buttonHeading))),
                    name: option_0.label,
                    isChecked: option_0.value === style,
                    onChange: handleChange,
                    style: {
                        margin: "auto"
                    },
                    testId: `button-style-${option_0.value}`
                });
            $[43] = handleChange;
            $[44] = style;
            $[45] = t16;
        } else t16 = $[45];
        t15 = buttonStyleOptions.map(t16);
        $[39] = buttonStyleOptions;
        $[40] = handleChange;
        $[41] = style;
        $[42] = t15;
    } else t15 = $[42];
    let t16;
    if ($[46] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, t15);
        $[46] = t15;
        $[47] = t16;
    } else t16 = $[47];
    let t17;
    if ($[48] !== t10 || $[49] !== t11 || $[50] !== t14 || $[51] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            padding: "space.150",
            xcss: $4d261656ae8fd0a9$var$popupWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.200",
            grow: "fill"
        }, t10, t11, t14, t16));
        $[48] = t10;
        $[49] = t11;
        $[50] = t14;
        $[51] = t16;
        $[52] = t17;
    } else t17 = $[52];
    return t17;
} : ({ text: text, link: link, style: style, source: source, buttonStyles: buttonStyles, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, handleClearButton: handleClearButton, updateButtonText: updateButtonText, updateButtonStyle: updateButtonStyle, cloudId: cloudId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const buttonStyleOptions = buttonStyles || [
        {
            label: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).defaultButtonStyleLabel),
            value: (0, $4cOi8.ButtonStyle).DEFAULT,
            styles: $4d261656ae8fd0a9$var$defaultRadioOptionStyles
        },
        {
            label: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).alternativeButtonStyleLabel),
            value: (0, $4cOi8.ButtonStyle).ALTERNATIVE_1,
            styles: [
                $4d261656ae8fd0a9$var$defaultRadioOptionStyles,
                $4d261656ae8fd0a9$var$alternativeRadioOptionStyles
            ]
        }
    ];
    const fireTextFieldAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'focused',
                actionSubject: 'textField',
                actionSubjectId: 'configPanelButtonField',
                source: `${source}ButtonLabel`
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const fireButtonLinkAnalytics = (0, $42omo.useCallback)((isAddingLink)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: isAddingLink ? 'added' : 'removed',
                actionSubject: 'buttonLink',
                actionSubjectId: 'configPanelButtonLink',
                source: `${source}ButtonLink`
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const selectLink = (0, $42omo.useCallback)((selectedLink)=>{
        handleSelectLink(selectedLink);
        fireButtonLinkAnalytics(true);
    }, [
        fireButtonLinkAnalytics,
        handleSelectLink
    ]);
    const handleDeleteButton = ()=>{
        fireButtonLinkAnalytics(false);
        handleClearButton();
    };
    const handleChange = (event)=>{
        const selectedOption = buttonStyleOptions.find((option)=>option.value === event.currentTarget.value);
        if (selectedOption) updateButtonStyle(selectedOption.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.150",
        xcss: $4d261656ae8fd0a9$var$popupWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $252cf81a0f143938$export$defe85febe8b728c).buttonHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        isDisabled: !(text || link),
        spacing: "compact",
        appearance: "subtle",
        onClick: handleDeleteButton,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        label: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).deleteIconLabel),
        testId: "delete-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        testId: "link-picker-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jjEv.LinkPicker), {
        cloudId: cloudId,
        link: link,
        id: "button-link",
        handleSelectLink: selectLink,
        handleClearLink: handleClearLink
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        maxLength: 40,
        value: text,
        onChange: (event_0)=>{
            updateButtonText(event_0.currentTarget.value);
        },
        onFocus: fireTextFieldAnalytics,
        placeholder: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).textPlaceholder),
        testId: "button-name"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, buttonStyleOptions.map((option_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
            key: index,
            value: option_0.value,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                xcss: option_0.styles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $252cf81a0f143938$export$defe85febe8b728c).buttonHeading))),
            name: option_0.label,
            isChecked: option_0.value === style,
            onChange: handleChange,
            // Static styling is necessary here to ensure the radio button is centered
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                margin: 'auto'
            },
            testId: `button-style-${option_0.value}`
        })))));
};
function $4d261656ae8fd0a9$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["ButtonConfig"] = $4d261656ae8fd0a9$export$322c06619d3c1a57;

});

parcelRegister("l1iRA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $dAbO5 = parcelRequire("dAbO5");

var $6r7Ix = parcelRequire("6r7Ix");

var $hjUk0 = parcelRequire("hjUk0");

var $6UUyu = parcelRequire("6UUyu");

var $4cOi8 = parcelRequire("4cOi8");

var $jD7cj = parcelRequire("jD7cj");

var $1m9A2 = parcelRequire("1m9A2");

var $3VS69 = parcelRequire("3VS69");

var $g3LxX = parcelRequire("g3LxX");

var $3v7tz = parcelRequire("3v7tz");

var $fOKpq = parcelRequire("fOKpq");


var $5Ac5G = parcelRequire("5Ac5G");


var $eIwIu = parcelRequire("eIwIu");











var $dCemt = parcelRequire("dCemt");

var $2oKNO = parcelRequire("2oKNO");


var $izxBd = parcelRequire("izxBd");



















var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $5n7dr = parcelRequire("5n7dr");

var $fQWPs = parcelRequire("fQWPs");

var $7Ux0V = parcelRequire("7Ux0V");

var $1u5CA = parcelRequire("1u5CA");




var $7XNwX = parcelRequire("7XNwX");

var $7lwhH = parcelRequire("7lwhH");




var $fcbj5 = parcelRequire("fcbj5");

var $bWZ7X = parcelRequire("bWZ7X");


var $litlC = parcelRequire("litlC");

















var $gMc0m = parcelRequire("gMc0m");








var $ccHMk = parcelRequire("ccHMk");


var $1Whri = parcelRequire("1Whri");


var $ghftu = parcelRequire("ghftu");


var $lGgRw = parcelRequire("lGgRw");





var $hECbK = parcelRequire("hECbK");








var $jPFXE = parcelRequire("jPFXE");




const $94057edfb8ba8d7a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    buttonTitle: {
        id: "company-hub.carousel-extension.config-panel.layout.title",
        defaultMessage: "Choose a layout"
    },
    frameAboveImageLabel: {
        id: "company-hub.carousel-extension.config-panel.layouts.frame-above-image.label",
        defaultMessage: "Text with frame above image"
    },
    splitDesignLabel: {
        id: "company-hub.carousel-extension.config-panel.layouts.split-design-content.label",
        defaultMessage: "Split design"
    },
    solidColorBackgroundLabel: {
        id: "company-hub.carousel-extension.config-panel.layouts.solid-color-background.label",
        defaultMessage: "Solid color background"
    }
});


const $a2bf2f277dad4905$var$DROPDOWN_WIDTH = 241;
const $a2bf2f277dad4905$var$DROPDOWN_MAX_HEIGHT = 500;
const $a2bf2f277dad4905$var$BUTTON_CONTAINER_WIDTH = 152;
const $a2bf2f277dad4905$export$af1b061943ec63f0 = [
    {
        label: (0, $94057edfb8ba8d7a$export$defe85febe8b728c).frameAboveImageLabel,
        value: (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE
    },
    {
        label: (0, $94057edfb8ba8d7a$export$defe85febe8b728c).splitDesignLabel,
        value: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    },
    {
        label: (0, $94057edfb8ba8d7a$export$defe85febe8b728c).splitDesignLabel,
        value: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        label: (0, $94057edfb8ba8d7a$export$defe85febe8b728c).solidColorBackgroundLabel,
        value: (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND
    }
];
const $a2bf2f277dad4905$var$styles = {
    dropdownMenuStyles: "_1bsbn8ye _c71ldgin _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _18m91wug",
    buttonContainer: "_1bsb1llu _otyrpxbi"
};
const $a2bf2f277dad4905$export$23adc972c5b7cdfa = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { updateFrameFormField: updateFrameFormField, frameParameters: frameParameters, contentId: contentId } = t0;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== frameParameters.cardId || $[1] !== updateFrameFormField) {
        t1 = (newLayout)=>updateFrameFormField(frameParameters.cardId, {
                layout: newLayout
            });
        $[0] = frameParameters.cardId;
        $[1] = updateFrameFormField;
        $[2] = t1;
    } else t1 = $[2];
    const handleUpdateLayout = t1;
    let t2;
    if ($[3] !== contentId || $[4] !== frameParameters.backgroundColor || $[5] !== frameParameters.description || $[6] !== frameParameters.imageSrc || $[7] !== frameParameters.link || $[8] !== frameParameters.textColor || $[9] !== frameParameters.title) {
        t2 = (t3)=>{
            const { height: height, layout: layout } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jPFXE.CarouselLayoutRenderer), {
                testId: "carousel-spotlight-preview",
                backgroundColor: frameParameters.backgroundColor,
                height: height,
                layout: layout,
                imageData: frameParameters.imageSrc,
                title: frameParameters?.title,
                description: frameParameters?.description,
                textColor: frameParameters?.textColor,
                link: frameParameters.link,
                contentId: contentId,
                source: "carousel-spotlight-preview"
            }));
        };
        $[3] = contentId;
        $[4] = frameParameters.backgroundColor;
        $[5] = frameParameters.description;
        $[6] = frameParameters.imageSrc;
        $[7] = frameParameters.link;
        $[8] = frameParameters.textColor;
        $[9] = frameParameters.title;
        $[10] = t2;
    } else t2 = $[10];
    const PreviewContentComponent = t2;
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsOpen(false);
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== PreviewContentComponent || $[13] !== frameParameters.layout || $[14] !== handleUpdateLayout) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                direction: "column",
                gap: "space.150",
                xcss: (0, $1Whri.cx)($a2bf2f277dad4905$var$styles.dropdownMenuStyles)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hECbK.LayoutOptions), {
                updateLayout: handleUpdateLayout,
                source: (0, $5Ac5G.carouselConfigAnalyticSource),
                layoutOptions: $a2bf2f277dad4905$export$af1b061943ec63f0,
                variant: "compact",
                currentLayoutSelection: frameParameters.layout,
                PreviewComponent: PreviewContentComponent
            }));
        $[12] = PreviewContentComponent;
        $[13] = frameParameters.layout;
        $[14] = handleUpdateLayout;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== isOpen) {
        t5 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    $a2bf2f277dad4905$var$styles.buttonContainer
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                iconAfter: $a2bf2f277dad4905$var$_temp
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $94057edfb8ba8d7a$export$defe85febe8b728c).buttonTitle)));
        $[16] = isOpen;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== isOpen || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            shouldRenderToParent: true,
            isOpen: isOpen,
            onClose: t3,
            placement: "bottom-start",
            zIndex: 600,
            content: t4,
            trigger: t5
        });
        $[18] = isOpen;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
} : ({ updateFrameFormField: updateFrameFormField, frameParameters: frameParameters, contentId: contentId })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const handleUpdateLayout = (0, $42omo.useCallback)((newLayout)=>updateFrameFormField(frameParameters.cardId, {
            layout: newLayout
        }), [
        frameParameters.cardId,
        updateFrameFormField
    ]);
    const PreviewContentComponent = (0, $42omo.useCallback)(({ height: height, layout: layout })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jPFXE.CarouselLayoutRenderer), {
            testId: "carousel-spotlight-preview",
            backgroundColor: frameParameters.backgroundColor,
            height: height,
            layout: layout,
            imageData: frameParameters.imageSrc,
            title: frameParameters?.title,
            description: frameParameters?.description,
            textColor: frameParameters?.textColor,
            link: frameParameters.link,
            contentId: contentId,
            source: "carousel-spotlight-preview"
        }));
    }, [
        frameParameters,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        zIndex: 600,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                direction: "column",
                gap: "space.150",
                xcss: (0, $1Whri.cx)($a2bf2f277dad4905$var$styles.dropdownMenuStyles)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hECbK.LayoutOptions), {
                updateLayout: handleUpdateLayout,
                source: (0, $5Ac5G.carouselConfigAnalyticSource),
                layoutOptions: $a2bf2f277dad4905$export$af1b061943ec63f0,
                variant: "compact",
                currentLayoutSelection: frameParameters.layout,
                PreviewComponent: PreviewContentComponent
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    $a2bf2f277dad4905$var$styles.buttonContainer
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $94057edfb8ba8d7a$export$defe85febe8b728c).buttonTitle)))
    });
};
function $a2bf2f277dad4905$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        ...iconProps,
        size: "small"
    });
}















var $jSnXV = parcelRequire("jSnXV");





var $inPa6 = parcelRequire("inPa6");


var $bfgIy = parcelRequire("bfgIy");


var $k00oi = parcelRequire("k00oi");





var $9EtP6 = parcelRequire("9EtP6");


var $4noo5 = parcelRequire("4noo5");


var $jQ0mm = parcelRequire("jQ0mm");



var $3kSzn = parcelRequire("3kSzn");

var $jCIc5 = parcelRequire("jCIc5");

var $d0hoS = parcelRequire("d0hoS");




var $iqWjJ = parcelRequire("iqWjJ");













const $6f92deb89807bbb7$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    linkFieldLabel: {
        id: "company-hub.carousel-extension.config-panel.link.field.label",
        defaultMessage: "Link"
    },
    titleFieldLabel: {
        id: "company-hub.carousel-extension.title.field.label",
        defaultMessage: "Title"
    },
    recommendedFieldLabel: {
        id: "company-hub.carousel-extension.recommended.field.label",
        defaultMessage: "(Recommended)"
    },
    descriptionFieldLabel: {
        id: "company-hub.carousel-extension.description.field.label",
        defaultMessage: "Description"
    },
    titlePlaceholder: {
        id: "company-hub.carousel-extension.title.placeholder",
        defaultMessage: "Give your frame a title"
    },
    descriptionPlaceholder: {
        id: "company-hub.carousel-extension.description.placeholder",
        defaultMessage: "Customize this frame to create a rotating carousel."
    }
});


const $5912d0e11f9fe29f$var$debouncedParametersUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((updateFrameFormField, inputPropertyToUpdate, inputIsUserEditedPropertyToUpdate, cardId, value, createAnalyticsEvent, shouldUpdateUserEdited = true)=>{
    updateFrameFormField(cardId, {
        [inputPropertyToUpdate]: value,
        [inputIsUserEditedPropertyToUpdate]: shouldUpdateUserEdited
    });
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'edited',
            actionSubject: inputPropertyToUpdate,
            source: (0, $5Ac5G.carouselConfigAnalyticSource)
        }
    }).fire();
}, 400); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5912d0e11f9fe29f$var$RecommendedWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1p1dglyw _k48pi7a9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1p1dglyw _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $5912d0e11f9fe29f$var$fieldWrapperStyles = {
    fieldWrapper: "_19pkpxbi"
};
const $5912d0e11f9fe29f$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
const $5912d0e11f9fe29f$var$getFieldsToUpdateOnLinkSelect = async (selectedLink, fetchCoverImageUrl, cardImage, cardTitle, cardDescription, isTitleUserEdited, isDescriptionUserEdited, submitError)=>{
    let fieldsToUpdate = (0, $eIwIu.updateLinkAndConfluencePageId)(selectedLink.url, '', true);
    try {
        const client = new (0, $k00oi.default)();
        const queriedMetadata = await client.fetchData(selectedLink.url);
        const { name: name, image: image, summary: summary } = queriedMetadata?.data || {};
        const { objectId: objectId } = queriedMetadata?.meta || {};
        fieldsToUpdate = {
            ...fieldsToUpdate,
            ...(0, $eIwIu.updateLinkAndConfluencePageId)(selectedLink.url, objectId, true)
        };
        if (!cardTitle || isTitleUserEdited === false) {
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).TITLE] = name;
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED] = false;
        }
        if (!cardDescription || isDescriptionUserEdited === false) {
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).DESCRIPTION] = summary;
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = false;
        } // Updating imageSrc and imageAltText
        let newImageSrc = cardImage || '';
        const newImageAltText = '';
        const coverImage = await fetchCoverImageUrl(objectId, image);
        if (coverImage) {
            const isExternalSiteImage = $5912d0e11f9fe29f$var$externalSiteMatcher.test(coverImage);
            if (!(0, $iqWjJ.isUnsplashImage)(coverImage) && !isExternalSiteImage) // For custom uploaded image save it in format `contentId/imageId`
            newImageSrc = `${objectId}/${coverImage}`;
            else newImageSrc = coverImage;
        } // Do not store private Loom CDN thumbnails (they expire via Policy)
        if ((0, $3kSzn.isPrivateLoomImageUrl)(newImageSrc)) newImageSrc = '';
        fieldsToUpdate = {
            ...fieldsToUpdate,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: newImageSrc,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: newImageAltText
        };
    } catch (error) {
        submitError?.(error);
    }
    return fieldsToUpdate;
};
const $5912d0e11f9fe29f$export$48fc9d47b1ec72d4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(84);
    const { frameParameters: frameParameters, updateFrameFormField: updateFrameFormField, isDisabled: isDisabled } = t0;
    const { cardId: cardId, link: link, title: title, description: description, isTitleUserEdited: isTitleUserEdited, isDescriptionUserEdited: isDescriptionUserEdited, imageSrc: imageSrc, buttonStyle: buttonStyle, buttonText: buttonText } = frameParameters;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { submitError: submitError, cloudId: cloudId } = (0, $fOKpq.useProductDependencies)();
    const [titleValue, setTitleValue] = (0, $42omo.useState)(title);
    const [descriptionValue, setDescriptionValue] = (0, $42omo.useState)(description);
    const titleId = `title-field-${cardId}`;
    const descriptionId = `description-field-${cardId}`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== title) {
        t1 = ()=>{
            setTitleValue(title);
        };
        t2 = [
            title
        ];
        $[0] = title;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== description) {
        t3 = ()=>{
            setDescriptionValue(description);
        };
        t4 = [
            description
        ];
        $[3] = description;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[6] !== cardId || $[7] !== createAnalyticsEvent || $[8] !== updateFrameFormField) {
        t5 = (event)=>{
            const { value: value } = event.currentTarget;
            setDescriptionValue(value);
            $5912d0e11f9fe29f$var$debouncedParametersUpdate(updateFrameFormField, (0, $4cOi8.ITEM_FIELDS).DESCRIPTION, (0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED, cardId, value, createAnalyticsEvent, (0, $5Ac5G.carouselConfigAnalyticSource));
        };
        $[6] = cardId;
        $[7] = createAnalyticsEvent;
        $[8] = updateFrameFormField;
        $[9] = t5;
    } else t5 = $[9];
    const handleDescriptionChange = t5;
    let t6;
    if ($[10] !== cardId || $[11] !== createAnalyticsEvent || $[12] !== updateFrameFormField) {
        t6 = (event_0)=>{
            const { value: value_0 } = event_0.currentTarget;
            setTitleValue(value_0.trimStart());
            $5912d0e11f9fe29f$var$debouncedParametersUpdate(updateFrameFormField, (0, $4cOi8.ITEM_FIELDS).TITLE, (0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED, cardId, value_0.trimStart(), createAnalyticsEvent, (0, $5Ac5G.carouselConfigAnalyticSource));
        };
        $[10] = cardId;
        $[11] = createAnalyticsEvent;
        $[12] = updateFrameFormField;
        $[13] = t6;
    } else t6 = $[13];
    const handleTitleOnChange = t6;
    const fetchCoverImageUrl = (0, $d0hoS.useFetchCoverImage)((0, $5Ac5G.carouselConfigAnalyticSource));
    let t7;
    if ($[14] !== cardId || $[15] !== description || $[16] !== fetchCoverImageUrl || $[17] !== imageSrc || $[18] !== isDescriptionUserEdited || $[19] !== isTitleUserEdited || $[20] !== submitError || $[21] !== title || $[22] !== updateFrameFormField) {
        t7 = async (selectedLink)=>{
            const fieldsToUpdate = await $5912d0e11f9fe29f$var$getFieldsToUpdateOnLinkSelect(selectedLink, fetchCoverImageUrl, imageSrc, title, description, isTitleUserEdited || false, isDescriptionUserEdited || false, submitError);
            updateFrameFormField(cardId, fieldsToUpdate);
        };
        $[14] = cardId;
        $[15] = description;
        $[16] = fetchCoverImageUrl;
        $[17] = imageSrc;
        $[18] = isDescriptionUserEdited;
        $[19] = isTitleUserEdited;
        $[20] = submitError;
        $[21] = title;
        $[22] = updateFrameFormField;
        $[23] = t7;
    } else t7 = $[23];
    const handleSelectLink = t7;
    let t8;
    if ($[24] !== cardId || $[25] !== isDescriptionUserEdited || $[26] !== isTitleUserEdited || $[27] !== updateFrameFormField) {
        t8 = (t9)=>{
            const clearAllFields = t9 === undefined ? false : t9;
            const fieldsToClear = {
                ...(0, $eIwIu.updateLinkAndConfluencePageId)("", ""),
                ...clearAllFields ? {
                    buttonText: "",
                    buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT
                } : {}
            };
            if (isTitleUserEdited === false) {
                fieldsToClear[(0, $4cOi8.ITEM_FIELDS).TITLE] = "";
                fieldsToClear[(0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED] = undefined;
            }
            if (isDescriptionUserEdited === false) {
                fieldsToClear[(0, $4cOi8.ITEM_FIELDS).DESCRIPTION] = "";
                fieldsToClear[(0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = undefined;
            }
            updateFrameFormField(cardId, fieldsToClear);
        };
        $[24] = cardId;
        $[25] = isDescriptionUserEdited;
        $[26] = isTitleUserEdited;
        $[27] = updateFrameFormField;
        $[28] = t8;
    } else t8 = $[28];
    const handleClearLink = t8;
    let t9;
    if ($[29] !== handleClearLink) {
        t9 = ()=>{
            handleClearLink(true);
        };
        $[29] = handleClearLink;
        $[30] = t9;
    } else t9 = $[30];
    const handleClearButton = t9;
    let t10;
    if ($[31] !== cardId || $[32] !== updateFrameFormField) {
        t10 = (buttonTextPayload)=>{
            updateFrameFormField(cardId, {
                buttonText: buttonTextPayload
            });
        };
        $[31] = cardId;
        $[32] = updateFrameFormField;
        $[33] = t10;
    } else t10 = $[33];
    const updateButtonText = t10;
    let t11;
    if ($[34] !== cardId || $[35] !== updateFrameFormField) {
        t11 = (buttonStylePayload)=>{
            updateFrameFormField(cardId, {
                buttonStyle: buttonStylePayload
            });
        };
        $[34] = cardId;
        $[35] = updateFrameFormField;
        $[36] = t11;
    } else t11 = $[36];
    const updateButtonStyle = t11;
    let t12;
    if ($[37] !== buttonStyle || $[38] !== buttonText || $[39] !== cloudId || $[40] !== handleClearButton || $[41] !== handleClearLink || $[42] !== handleSelectLink || $[43] !== link || $[44] !== updateButtonStyle || $[45] !== updateButtonText) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jQ0mm.ButtonConfig), {
            cloudId: cloudId,
            link: link,
            text: buttonText,
            style: buttonStyle,
            handleSelectLink: handleSelectLink,
            handleClearLink: handleClearLink,
            handleClearButton: handleClearButton,
            updateButtonText: updateButtonText,
            updateButtonStyle: updateButtonStyle,
            source: (0, $5Ac5G.carouselContentAnalyticSource)
        });
        $[37] = buttonStyle;
        $[38] = buttonText;
        $[39] = cloudId;
        $[40] = handleClearButton;
        $[41] = handleClearLink;
        $[42] = handleSelectLink;
        $[43] = link;
        $[44] = updateButtonStyle;
        $[45] = updateButtonText;
        $[46] = t12;
    } else t12 = $[46];
    let t13;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6f92deb89807bbb7$export$defe85febe8b728c).titleFieldLabel);
        $[47] = t13;
    } else t13 = $[47];
    let t14;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jCIc5.PanelSubheader), {
            showUpdatedStyles: true
        }, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5912d0e11f9fe29f$var$RecommendedWrapper, null, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6f92deb89807bbb7$export$defe85febe8b728c).recommendedFieldLabel)));
        $[48] = t14;
    } else t14 = $[48];
    let t15;
    if ($[49] !== titleId) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
            htmlFor: titleId
        }, t14);
        $[49] = titleId;
        $[50] = t15;
    } else t15 = $[50];
    let t16;
    if ($[51] !== titleValue) {
        t16 = titleValue?.trimStart();
        $[51] = titleValue;
        $[52] = t16;
    } else t16 = $[52];
    let t17;
    if ($[53] !== formatMessage) {
        t17 = formatMessage((0, $6f92deb89807bbb7$export$defe85febe8b728c).titlePlaceholder);
        $[53] = formatMessage;
        $[54] = t17;
    } else t17 = $[54];
    let t18;
    if ($[55] !== handleTitleOnChange || $[56] !== isDisabled || $[57] !== t16 || $[58] !== t17 || $[59] !== titleId) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            id: titleId,
            value: t16,
            onChange: handleTitleOnChange,
            maxLength: 255,
            isDisabled: isDisabled,
            placeholder: t17
        });
        $[55] = handleTitleOnChange;
        $[56] = isDisabled;
        $[57] = t16;
        $[58] = t17;
        $[59] = titleId;
        $[60] = t18;
    } else t18 = $[60];
    let t19;
    if ($[61] !== t15 || $[62] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5912d0e11f9fe29f$var$fieldWrapperStyles.fieldWrapper,
            direction: "column"
        }, t15, t18);
        $[61] = t15;
        $[62] = t18;
        $[63] = t19;
    } else t19 = $[63];
    let t20;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jCIc5.PanelSubheader), {
            showUpdatedStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6f92deb89807bbb7$export$defe85febe8b728c).descriptionFieldLabel));
        $[64] = t20;
    } else t20 = $[64];
    let t21;
    if ($[65] !== descriptionId) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
            htmlFor: descriptionId
        }, t20);
        $[65] = descriptionId;
        $[66] = t21;
    } else t21 = $[66];
    let t22;
    if ($[67] !== descriptionValue) {
        t22 = descriptionValue?.trimStart();
        $[67] = descriptionValue;
        $[68] = t22;
    } else t22 = $[68];
    let t23;
    if ($[69] !== formatMessage) {
        t23 = formatMessage((0, $6f92deb89807bbb7$export$defe85febe8b728c).descriptionPlaceholder);
        $[69] = formatMessage;
        $[70] = t23;
    } else t23 = $[70];
    let t24;
    if ($[71] !== descriptionId || $[72] !== handleDescriptionChange || $[73] !== isDisabled || $[74] !== t22 || $[75] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
            id: descriptionId,
            rows: 3,
            value: t22,
            onChange: handleDescriptionChange,
            maxLength: 700,
            isDisabled: isDisabled,
            testId: "frame-description-field",
            placeholder: t23
        });
        $[71] = descriptionId;
        $[72] = handleDescriptionChange;
        $[73] = isDisabled;
        $[74] = t22;
        $[75] = t23;
        $[76] = t24;
    } else t24 = $[76];
    let t25;
    if ($[77] !== t21 || $[78] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $5912d0e11f9fe29f$var$fieldWrapperStyles.fieldWrapper,
            direction: "column"
        }, t21, t24);
        $[77] = t21;
        $[78] = t24;
        $[79] = t25;
    } else t25 = $[79];
    let t26;
    if ($[80] !== t12 || $[81] !== t19 || $[82] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t12, t19, t25);
        $[80] = t12;
        $[81] = t19;
        $[82] = t25;
        $[83] = t26;
    } else t26 = $[83];
    return t26;
} : ({ frameParameters: frameParameters, updateFrameFormField: updateFrameFormField, isDisabled: isDisabled })=>{
    const { cardId: cardId, link: link, title: title, description: description, isTitleUserEdited: isTitleUserEdited, isDescriptionUserEdited: isDescriptionUserEdited, imageSrc: imageSrc, buttonStyle: // carousel v2
    buttonStyle, buttonText: buttonText } = frameParameters;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { submitError: submitError, cloudId: cloudId } = (0, $fOKpq.useProductDependencies)();
    const [titleValue, setTitleValue] = (0, $42omo.useState)(title);
    const [descriptionValue, setDescriptionValue] = (0, $42omo.useState)(description);
    const titleId = `title-field-${cardId}`;
    const descriptionId = `description-field-${cardId}`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        setTitleValue(title);
    }, [
        title
    ]);
    (0, $42omo.useEffect)(()=>{
        setDescriptionValue(description);
    }, [
        description
    ]);
    const handleDescriptionChange = (0, $42omo.useCallback)((event)=>{
        const { value: value } = event.currentTarget;
        setDescriptionValue(value);
        $5912d0e11f9fe29f$var$debouncedParametersUpdate(updateFrameFormField, (0, $4cOi8.ITEM_FIELDS).DESCRIPTION, (0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED, cardId, value, createAnalyticsEvent, (0, $5Ac5G.carouselConfigAnalyticSource));
    }, [
        updateFrameFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const handleTitleOnChange = (0, $42omo.useCallback)((event_0)=>{
        const { value: value_0 } = event_0.currentTarget;
        setTitleValue(value_0.trimStart());
        $5912d0e11f9fe29f$var$debouncedParametersUpdate(updateFrameFormField, (0, $4cOi8.ITEM_FIELDS).TITLE, (0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED, cardId, value_0.trimStart(), createAnalyticsEvent, (0, $5Ac5G.carouselConfigAnalyticSource));
    }, [
        updateFrameFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const fetchCoverImageUrl = (0, $d0hoS.useFetchCoverImage)((0, $5Ac5G.carouselConfigAnalyticSource));
    const handleSelectLink = (0, $42omo.useCallback)(async (selectedLink)=>{
        const fieldsToUpdate = await $5912d0e11f9fe29f$var$getFieldsToUpdateOnLinkSelect(selectedLink, fetchCoverImageUrl, imageSrc, title, description, isTitleUserEdited || false, isDescriptionUserEdited || false, submitError);
        updateFrameFormField(cardId, fieldsToUpdate);
    }, [
        cardId,
        imageSrc,
        title,
        description,
        isTitleUserEdited,
        isDescriptionUserEdited,
        fetchCoverImageUrl,
        updateFrameFormField,
        submitError
    ]);
    const handleClearLink = (0, $42omo.useCallback)((clearAllFields = false)=>{
        const fieldsToClear = {
            ...(0, $eIwIu.updateLinkAndConfluencePageId)('', ''),
            ...clearAllFields ? {
                buttonText: '',
                buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT
            } : {}
        };
        if (isTitleUserEdited === false) {
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).TITLE] = '';
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED] = undefined;
        }
        if (isDescriptionUserEdited === false) {
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).DESCRIPTION] = '';
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = undefined;
        }
        updateFrameFormField(cardId, fieldsToClear);
    }, [
        updateFrameFormField,
        cardId,
        isTitleUserEdited,
        isDescriptionUserEdited
    ]);
    const handleClearButton = ()=>{
        handleClearLink(true);
    };
    const updateButtonText = (0, $42omo.useCallback)((buttonTextPayload)=>{
        updateFrameFormField(cardId, {
            buttonText: buttonTextPayload
        });
    }, [
        updateFrameFormField,
        cardId
    ]);
    const updateButtonStyle = (0, $42omo.useCallback)((buttonStylePayload)=>{
        updateFrameFormField(cardId, {
            buttonStyle: buttonStylePayload
        });
    }, [
        updateFrameFormField,
        cardId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jQ0mm.ButtonConfig), {
        cloudId: cloudId,
        link: link,
        text: buttonText,
        style: buttonStyle,
        handleSelectLink: handleSelectLink,
        handleClearLink: handleClearLink,
        handleClearButton: handleClearButton,
        updateButtonText: updateButtonText,
        updateButtonStyle: updateButtonStyle,
        source: (0, $5Ac5G.carouselContentAnalyticSource)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $5912d0e11f9fe29f$var$fieldWrapperStyles.fieldWrapper,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
        htmlFor: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jCIc5.PanelSubheader), {
        showUpdatedStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6f92deb89807bbb7$export$defe85febe8b728c).titleFieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5912d0e11f9fe29f$var$RecommendedWrapper, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6f92deb89807bbb7$export$defe85febe8b728c).recommendedFieldLabel)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        id: titleId,
        value: titleValue?.trimStart(),
        onChange: handleTitleOnChange,
        maxLength: 255,
        isDisabled: isDisabled,
        placeholder: formatMessage((0, $6f92deb89807bbb7$export$defe85febe8b728c).titlePlaceholder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $5912d0e11f9fe29f$var$fieldWrapperStyles.fieldWrapper,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
        htmlFor: descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jCIc5.PanelSubheader), {
        showUpdatedStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6f92deb89807bbb7$export$defe85febe8b728c).descriptionFieldLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        id: descriptionId,
        rows: 3,
        value: descriptionValue?.trimStart(),
        onChange: handleDescriptionChange,
        maxLength: 700,
        isDisabled: isDisabled,
        testId: "frame-description-field",
        placeholder: formatMessage((0, $6f92deb89807bbb7$export$defe85febe8b728c).descriptionPlaceholder)
    })));
};





const $cd253c0731ac2770$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    backgroundColor: {
        id: "company-hub.carousel-extension.frame.background.color",
        defaultMessage: "Background color"
    },
    textColor: {
        id: "company-hub.carousel-extension.frame.text.color",
        defaultMessage: "Text color"
    },
    colorValidationSuccessMessage: {
        id: "company-hub.carousel-extension.frame.color-contrast.success",
        defaultMessage: "Your text and background colors work well for readability."
    },
    colorValidationFailMessage: {
        id: "company-hub.carousel-extension.frame.color-contrast.fail",
        defaultMessage: "Your text and background colors don\u2019t work well for readability."
    }
});


const $7398f533eccdc537$var$styles = {
    wrapper: "_1wpz1fhb _2lx21bp4 _19pku2gc _otyru2gc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    bgAndTextColorOptionsWrapper: "_19pkpxbi"
};
const $7398f533eccdc537$export$a2a14dc5e9bae153 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(67);
    const { contentId: contentId, frameParameters: frameParameters, initialUnsplashResults: initialUnsplashResults, isDisabled: isDisabled, showBgAndTextColorOptions: showBgAndTextColorOptions, updateFrameFormField: updateFrameFormField, showMediaPicker: showMediaPicker, showLayout: showLayout } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { cardId: cardId, imageSrc: imageSrc, imageAltText: imageAltText, confluencePageId: confluencePageId, backgroundColor: t1, textColor: t2, layout: layout } = frameParameters;
    const backgroundColor = t1 === undefined ? (0, $eIwIu.frameNewParametersV2).backgroundColor : t1;
    const textColor = t2 === undefined ? (0, $eIwIu.frameNewParametersV2).textColor : t2;
    const { isCompanyHub: isCompanyHub, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker, isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $fOKpq.useProductDependencies)();
    let t3;
    if ($[0] !== branding) {
        t3 = branding ?? {};
        $[0] = branding;
        $[1] = t3;
    } else t3 = $[1];
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = t3;
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $litlC.useHubTheming)();
    const isV2 = !!theming?.isAdvancedThemingEnabled;
    const palette = isV2 ? theming.palette : undefined;
    const primaryColor = isV2 ? theming.primaryColor : undefined;
    const v2BrandMap = isV2 ? theming.brandBackgroundColorMap : undefined;
    let t4;
    if ($[2] !== backgroundColor || $[3] !== isV2 || $[4] !== palette || $[5] !== primaryColor) {
        t4 = isV2 && palette && primaryColor ? (0, $fcbj5.resolveAdfColorForPicker)(backgroundColor, palette, "primary.200", primaryColor) : backgroundColor;
        $[2] = backgroundColor;
        $[3] = isV2;
        $[4] = palette;
        $[5] = primaryColor;
        $[6] = t4;
    } else t4 = $[6];
    const resolvedBackgroundColor = t4;
    let t5;
    if ($[7] !== isV2 || $[8] !== palette || $[9] !== primaryColor || $[10] !== textColor) {
        t5 = isV2 && palette && primaryColor ? (0, $fcbj5.resolveAdfColorForPicker)(textColor, palette, "primary.1000", (0, $fQWPs.isReadable)("#FFFFFF", primaryColor) ? "#FFFFFF" : "#000000") : textColor;
        $[7] = isV2;
        $[8] = palette;
        $[9] = primaryColor;
        $[10] = textColor;
        $[11] = t5;
    } else t5 = $[11];
    const resolvedTextColor = t5;
    let t6;
    if ($[12] !== resolvedTextColor) {
        t6 = (color)=>(0, $fQWPs.isReadable)(color, resolvedTextColor);
        $[12] = resolvedTextColor;
        $[13] = t6;
    } else t6 = $[13];
    const isReadableBackgroundColor = t6;
    let t7;
    if ($[14] !== resolvedBackgroundColor) {
        t7 = (color_0)=>(0, $fQWPs.isReadable)(color_0, resolvedBackgroundColor);
        $[14] = resolvedBackgroundColor;
        $[15] = t7;
    } else t7 = $[15];
    const isReadableTextColor = t7;
    let t8;
    if ($[16] !== cardId || $[17] !== isV2 || $[18] !== palette || $[19] !== updateFrameFormField) {
        t8 = (bgColor)=>{
            const next = isV2 && palette ? (0, $bWZ7X.toAdfColor)(bgColor, palette) : bgColor;
            updateFrameFormField(cardId, {
                [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: next
            });
        };
        $[16] = cardId;
        $[17] = isV2;
        $[18] = palette;
        $[19] = updateFrameFormField;
        $[20] = t8;
    } else t8 = $[20];
    const updateBackgroundColor = t8;
    let t9;
    if ($[21] !== cardId || $[22] !== isV2 || $[23] !== palette || $[24] !== updateFrameFormField) {
        t9 = (color_1)=>{
            const next_0 = isV2 && palette ? (0, $bWZ7X.toAdfColor)(color_1, palette) : color_1;
            updateFrameFormField(cardId, {
                [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: next_0
            });
        };
        $[21] = cardId;
        $[22] = isV2;
        $[23] = palette;
        $[24] = updateFrameFormField;
        $[25] = t9;
    } else t9 = $[25];
    const updateTextColor = t9;
    const canShowImagePicker = layout !== (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND;
    (0, $7Ux0V.useAutoTransitioningColors)(resolvedBackgroundColor, isReadableTextColor, resolvedTextColor, updateTextColor, branding?.defaultParameters);
    let t10;
    if ($[26] !== contentId || $[27] !== frameParameters || $[28] !== showLayout || $[29] !== updateFrameFormField) {
        t10 = showLayout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a2bf2f277dad4905$export$23adc972c5b7cdfa), {
            frameParameters: frameParameters,
            updateFrameFormField: updateFrameFormField,
            contentId: contentId
        });
        $[26] = contentId;
        $[27] = frameParameters;
        $[28] = showLayout;
        $[29] = updateFrameFormField;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== frameParameters || $[32] !== isDisabled || $[33] !== updateFrameFormField) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5912d0e11f9fe29f$export$48fc9d47b1ec72d4), {
            frameParameters: frameParameters,
            isDisabled: isDisabled,
            updateFrameFormField: updateFrameFormField
        });
        $[31] = frameParameters;
        $[32] = isDisabled;
        $[33] = updateFrameFormField;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== canShowImagePicker || $[36] !== cardId || $[37] !== confluencePageId || $[38] !== contentId || $[39] !== enableLinkInputInMediaPicker || $[40] !== imageAltText || $[41] !== imageSrc || $[42] !== initialUnsplashResults || $[43] !== showMediaPicker || $[44] !== updateFrameFormField) {
        t12 = canShowImagePicker && (showMediaPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7XNwX.ImageField), {
            shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
            analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
            itemId: cardId,
            contentId: contentId,
            imageSrc: imageSrc,
            imageAltText: imageAltText,
            updateItemFormField: updateFrameFormField
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7lwhH.UnsplashSearchField), {
            analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
            idPrefix: "frame",
            itemId: cardId,
            contentId: contentId,
            confluencePageId: confluencePageId,
            imageSrc: imageSrc,
            imageAltText: imageAltText,
            initialUnsplashResults: initialUnsplashResults,
            isNoImageAllowed: false,
            updateItemFormField: updateFrameFormField
        }));
        $[35] = canShowImagePicker;
        $[36] = cardId;
        $[37] = confluencePageId;
        $[38] = contentId;
        $[39] = enableLinkInputInMediaPicker;
        $[40] = imageAltText;
        $[41] = imageSrc;
        $[42] = initialUnsplashResults;
        $[43] = showMediaPicker;
        $[44] = updateFrameFormField;
        $[45] = t12;
    } else t12 = $[45];
    let t13;
    if ($[46] !== backgroundColorMap || $[47] !== brandBackgroundColorMap || $[48] !== emptyColorMap || $[49] !== formatMessage || $[50] !== hideDefaultColorPalette || $[51] !== isCompanyHub || $[52] !== isReadableBackgroundColor || $[53] !== isReadableTextColor || $[54] !== resolvedBackgroundColor || $[55] !== resolvedTextColor || $[56] !== showBgAndTextColorOptions || $[57] !== textColorMap || $[58] !== updateBackgroundColor || $[59] !== updateTextColor || $[60] !== v2BrandMap) {
        t13 = showBgAndTextColorOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            xcss: $7398f533eccdc537$var$styles.bgAndTextColorOptionsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $cd253c0731ac2770$export$defe85febe8b728c).backgroundColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5n7dr.ColorPicker), {
            builtInColorMap: v2BrandMap ? v2BrandMap : hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
            isReadableColor: isReadableBackgroundColor,
            onChange: updateBackgroundColor,
            value: resolvedBackgroundColor,
            pickerTitle: (0, $cd253c0731ac2770$export$defe85febe8b728c).backgroundColor,
            validationSuccessMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationSuccessMessage),
            validationFailMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationFailMessage),
            showCustomPalette: isCompanyHub,
            analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $cd253c0731ac2770$export$defe85febe8b728c).textColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5n7dr.ColorPicker), {
            builtInColorMap: v2BrandMap ? v2BrandMap : hideDefaultColorPalette ? emptyColorMap : textColorMap,
            isReadableColor: isReadableTextColor,
            onChange: updateTextColor,
            value: resolvedTextColor,
            pickerTitle: (0, $cd253c0731ac2770$export$defe85febe8b728c).textColor,
            validationSuccessMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationSuccessMessage),
            validationFailMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationFailMessage),
            showCustomPalette: isCompanyHub,
            analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
            showTextIcon: true
        })));
        $[46] = backgroundColorMap;
        $[47] = brandBackgroundColorMap;
        $[48] = emptyColorMap;
        $[49] = formatMessage;
        $[50] = hideDefaultColorPalette;
        $[51] = isCompanyHub;
        $[52] = isReadableBackgroundColor;
        $[53] = isReadableTextColor;
        $[54] = resolvedBackgroundColor;
        $[55] = resolvedTextColor;
        $[56] = showBgAndTextColorOptions;
        $[57] = textColorMap;
        $[58] = updateBackgroundColor;
        $[59] = updateTextColor;
        $[60] = v2BrandMap;
        $[61] = t13;
    } else t13 = $[61];
    let t14;
    if ($[62] !== t10 || $[63] !== t11 || $[64] !== t12 || $[65] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $7398f533eccdc537$var$styles.wrapper
        }, t10, t11, t12, t13);
        $[62] = t10;
        $[63] = t11;
        $[64] = t12;
        $[65] = t13;
        $[66] = t14;
    } else t14 = $[66];
    return t14;
} : ({ contentId: contentId, frameParameters: frameParameters, initialUnsplashResults: initialUnsplashResults, isDisabled: isDisabled, showBgAndTextColorOptions: showBgAndTextColorOptions, updateFrameFormField: updateFrameFormField, showMediaPicker: showMediaPicker, showLayout: showLayout })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { cardId: cardId, imageSrc: imageSrc, imageAltText: imageAltText, confluencePageId: confluencePageId, backgroundColor: backgroundColor = (0, $eIwIu.frameNewParametersV2).backgroundColor, textColor: textColor = (0, $eIwIu.frameNewParametersV2).textColor, layout: layout } = frameParameters;
    const { isCompanyHub: isCompanyHub, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker, isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $litlC.useHubTheming)();
    const isV2 = !!theming?.isAdvancedThemingEnabled;
    const palette = isV2 ? theming.palette : undefined;
    const primaryColor = isV2 ? theming.primaryColor : undefined;
    const v2BrandMap = isV2 ? theming.brandBackgroundColorMap : undefined; // Resolve to literal hex so isReadable in useAutoTransitioningColors works
    // against the actual colour values, not against CSS var refs (which would
    // silently fail).
    const resolvedBackgroundColor = isV2 && palette && primaryColor ? (0, $fcbj5.resolveAdfColorForPicker)(backgroundColor, palette, 'primary.200', primaryColor) : backgroundColor;
    const resolvedTextColor = isV2 && palette && primaryColor ? (0, $fcbj5.resolveAdfColorForPicker)(textColor, palette, 'primary.1000', (0, $fQWPs.isReadable)('#FFFFFF', primaryColor) ? '#FFFFFF' : '#000000') : textColor;
    const isReadableBackgroundColor = (color)=>(0, $fQWPs.isReadable)(color, resolvedTextColor);
    const isReadableTextColor = (color_0)=>(0, $fQWPs.isReadable)(color_0, resolvedBackgroundColor);
    const updateBackgroundColor = (bgColor)=>{
        const next = isV2 && palette ? (0, $bWZ7X.toAdfColor)(bgColor, palette) : bgColor;
        updateFrameFormField(cardId, {
            [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: next
        });
    };
    const updateTextColor = (color_1)=>{
        const next_0 = isV2 && palette ? (0, $bWZ7X.toAdfColor)(color_1, palette) : color_1;
        updateFrameFormField(cardId, {
            [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: next_0
        });
    };
    const canShowImagePicker = layout !== (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND;
    (0, $7Ux0V.useAutoTransitioningColors)(resolvedBackgroundColor, isReadableTextColor, resolvedTextColor, updateTextColor, branding?.defaultParameters);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $7398f533eccdc537$var$styles.wrapper
    }, showLayout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a2bf2f277dad4905$export$23adc972c5b7cdfa), {
        frameParameters: frameParameters,
        updateFrameFormField: updateFrameFormField,
        contentId: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5912d0e11f9fe29f$export$48fc9d47b1ec72d4), {
        frameParameters: frameParameters,
        isDisabled: isDisabled,
        updateFrameFormField: updateFrameFormField
    }), canShowImagePicker && (showMediaPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7XNwX.ImageField), {
        shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
        analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
        itemId: cardId,
        contentId: contentId,
        imageSrc: imageSrc,
        imageAltText: imageAltText,
        updateItemFormField: updateFrameFormField
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7lwhH.UnsplashSearchField), {
        analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
        idPrefix: "frame",
        itemId: cardId,
        contentId: contentId,
        confluencePageId: confluencePageId,
        imageSrc: imageSrc,
        imageAltText: imageAltText,
        initialUnsplashResults: initialUnsplashResults,
        isNoImageAllowed: false,
        updateItemFormField: updateFrameFormField
    })), showBgAndTextColorOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200",
        xcss: $7398f533eccdc537$var$styles.bgAndTextColorOptionsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $cd253c0731ac2770$export$defe85febe8b728c).backgroundColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5n7dr.ColorPicker), {
        builtInColorMap: v2BrandMap ? v2BrandMap : hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
        isReadableColor: isReadableBackgroundColor,
        onChange: updateBackgroundColor,
        value: resolvedBackgroundColor,
        pickerTitle: (0, $cd253c0731ac2770$export$defe85febe8b728c).backgroundColor,
        validationSuccessMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationSuccessMessage),
        validationFailMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationFailMessage),
        showCustomPalette: isCompanyHub,
        analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $cd253c0731ac2770$export$defe85febe8b728c).textColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5n7dr.ColorPicker), {
        builtInColorMap: v2BrandMap ? v2BrandMap : hideDefaultColorPalette ? emptyColorMap : textColorMap,
        isReadableColor: isReadableTextColor,
        onChange: updateTextColor,
        value: resolvedTextColor,
        pickerTitle: (0, $cd253c0731ac2770$export$defe85febe8b728c).textColor,
        validationSuccessMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationSuccessMessage),
        validationFailMessage: formatMessage((0, $cd253c0731ac2770$export$defe85febe8b728c).colorValidationFailMessage),
        showCustomPalette: isCompanyHub,
        analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
        showTextIcon: true
    }))));
};


const $bdecac3535434a54$var$actionSubjectIdPostFix = 'Frame';
const $bdecac3535434a54$export$3067bcb36d887961 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let framesAreaContainerProps;
    if ($[0] !== t0) {
        ({ ...framesAreaContainerProps } = t0);
        $[0] = t0;
        $[1] = framesAreaContainerProps;
    } else framesAreaContainerProps = $[1];
    const { items: items, contentId: contentId, showBgAndTextColorOptions: showBgAndTextColorOptions, showMediaPicker: showMediaPicker, showLayout: showLayout, updateFrameFormField: updateFrameFormField } = framesAreaContainerProps;
    const initialUnsplashResults = (0, $izxBd.useInitialUnsplashResults)(items);
    let t1;
    if ($[2] !== contentId || $[3] !== initialUnsplashResults || $[4] !== showBgAndTextColorOptions || $[5] !== showLayout || $[6] !== showMediaPicker || $[7] !== updateFrameFormField) {
        t1 = (frameParameters, isFrameDisabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7398f533eccdc537$export$a2a14dc5e9bae153), {
                contentId: contentId,
                frameParameters: frameParameters,
                initialUnsplashResults: initialUnsplashResults,
                isDisabled: isFrameDisabled,
                showBgAndTextColorOptions: showBgAndTextColorOptions,
                showMediaPicker: showMediaPicker,
                showLayout: showLayout,
                updateFrameFormField: updateFrameFormField
            });
        $[2] = contentId;
        $[3] = initialUnsplashResults;
        $[4] = showBgAndTextColorOptions;
        $[5] = showLayout;
        $[6] = showMediaPicker;
        $[7] = updateFrameFormField;
        $[8] = t1;
    } else t1 = $[8];
    const renderFrameContent = t1;
    let t2;
    if ($[9] !== framesAreaContainerProps || $[10] !== renderFrameContent) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2oKNO.ItemsListBuilder), {
            analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
            actionSubjectIdPostFix: $bdecac3535434a54$var$actionSubjectIdPostFix,
            renderItemContent: renderFrameContent,
            itemLabel: (0, $dCemt.ITEM_LABEL).FRAME,
            ...framesAreaContainerProps
        });
        $[9] = framesAreaContainerProps;
        $[10] = renderFrameContent;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
} : ({ ...framesAreaContainerProps })=>{
    const { items: items, contentId: contentId, showBgAndTextColorOptions: showBgAndTextColorOptions, showMediaPicker: showMediaPicker, showLayout: showLayout, updateFrameFormField: updateFrameFormField } = framesAreaContainerProps;
    const initialUnsplashResults = (0, $izxBd.useInitialUnsplashResults)(items);
    const renderFrameContent = (frameParameters, isFrameDisabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7398f533eccdc537$export$a2a14dc5e9bae153), {
            contentId: contentId,
            frameParameters: frameParameters,
            initialUnsplashResults: initialUnsplashResults,
            isDisabled: isFrameDisabled,
            showBgAndTextColorOptions: showBgAndTextColorOptions,
            showMediaPicker: showMediaPicker,
            showLayout: showLayout,
            updateFrameFormField: updateFrameFormField
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2oKNO.ItemsListBuilder), {
        analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
        actionSubjectIdPostFix: $bdecac3535434a54$var$actionSubjectIdPostFix,
        renderItemContent: renderFrameContent,
        itemLabel: (0, $dCemt.ITEM_LABEL).FRAME,
        ...framesAreaContainerProps
    });
};





const $d7698af16187cbb4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "company-hub.carousel-extension.config-panel.title",
        defaultMessage: "Carousel"
    },
    framesInvalidMessage: {
        id: "company-hub.carousel-extension.config-panel.field.frames.error.invalid-list",
        defaultMessage: "Add frames"
    },
    preambleV2: {
        id: "company-hub.carousel-extension.config-panel.preamble-v2",
        defaultMessage: "Design a set of up to {number} rotating frames. {supportLink}"
    },
    preambleV2WithoutSupportLink: {
        id: "company-hub.carousel-extension.config-panel.preamble-v2-without-support-link",
        defaultMessage: "Design a set of up to {number} rotating frames."
    },
    preambleSupportLinkLabelV2: {
        id: "company-hub.carousel-extension.config-panel.preamble-link.label-v2",
        defaultMessage: "Learn more about carousels"
    },
    stylesTabLabel: {
        id: "company-hub.carousel-extension.config-panel.tab.styles.label",
        defaultMessage: "Styles"
    },
    contentTabLabel: {
        id: "company-hub.carousel-extension.config-panel.tab.content.label",
        defaultMessage: "Content"
    },
    styleSectionGeneralTitle: {
        id: "company-hub.carousel-extension.config-panel.style.general.title",
        defaultMessage: "General"
    },
    styleSectionNavigationTitle: {
        id: "company-hub.carousel-extension.config-panel.style.navigation.title",
        defaultMessage: "Navigation"
    },
    addFrameText: {
        id: "company-hub.carousel-extension.config-panel.add-frame-cta",
        defaultMessage: "Add frame"
    }
});


















var $aPCur = parcelRequire("aPCur");




















var $eXmBZ = parcelRequire("eXmBZ");


var $3gadb = parcelRequire("3gadb");


var $k1IsV = parcelRequire("k1IsV");







const $ece5b81ab8418f6b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    autoplayLabel: {
        id: "company-hub.carousel-extension.config-panel.styles.autoplay-label",
        defaultMessage: "Autoplay"
    },
    autoplayTooltipContent: {
        id: "company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content",
        defaultMessage: "Set your carousel to scroll automatically every {number} seconds in view mode"
    }
});


const $75988e0875c55d97$export$20a10abef505ee19 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isAutoplayEnabled || $[2] !== updateMainFormField) {
        t1 = ()=>{
            updateMainFormField({
                isAutoplayEnabled: !isAutoplayEnabled
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "toggle",
                    actionSubjectId: "autoplayToggle",
                    source: (0, $5Ac5G.carouselConfigAnalyticSource)
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isAutoplayEnabled;
        $[2] = updateMainFormField;
        $[3] = t1;
    } else t1 = $[3];
    const handleChange = t1;
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $ece5b81ab8418f6b$export$defe85febe8b728c).autoplayLabel);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== formatMessage) {
        t3 = formatMessage((0, $ece5b81ab8418f6b$export$defe85febe8b728c).autoplayTooltipContent, {
            number: (0, $5Ac5G.AUTOPLAY_SECONDS)
        });
        $[6] = formatMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            testId: "autoplay-information-icon",
            label: "autoplay-information",
            color: "var(--ds-icon-discovery, #AF59E1)"
        });
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t3,
            position: "bottom"
        }, t4);
        $[9] = t3;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== handleChange || $[12] !== isAutoplayEnabled || $[13] !== t2 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k1IsV.ToggleField), {
            label: t2,
            Icon: t5,
            isChecked: isAutoplayEnabled,
            onChange: handleChange
        });
        $[11] = handleChange;
        $[12] = isAutoplayEnabled;
        $[13] = t2;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            isAutoplayEnabled: !isAutoplayEnabled
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'toggle',
                actionSubjectId: 'autoplayToggle',
                source: (0, $5Ac5G.carouselConfigAnalyticSource)
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAutoplayEnabled,
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k1IsV.ToggleField), {
        label: formatMessage((0, $ece5b81ab8418f6b$export$defe85febe8b728c).autoplayLabel),
        Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $ece5b81ab8418f6b$export$defe85febe8b728c).autoplayTooltipContent, {
                number: (0, $5Ac5G.AUTOPLAY_SECONDS)
            }),
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            testId: "autoplay-information-icon",
            label: "autoplay-information",
            color: "var(--ds-icon-discovery, #AF59E1)"
        })),
        isChecked: isAutoplayEnabled,
        onChange: handleChange
    });
};


const $25953e55e006277d$export$82b81ff3fcd805f0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { isCompanyHub: isCompanyHub, isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField, cornerStyle: cornerStyle, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== source || $[2] !== updateMainFormField) {
        t1 = (newCornerStyle)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "cornerStyling",
                    source: source,
                    attributes: {
                        cornerStyle: newCornerStyle
                    }
                }
            }).fire();
            updateMainFormField({
                cornerStyle: newCornerStyle
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = updateMainFormField;
        $[3] = t1;
    } else t1 = $[3];
    const handleCornerStyleChange = t1;
    let t2;
    if ($[4] !== isAutoplayEnabled || $[5] !== updateMainFormField) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75988e0875c55d97$export$20a10abef505ee19), {
            isAutoplayEnabled: isAutoplayEnabled,
            updateMainFormField: updateMainFormField
        });
        $[4] = isAutoplayEnabled;
        $[5] = updateMainFormField;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== cornerStyle || $[8] !== handleCornerStyleChange || $[9] !== isCompanyHub) {
        t3 = isCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aPCur.CornerStyleConfig), {
            cornerStyleValue: cornerStyle || (0, $eIwIu.carouselNewParametersV2).cornerStyle,
            updateCornerStyle: handleCornerStyleChange,
            roundCornerValue: (0, $4cOi8.CornerStyle).ROUNDED,
            squareCornerValue: (0, $4cOi8.CornerStyle).SQUARED
        });
        $[7] = cornerStyle;
        $[8] = handleCornerStyleChange;
        $[9] = isCompanyHub;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t2 || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, t3);
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ isCompanyHub: isCompanyHub, isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField, cornerStyle: cornerStyle, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleCornerStyleChange = (newCornerStyle)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'cornerStyling',
                source: source,
                attributes: {
                    cornerStyle: newCornerStyle
                }
            }
        }).fire();
        updateMainFormField({
            cornerStyle: newCornerStyle
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75988e0875c55d97$export$20a10abef505ee19), {
        isAutoplayEnabled: isAutoplayEnabled,
        updateMainFormField: updateMainFormField
    }), isCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aPCur.CornerStyleConfig), {
        cornerStyleValue: cornerStyle || (0, $eIwIu.carouselNewParametersV2).cornerStyle,
        updateCornerStyle: handleCornerStyleChange,
        roundCornerValue: (0, $4cOi8.CornerStyle).ROUNDED,
        squareCornerValue: (0, $4cOi8.CornerStyle).SQUARED
    }));
};





















var $gj7hi = parcelRequire("gj7hi");









var $kZ5GD = parcelRequire("kZ5GD");

var $3e06541cca22ea2e$exports = {};
$3e06541cca22ea2e$exports = new URL("ProgressCirclesNavigation.e2e6ad70.svg", import.meta.url).toString();

var $77c771ba77740abe$exports = {};
$77c771ba77740abe$exports = new URL("ThumbnailNavigation.7523958e.svg", import.meta.url).toString();






var $9Uxg8 = parcelRequire("9Uxg8");




const $37f7f8137c9e7d2e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    progressCirclesNavigationStyleLabel: {
        id: "company-hub.carousel-extension.config-panel.navigation.progress-circles",
        defaultMessage: "Progress circles"
    },
    thumbnailsNavigationStyleLabel: {
        id: "company-hub.carousel-extension.config-panel.navigation.thumbnails",
        defaultMessage: "Thumbnails"
    }
});


const $9d5bf13189ecc7ee$var$styles = {
    border: "_19itia51 _2rko12b0",
    borderSelected: "_1h6d1w55",
    optionContainer: "_bfhksm61 _n3tdu2gc",
    optionImage: "_18zru2gc _1bsb1osq _ca0qutpp _n3td1b66"
};
const $9d5bf13189ecc7ee$var$navigationOptions = [
    {
        navigationOption: (0, $9Uxg8.NavigationStyle).PROGRESS_CIRCLES,
        optionImage: (0, (/*@__PURE__*/$parcel$interopDefault($3e06541cca22ea2e$exports))),
        label: (0, $37f7f8137c9e7d2e$export$defe85febe8b728c).progressCirclesNavigationStyleLabel
    },
    {
        navigationOption: (0, $9Uxg8.NavigationStyle).THUMBNAILS,
        optionImage: (0, (/*@__PURE__*/$parcel$interopDefault($77c771ba77740abe$exports))),
        label: (0, $37f7f8137c9e7d2e$export$defe85febe8b728c).thumbnailsNavigationStyleLabel
    }
];
const $9d5bf13189ecc7ee$export$8be72cf8db455613 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { navigationType: t1, updateMainFormField: updateMainFormField } = t0;
    const navigationType = t1 === undefined ? (0, $9Uxg8.NavigationStyle).PROGRESS_CIRCLES : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== updateMainFormField) {
        t2 = (selectedNavigationOption)=>{
            updateMainFormField({
                navigationStyle: selectedNavigationOption
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationStyle",
                    actionSubjectId: "configPanelNavigationStyle",
                    source: (0, $5Ac5G.carouselConfigAnalyticSource),
                    attributes: {
                        selectedValue: selectedNavigationOption
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = updateMainFormField;
        $[2] = t2;
    } else t2 = $[2];
    const handleNavigationTypeUpdate = t2;
    let t3;
    if ($[3] !== handleNavigationTypeUpdate || $[4] !== navigationType) {
        t3 = $9d5bf13189ecc7ee$var$navigationOptions.map((t4)=>{
            const { navigationOption: navigationOption, optionImage: optionImage, label: label } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($9d5bf13189ecc7ee$var$styles.border, $9d5bf13189ecc7ee$var$styles.optionContainer, navigationType === navigationOption && $9d5bf13189ecc7ee$var$styles.borderSelected),
                key: navigationOption
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($9d5bf13189ecc7ee$var$styles.optionImage)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                src: optionImage,
                alt: "",
                testId: `${navigationOption}--image`
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
                onChange: ()=>handleNavigationTypeUpdate(navigationOption),
                value: navigationOption,
                testId: `${navigationOption}${navigationType === navigationOption ? "--selected" : ""}`,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    size: "small",
                    align: "center",
                    weight: "semibold"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label)),
                isChecked: navigationType === navigationOption
            }));
        });
        $[3] = handleNavigationTypeUpdate;
        $[4] = navigationType;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150"
        }, t3));
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ navigationType: navigationType = (0, $9Uxg8.NavigationStyle).PROGRESS_CIRCLES, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleNavigationTypeUpdate = (selectedNavigationOption)=>{
        updateMainFormField({
            navigationStyle: selectedNavigationOption
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationStyle',
                actionSubjectId: 'configPanelNavigationStyle',
                source: (0, $5Ac5G.carouselConfigAnalyticSource),
                attributes: {
                    selectedValue: selectedNavigationOption
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, $9d5bf13189ecc7ee$var$navigationOptions.map(({ navigationOption: navigationOption, optionImage: optionImage, label: label })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($9d5bf13189ecc7ee$var$styles.border, $9d5bf13189ecc7ee$var$styles.optionContainer, navigationType === navigationOption && $9d5bf13189ecc7ee$var$styles.borderSelected),
            key: navigationOption
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($9d5bf13189ecc7ee$var$styles.optionImage)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: optionImage,
            alt: "",
            testId: `${navigationOption}--image`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZ5GD.default), {
            onChange: ()=>handleNavigationTypeUpdate(navigationOption),
            value: navigationOption,
            testId: `${navigationOption}${navigationType === navigationOption ? '--selected' : ''}`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                align: "center",
                weight: "semibold"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label)),
            isChecked: navigationType === navigationOption
        }));
    })));
};


const $1d219d304190b3f7$var$SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/add-a-trio-of-dynamic-frames-to-your-page-with-carousel/';
const $1d219d304190b3f7$var$TRIGGER_BUTTON_KEYS = [
    'Enter',
    'Spacebar',
    ' '
];
var $1d219d304190b3f7$var$TabValues = /*#__PURE__*/ function(TabValues) {
    TabValues["STYLES"] = "styles";
    TabValues["CONTENT"] = "content";
    return TabValues;
}($1d219d304190b3f7$var$TabValues || {});
const $1d219d304190b3f7$var$styles = {
    carouselListBuilderFooterWrapper: "_zulpu2gc _1rjc1ejb _1e0c1txw _2lx21bp4",
    stickyFooter: "_18zr1b66 _195gr5cr _kqsw1if8 _94n5ze3t _bfhkvuon",
    disabledContentWrapper: "_80om13gf",
    supportLinkWrapper: "_otyrx0bf"
};
const $1d219d304190b3f7$export$97c0055a2666fa5d = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(73);
    const { contentId: contentId, closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = {
            localId: localId,
            editorActions: editorActions
        };
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const { carouselActions: carouselActions, carouselParameters: carouselParameters } = (0, $eIwIu.useCarouselExtensionParametersAndActions)(t1);
    const framesListRef = (0, $42omo.useRef)(null);
    let t2;
    if ($[3] !== carouselParameters) {
        t2 = carouselParameters || {};
        $[3] = carouselParameters;
        $[4] = t2;
    } else t2 = $[4];
    const { cards: frames, isAutoplayEnabled: isAutoplayEnabled, cornerStyle: cornerStyle, navigationStyle: navigationStyle } = t2;
    const { addFrame: addFrame, removeFrame: removeFrame, updateFrameFormField: updateFrameFormField, updateMainFormField: updateMainFormField } = carouselActions;
    const { isCompanyHub: isCompanyHub, showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $fOKpq.useProductDependencies)();
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    const hasReachedFrameLimit = frames?.length >= (0, $5Ac5G.FRAMES_LIMIT_V2);
    const [tabSelected, setTabSelected] = (0, $42omo.useState)("styles");
    const { setIsInViewMode: setIsInViewMode } = (0, $g3LxX.useExtensionsActions)();
    let t3;
    let t4;
    if ($[5] !== setIsInViewMode) {
        t3 = ()=>{
            setIsInViewMode(false);
        };
        t4 = [
            setIsInViewMode
        ];
        $[5] = setIsInViewMode;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (event)=>{
            if ($1d219d304190b3f7$var$TRIGGER_BUTTON_KEYS.includes(event.key)) setTimeout(()=>{
                (framesListRef?.current?.lastChild).focus();
            }, 100);
        };
        $[8] = t5;
    } else t5 = $[8];
    const handleAddFrameKeyPress = t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (tab)=>{
            setTabSelected(tab.value);
        };
        $[9] = t6;
    } else t6 = $[9];
    const handleTabClick = t6;
    let t7;
    if ($[10] !== addFrame || $[11] !== frames?.length || $[12] !== hasReachedFrameLimit || $[13] !== isDisabled || $[14] !== tabSelected) {
        t7 = ()=>{
            const isContentTabSelected = tabSelected === "content";
            if (isDisabled) return null;
            const showAddFramesButton = !hasReachedFrameLimit && isContentTabSelected;
            const showFramesErrorMessage = !frames?.length && isContentTabSelected;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $1d219d304190b3f7$var$styles.stickyFooter
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $1d219d304190b3f7$var$styles.carouselListBuilderFooterWrapper
            }, showAddFramesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAbO5.AddItemButton), {
                addItem: addFrame,
                label: (0, $d7698af16187cbb4$export$defe85febe8b728c).addFrameText,
                onAddItemKeyPress: handleAddFrameKeyPress,
                analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
                actionSubjectIdSuffix: "Carousel"
            }), showFramesErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jD7cj.FormFieldErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d7698af16187cbb4$export$defe85febe8b728c).framesInvalidMessage)), !isContentTabSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6r7Ix.ConfigPanelFeedbackCollector), {
                source: (0, $5Ac5G.carouselContentAnalyticSource),
                type: (0, $4cOi8.FeedbackType).CAROUSEL
            })));
        };
        $[10] = addFrame;
        $[11] = frames?.length;
        $[12] = hasReachedFrameLimit;
        $[13] = isDisabled;
        $[14] = tabSelected;
        $[15] = t7;
    } else t7 = $[15];
    const renderConfigPanelFooter = t7;
    if (!carouselParameters) {
        let t8;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1m9A2.NoExtensionData), {
                source: (0, $5Ac5G.carouselExtensionKey),
                isConfigPanel: true
            });
            $[16] = t8;
        } else t8 = $[16];
        return t8;
    }
    let t8;
    if ($[17] !== updateMainFormField) {
        t8 = (frames_0)=>updateMainFormField({
                cards: frames_0
            });
        $[17] = updateMainFormField;
        $[18] = t8;
    } else t8 = $[18];
    const updateFrames = t8;
    let t9;
    if ($[19] !== formatMessage) {
        t9 = formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).stylesTabLabel);
        $[19] = formatMessage;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== formatMessage) {
        t10 = formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).styleSectionGeneralTitle);
        $[21] = formatMessage;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== cornerStyle || $[24] !== isAutoplayEnabled || $[25] !== isCompanyHub || $[26] !== updateMainFormField) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25953e55e006277d$export$82b81ff3fcd805f0), {
            isCompanyHub: isCompanyHub,
            isAutoplayEnabled: isAutoplayEnabled,
            cornerStyle: cornerStyle,
            updateMainFormField: updateMainFormField,
            source: (0, $5Ac5G.carouselConfigAnalyticSource)
        });
        $[23] = cornerStyle;
        $[24] = isAutoplayEnabled;
        $[25] = isCompanyHub;
        $[26] = updateMainFormField;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== t10 || $[29] !== t11) {
        t12 = {
            sectionId: "general",
            title: t10,
            defaultIsExpanded: true,
            component: t11
        };
        $[28] = t10;
        $[29] = t11;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== formatMessage) {
        t13 = formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).styleSectionNavigationTitle);
        $[31] = formatMessage;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== navigationStyle || $[34] !== updateMainFormField) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9d5bf13189ecc7ee$export$8be72cf8db455613), {
            updateMainFormField: updateMainFormField,
            navigationType: navigationStyle
        });
        $[33] = navigationStyle;
        $[34] = updateMainFormField;
        $[35] = t14;
    } else t14 = $[35];
    let t15;
    if ($[36] !== t13 || $[37] !== t14) {
        t15 = {
            sectionId: "navigation",
            title: t13,
            defaultIsExpanded: false,
            component: t14
        };
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
    } else t15 = $[38];
    let t16;
    if ($[39] !== t12 || $[40] !== t15) {
        t16 = [
            t12,
            t15
        ];
        $[39] = t12;
        $[40] = t15;
        $[41] = t16;
    } else t16 = $[41];
    let t17;
    if ($[42] !== t16 || $[43] !== t9) {
        t17 = {
            label: t9,
            value: "styles",
            tabContent: t16
        };
        $[42] = t16;
        $[43] = t9;
        $[44] = t17;
    } else t17 = $[44];
    let t18;
    if ($[45] !== formatMessage) {
        t18 = formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).contentTabLabel);
        $[45] = formatMessage;
        $[46] = t18;
    } else t18 = $[46];
    const t19 = isDisabled && $1d219d304190b3f7$var$styles.disabledContentWrapper;
    let t20;
    if ($[47] !== contentId || $[48] !== frames || $[49] !== removeFrame || $[50] !== updateFrameFormField || $[51] !== updateFrames) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bdecac3535434a54$export$3067bcb36d887961), {
            items: frames,
            itemsListRef: framesListRef,
            contentId: contentId,
            removeItem: removeFrame,
            updateFrameFormField: updateFrameFormField,
            updateItems: updateFrames,
            showBgAndTextColorOptions: true,
            showMediaPicker: true,
            showLayout: true,
            shouldUseCardV2UI: true
        });
        $[47] = contentId;
        $[48] = frames;
        $[49] = removeFrame;
        $[50] = updateFrameFormField;
        $[51] = updateFrames;
        $[52] = t20;
    } else t20 = $[52];
    let t21;
    if ($[53] !== t19 || $[54] !== t20) {
        t21 = [
            {
                sectionId: "frames",
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                    direction: "column",
                    gap: "space.300",
                    xcss: t19
                }, t20)
            }
        ];
        $[53] = t19;
        $[54] = t20;
        $[55] = t21;
    } else t21 = $[55];
    let t22;
    if ($[56] !== t18 || $[57] !== t21) {
        t22 = {
            label: t18,
            value: "content",
            tabContent: t21
        };
        $[56] = t18;
        $[57] = t21;
        $[58] = t22;
    } else t22 = $[58];
    let t23;
    if ($[59] !== t17 || $[60] !== t22) {
        t23 = [
            t17,
            t22
        ];
        $[59] = t17;
        $[60] = t22;
        $[61] = t23;
    } else t23 = $[61];
    const tabSections = t23;
    let t24;
    if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d7698af16187cbb4$export$defe85febe8b728c).title);
        $[62] = t24;
    } else t24 = $[62];
    const t25 = showConfigPreambleSupportLink ? (0, $d7698af16187cbb4$export$defe85febe8b728c).preambleV2 : (0, $d7698af16187cbb4$export$defe85febe8b728c).preambleV2WithoutSupportLink;
    let t26;
    if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = {
            number: (0, $5Ac5G.FRAMES_LIMIT_V2),
            supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                target: "_blank",
                href: $1d219d304190b3f7$var$SUPPORT_LINK
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d7698af16187cbb4$export$defe85febe8b728c).preambleSupportLinkLabelV2))
        };
        $[63] = t26;
    } else t26 = $[63];
    let t27;
    if ($[64] !== t25) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $1d219d304190b3f7$var$styles.supportLinkWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...t25,
            values: t26
        }));
        $[64] = t25;
        $[65] = t27;
    } else t27 = $[65];
    let t28;
    if ($[66] !== tabSections) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3VS69.PremiumGateForExtensionConfigPanel), {
            feature: "premiumCarouselConfig"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjUk0.ConfigPanelGrouping), {
            source: (0, $5Ac5G.carouselConfigAnalyticSource),
            tabSections: tabSections,
            onTabClick: handleTabClick
        }));
        $[66] = tabSections;
        $[67] = t28;
    } else t28 = $[67];
    let t29;
    if ($[68] !== closeConfigPanel || $[69] !== renderConfigPanelFooter || $[70] !== t27 || $[71] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UUyu.ExtensionsConfigWrapper), {
            title: t24,
            footerComponent: renderConfigPanelFooter,
            closeConfigPanel: closeConfigPanel
        }, t27, t28);
        $[68] = closeConfigPanel;
        $[69] = renderConfigPanelFooter;
        $[70] = t27;
        $[71] = t28;
        $[72] = t29;
    } else t29 = $[72];
    return t29;
} : ({ contentId: contentId, closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { carouselActions: carouselActions, carouselParameters: carouselParameters } = (0, $eIwIu.useCarouselExtensionParametersAndActions)({
        localId: localId,
        editorActions: editorActions
    });
    const framesListRef = (0, $42omo.useRef)(null);
    const { cards: frames, isAutoplayEnabled: isAutoplayEnabled, cornerStyle: cornerStyle, navigationStyle: navigationStyle } = carouselParameters || {};
    const { addFrame: addFrame, removeFrame: removeFrame, updateFrameFormField: updateFrameFormField, updateMainFormField: updateMainFormField } = carouselActions;
    const { isCompanyHub: isCompanyHub, showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $fOKpq.useProductDependencies)();
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    const CURRENT_FRAMES_LIMIT = (0, $5Ac5G.FRAMES_LIMIT_V2);
    const hasReachedFrameLimit = frames?.length >= CURRENT_FRAMES_LIMIT;
    const [tabSelected, setTabSelected] = (0, $42omo.useState)("styles");
    const { setIsInViewMode: setIsInViewMode } = (0, $g3LxX.useExtensionsActions)();
    (0, $42omo.useEffect)(()=>{
        setIsInViewMode(false);
    }, [
        setIsInViewMode
    ]);
    const handleAddFrameKeyPress = (event)=>{
        if ($1d219d304190b3f7$var$TRIGGER_BUTTON_KEYS.includes(event.key)) setTimeout(()=>{
            (framesListRef?.current?.lastChild).focus();
        }, 100);
    };
    const handleTabClick = (0, $42omo.useCallback)((tab)=>{
        setTabSelected(tab.value);
    }, []);
    const renderConfigPanelFooter = (0, $42omo.useCallback)(()=>{
        const isContentTabSelected = tabSelected === "content"; // when Carousel is disabled (ie. premium gated), don't show the footer
        if (isDisabled) return null;
        const showAddFramesButton = !hasReachedFrameLimit && isContentTabSelected;
        const showFramesErrorMessage = !frames?.length && isContentTabSelected;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $1d219d304190b3f7$var$styles.stickyFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $1d219d304190b3f7$var$styles.carouselListBuilderFooterWrapper
        }, showAddFramesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAbO5.AddItemButton), {
            addItem: addFrame,
            label: (0, $d7698af16187cbb4$export$defe85febe8b728c).addFrameText,
            onAddItemKeyPress: handleAddFrameKeyPress,
            analyticsSource: (0, $5Ac5G.carouselConfigAnalyticSource),
            actionSubjectIdSuffix: "Carousel"
        }), showFramesErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jD7cj.FormFieldErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d7698af16187cbb4$export$defe85febe8b728c).framesInvalidMessage)), !isContentTabSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6r7Ix.ConfigPanelFeedbackCollector), {
            source: (0, $5Ac5G.carouselContentAnalyticSource),
            type: (0, $4cOi8.FeedbackType).CAROUSEL
        })));
    }, [
        frames,
        addFrame,
        isDisabled,
        hasReachedFrameLimit,
        tabSelected
    ]);
    if (!carouselParameters) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1m9A2.NoExtensionData), {
        source: (0, $5Ac5G.carouselExtensionKey),
        isConfigPanel: true
    });
    const updateFrames = (frames_0)=>updateMainFormField({
            cards: frames_0
        });
    const tabSections = [
        {
            label: formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).stylesTabLabel),
            value: "styles",
            tabContent: [
                {
                    sectionId: 'general',
                    title: formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).styleSectionGeneralTitle),
                    defaultIsExpanded: true,
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25953e55e006277d$export$82b81ff3fcd805f0), {
                        isCompanyHub: isCompanyHub,
                        isAutoplayEnabled: isAutoplayEnabled,
                        cornerStyle: cornerStyle,
                        updateMainFormField: updateMainFormField,
                        source: (0, $5Ac5G.carouselConfigAnalyticSource)
                    })
                },
                {
                    sectionId: 'navigation',
                    title: formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).styleSectionNavigationTitle),
                    defaultIsExpanded: false,
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9d5bf13189ecc7ee$export$8be72cf8db455613), {
                        updateMainFormField: updateMainFormField,
                        navigationType: navigationStyle
                    })
                }
            ]
        },
        {
            label: formatMessage((0, $d7698af16187cbb4$export$defe85febe8b728c).contentTabLabel),
            value: "content",
            tabContent: [
                {
                    sectionId: 'frames',
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                        direction: "column",
                        gap: "space.300",
                        xcss: isDisabled && $1d219d304190b3f7$var$styles.disabledContentWrapper
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bdecac3535434a54$export$3067bcb36d887961), {
                        items: frames,
                        itemsListRef: framesListRef,
                        contentId: contentId,
                        removeItem: removeFrame,
                        updateFrameFormField: updateFrameFormField,
                        updateItems: updateFrames,
                        showBgAndTextColorOptions: true,
                        showMediaPicker: true,
                        showLayout: true,
                        shouldUseCardV2UI: true
                    }))
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UUyu.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d7698af16187cbb4$export$defe85febe8b728c).title),
        footerComponent: renderConfigPanelFooter,
        closeConfigPanel: closeConfigPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $1d219d304190b3f7$var$styles.supportLinkWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...showConfigPreambleSupportLink ? (0, $d7698af16187cbb4$export$defe85febe8b728c).preambleV2 : (0, $d7698af16187cbb4$export$defe85febe8b728c).preambleV2WithoutSupportLink,
        values: {
            number: CURRENT_FRAMES_LIMIT,
            supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                target: "_blank",
                href: $1d219d304190b3f7$var$SUPPORT_LINK
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d7698af16187cbb4$export$defe85febe8b728c).preambleSupportLinkLabelV2))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3VS69.PremiumGateForExtensionConfigPanel), {
        feature: "premiumCarouselConfig"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjUk0.ConfigPanelGrouping), {
        source: (0, $5Ac5G.carouselConfigAnalyticSource),
        tabSections: tabSections,
        onTabClick: handleTabClick
    })));
};
module.exports["CarouselConfigPanelContent"] = $1d219d304190b3f7$export$97c0055a2666fa5d;

});

parcelRegister("be2Qa", function(module, exports) {
const $6c81ed750728c4c0$var$itemDataKey = Symbol('item');
function $6c81ed750728c4c0$export$dc0c4ec5c1198760({ item: item, index: index }) {
    return {
        [$6c81ed750728c4c0$var$itemDataKey]: true,
        item: item,
        index: index
    };
}
function $6c81ed750728c4c0$export$2a210a87dce1e5bc(data) {
    return data[$6c81ed750728c4c0$var$itemDataKey] === true;
}
module.exports["getItemData"] = $6c81ed750728c4c0$export$dc0c4ec5c1198760;
module.exports["isItemData"] = $6c81ed750728c4c0$export$2a210a87dce1e5bc;

});

parcelRegister("h92Kw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $fOKpq = parcelRequire("fOKpq");


var $cQI39 = parcelRequire("cQI39");


var $8Rlmd = parcelRequire("8Rlmd");

const $6b23c8c5038277b4$export$f8da0ec9f5f5f971 = ({ contentId: contentId, handleUploadedImageSelection: handleUploadedImageSelection, analyticsSource: analyticsSource })=>{
    const { createEditorMediaProvider: createEditorMediaProvider, mediaUploadExperienceTracker: mediaUploadExperienceTracker, transformUploadedImageId: transformUploadedImageId } = (0, $fOKpq.useProductDependencies)();
    const [uploadedImageId, setUploadedImageId] = (0, $42omo.useState)(null);
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isUploadingImage, setIsUploadingImage] = (0, $42omo.useState)(false);
    const [isMediaBrowserOpen, setIsMediaBrowserOpen] = (0, $42omo.useState)(false);
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!!uploadedImageId) handleUploadedImageSelection({
            uploadedImageId: uploadedImageId,
            altDescription: ''
        });
    // We only want this logic to run when uploadedImageId changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        uploadedImageId
    ]);
    const openMediaBrowser = ()=>{
        setIsMediaBrowserOpen(true);
    };
    const closeMediaBrowser = ()=>{
        setIsMediaBrowserOpen(false);
    };
    const handleUploadStart = ()=>{
        setIsUploadingImage(true);
        mediaUploadExperienceTracker?.start({
            analyticsSource: analyticsSource
        });
    };
    const showErrorFlag = (0, $42omo.useCallback)(()=>{
        showFlag({
            title: formatMessage((0, $cQI39.messages).errorFlagTitle),
            description: formatMessage((0, $cQI39.messages).errorFlagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        });
        setIsUploadingImage(false);
    }, [
        formatMessage,
        showFlag
    ]);
    const handleOnError = (payload)=>{
        setIsUploadingImage(false);
        showErrorFlag();
        mediaUploadExperienceTracker?.stopOnError({
            error: payload?.error?.rawError ?? new Error('Error with cards image upload')
        });
    };
    const handleUploadEnd = (event)=>{
        setIsUploadingImage(false);
        const fileType = event?.file?.type;
        const id = event?.file?.id;
        if (!fileType.includes('image')) {
            showErrorFlag();
            mediaUploadExperienceTracker?.stopOnError({
                error: new Error('File type is not image')
            });
        } else if (id) {
            const imageId = transformUploadedImageId ? transformUploadedImageId({
                contentId: contentId,
                fileId: id
            }) : id;
            setUploadedImageId(imageId);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'image',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'customerUpload'
                    }
                }
            }).fire();
            mediaUploadExperienceTracker?.succeed();
        } else {
            showErrorFlag();
            mediaUploadExperienceTracker?.stopOnError({
                error: new Error('File does not have a type or id')
            });
        }
    };
    (0, $42omo.useEffect)(()=>{
        const showAttachmentLimitReachedFlag = (rejectionData)=>{
            if (rejectionData) {
                showFlag((0, $8Rlmd.getAttachmentSizeLimitErrorFlag)(rejectionData, intl));
                setIsUploadingImage(false);
                mediaUploadExperienceTracker?.succeed();
            }
            return !!rejectionData;
        };
        const createMediaConfig = async ()=>{
            try {
                const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = await createEditorMediaProvider?.({
                    contentId: contentId,
                    contentType: 'page',
                    isExternalShare: false,
                    onUploadRejection: showAttachmentLimitReachedFlag
                }) || {};
                if (uploadMediaClientConfig === undefined) return null;
                setMediaConfig({
                    collection: uploadParams?.collection,
                    authProvider: uploadMediaClientConfig.authProvider,
                    onUploadRejection: uploadParams?.onUploadRejection
                });
            } catch (error) {
                mediaUploadExperienceTracker?.stopOnError({
                    error: new Error(`Error with image media provider: ${error}`)
                });
            }
        };
        createMediaConfig();
    }, [
        contentId,
        showErrorFlag,
        showFlag,
        intl,
        mediaUploadExperienceTracker,
        createEditorMediaProvider
    ]);
    return {
        mediaConfig: mediaConfig,
        handleUploadEnd: handleUploadEnd,
        handleUploadStart: handleUploadStart,
        handleOnError: handleOnError,
        isMediaBrowserOpen: isMediaBrowserOpen,
        openMediaBrowser: openMediaBrowser,
        closeMediaBrowser: closeMediaBrowser,
        isUploadingImage: isUploadingImage
    };
};
module.exports["useUploadMediaConfig"] = $6b23c8c5038277b4$export$f8da0ec9f5f5f971;

});

parcelRegister("cQI39", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b215c39e0a4e002f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorFlagTitle: {
        id: "company-hub.company-hub-common.link.cards.image.upload.error.flag.title",
        defaultMessage: "We can\u2019t upload your image"
    },
    errorFlagDescription: {
        id: "company-hub.company-hub-common.link.cards.image.upload.error.flag.description",
        defaultMessage: "Refresh the page and try again."
    }
});
module.exports["messages"] = $b215c39e0a4e002f$export$defe85febe8b728c;

});

parcelRegister("8Rlmd", function(module, exports) {

var $7ikOB = parcelRequire("7ikOB");

// Constants
const $91ffb08f53002109$var$SIZE_LIMIT_LEARN_MORE_LINK = 'https://support.atlassian.com/confluence-cloud/docs/upload-a-file/';
const $91ffb08f53002109$var$BYTES_PER_UNIT = 1024;
const $91ffb08f53002109$var$DECIMAL_PLACES = 2;
const $91ffb08f53002109$var$SIZE_UNITS = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB'
];
/**
 * Calculates the appropriate unit index for a given byte size
 */ const $91ffb08f53002109$var$calculateUnitIndex = (bytes, maxMagnitude)=>{
    const calculatedIndex = Math.floor(Math.log(bytes) / Math.log($91ffb08f53002109$var$BYTES_PER_UNIT));
    // Only apply maxMagnitude limit if it's truthy and less than the calculated index
    if (maxMagnitude && maxMagnitude < $91ffb08f53002109$var$SIZE_UNITS.length - 1) return Math.min(calculatedIndex, maxMagnitude);
    return calculatedIndex;
};
/**
 * Formats bytes into a human-readable string with appropriate units
 */ const $91ffb08f53002109$var$formatBytesToString = (bytes, unitIndex)=>{
    const convertedSize = bytes / $91ffb08f53002109$var$BYTES_PER_UNIT ** unitIndex;
    const formattedSize = parseFloat(convertedSize.toFixed($91ffb08f53002109$var$DECIMAL_PLACES));
    return `${formattedSize} ${$91ffb08f53002109$var$SIZE_UNITS[unitIndex]}`;
};
const $91ffb08f53002109$export$f2d538a5633fea72 = (bytes, maxMagnitude)=>{
    if (bytes <= 0) return '0 bytes';
    // Validate maxMagnitude parameter (0 means no limit, so it's valid)
    if (maxMagnitude !== undefined && (maxMagnitude < 0 || maxMagnitude >= $91ffb08f53002109$var$SIZE_UNITS.length)) throw new Error(`maxMagnitude must be between 0 and ${$91ffb08f53002109$var$SIZE_UNITS.length - 1}`);
    const unitIndex = $91ffb08f53002109$var$calculateUnitIndex(bytes, maxMagnitude);
    return $91ffb08f53002109$var$formatBytesToString(bytes, unitIndex);
};
/**
 * Creates a flag configuration for file size limit exceeded error
 */ const $91ffb08f53002109$var$createFileSizeLimitExceededFlag = (fileName, limit, intl)=>({
        title: intl.formatMessage((0, $7ikOB.messages).errorTitle, {
            fileName: fileName
        }),
        description: intl.formatMessage((0, $7ikOB.messages).errorDescription, {
            size: $91ffb08f53002109$export$f2d538a5633fea72(limit)
        }),
        actions: [
            {
                content: intl.formatMessage((0, $7ikOB.messages).learnMore),
                onClick: ()=>{
                    window.open($91ffb08f53002109$var$SIZE_LIMIT_LEARN_MORE_LINK, '_blank');
                }
            }
        ]
    });
/**
 * Creates a flag configuration for empty file error
 */ const $91ffb08f53002109$var$createEmptyFileErrorFlag = (data, intl)=>({
        title: intl.formatMessage((0, $7ikOB.messages).zeroByteErrorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage((0, $7ikOB.messages).zeroByteErrorDescription)
    });
const $91ffb08f53002109$export$1c61cf0ed486df46 = (data, intl)=>{
    switch(data.reason){
        case 'fileSizeLimitExceeded':
            return $91ffb08f53002109$var$createFileSizeLimitExceededFlag(data.fileName, data.limit, intl);
        default:
            return $91ffb08f53002109$var$createEmptyFileErrorFlag(data, intl);
    }
};
module.exports["getAttachmentSizeLimitErrorFlag"] = $91ffb08f53002109$export$1c61cf0ed486df46;

});

parcelRegister("7ikOB", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $0278d68a01bcc940$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "company-hub-common.attachment-size-limit-error.title",
        defaultMessage: "{fileName} is too large to upload"
    },
    errorDescription: {
        id: "company-hub-common.attachment-size-limit-error.description",
        defaultMessage: "Attachments must be {size} or less."
    },
    learnMore: {
        id: "company-hub-common.attachment-size-limit-error.learn-more",
        defaultMessage: "Learn more"
    },
    zeroByteErrorTitle: {
        id: "company-hub-common.attachment-zero-byte-error.title",
        defaultMessage: "{fileName} is empty (zero bytes)"
    },
    zeroByteErrorDescription: {
        id: "company-hub-common.attachment-zero-byte.description",
        defaultMessage: "Attachments must be at least 1 byte of size"
    }
});
module.exports["messages"] = $0278d68a01bcc940$export$defe85febe8b728c;

});


//# sourceMappingURL=cards-extension.4b105215.js.map
